'use strict';

(function () {

	angular.module('app', ['app.core', 'app.config']);
})();
'use strict';

angular.module('app.core', ['ngSanitize', 'ngCookies',
// 3rd Party modules
'ui.router', 'chart.js', 'ui.bootstrap', 'ui.grid', 'ui.grid.pagination', 'ui.grid.resizeColumns', 'ui.grid.autoResize']);
"use strict";

angular.module("app.config", []).constant("enableSend", true);
'use strict';

angular.module('app').config(["$provide", "$httpProvider", "$sceDelegateProvider", function ($provide, $httpProvider, $sceDelegateProvider) {
	// define global Highcharts config here

	// allow HTML for all toastrs, if desired
	// angular.extend(toastrConfig, {
	// 	allowHtml: true,
	// });

	// add http interceptor to handle 401s
	// $httpProvider.interceptors.push('Interceptor');

	$sceDelegateProvider.resourceUrlWhitelist([
	// Allow same origin resource loads.
	'self']
	// Allow loading from our assets domain. **.
	);
}]);
'use strict';

(function () {
	// used to create toastr popup that stays until user clicks
	// const permanentToastr = {
	// 	timeOut: 0,
	// 	extendedTimeOut: 0,
	// 	closeButton: true,
	// };

	// returns number like -4 for EST, or 2 for timezone in east europe
	// used for aggregation stats by day/week
	// const utcOffset = -(new Date().getTimezoneOffset() / 60);


	angular.module('app.core').constant('introSurveyUrl', 'https://uclahs.az1.qualtrics.com/jfe/form/SV_8bO5LVjgBdlAMGF').constant('mainSurveyUrl', 'https://uclahs.az1.qualtrics.com/jfe/form/SV_0Mw55IrSnYVurQ1');
})();
'use strict';

angular.module('app.core').config(["$locationProvider", "$stateProvider", "$urlRouterProvider", function ($locationProvider, $stateProvider, $urlRouterProvider) {
	// $locationProvider.html5Mode(true);
	$locationProvider.html5Mode({
		enabled: true
		// requireBase: false
	});

	$urlRouterProvider.otherwise('/');

	var latlng = '&lat&lng';
	var location = '&countrycode&zipcode&state&city';

	$stateProvider
	// main homepage (either blank or /home)
	.state('home', {
		url: '/?lang' + latlng + location,
		template: '<home></home>'
	})
	// entrypoint used by embedded surveys
	.state('faq', {
		url: '/faq?lang',
		template: '<faq></faq>'
	}).state('daily', {
		url: '/daily?orgname&orgurl&orgid&orglogo?lang',
		template: '<daily></daily>'
	}).state('hospital', {
		url: '/hospital',
		template: '<hospital></hospital>'
	}).state('testing', {
		url: '/testing',
		template: '<barcode></barcode>'
	}).state('student', {
		url: '/student?orgname&orgurl&orgid&orglogo?lang',
		template: '<student></student>'
	}).state('faqStudent', {
		url: '/faq-student',
		template: '<faq-student></faq-student>'
	}).state('staff', {
		url: '/staff',
		template: '<staff-login></staff-login>'
	});
}]);

function get($http, url) {
	return function (query) {
		return $http({
			method: 'GET',
			'url': url,
			params: query,
			headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
		});
	};
}

function post($http, url) {
	return function (params) {
		return $http({
			method: 'POST',
			'url': url,
			data: $.param(params),
			headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
		});
	};
}

function put($http, url) {
	return function (objid, props) {
		return $http({
			method: 'PUT',
			url: url,
			data: $.param({
				objid: objid,
				props: props
			}),
			headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
		});
	};
}

function dayhours(raw) {
	var date = new Date(raw);
	return date.getMonth() + 1 + '/' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes();
}
"use strict";

// angular.module('app')
// .run(($location) => {
// 	// console.log($location);

// });
// angular.module('app')
// .run(($rootScope, $window) => {

// 	$rootScope.$on('$stateChangeSuccess', function () {
// 		$window.scrollTo(0,0);
// 	});
// });
/*
});
// 	const authInfo = LocalAuth.getAuth();

// 	if (!authInfo || !authInfo.token) return $state.go('login');
// 	LocalAuth.initAuthToken(authInfo.token);

// 	// scroll to top of page for each ui-router change
// 	$rootScope.$on('$stateChangeSuccess', () => {
// 		$document[0].body.scrollTop = $document[0].documentElement.scrollTop = 0;
// 	});



// })
// .config(($provide) => {
// 	  $provide.decorator('$uiViewScroll', ($delegate) => {
//     return (uiViewElement) => {
//       var top = uiViewElement.getBoundingClientRect().top;
//       window.scrollTo(0, (top - 5));
//     };
//   });
// });
*/

var mapStyles = [{
	"elementType": "geometry",
	"stylers": [{
		"color": "#212121"
	}]
}, {
	"elementType": "labels.icon",
	"stylers": [{
		"visibility": "off"
	}]
}, {
	"elementType": "labels.text.fill",
	"stylers": [{
		"color": "#757575"
	}]
}, {
	"elementType": "labels.text.stroke",
	"stylers": [{
		"color": "#212121"
	}]
}, {
	"featureType": "administrative",
	"elementType": "geometry",
	"stylers": [{
		"color": "#757575"
	}, {
		"visibility": "off"
	}]
}, {
	"featureType": "administrative.country",
	"elementType": "labels.text.fill",
	"stylers": [{
		"color": "#9e9e9e"
	}]
}, {
	"featureType": "administrative.land_parcel",
	"stylers": [{
		"visibility": "off"
	}]
}, {
	"featureType": "administrative.locality",
	"elementType": "labels.text.fill",
	"stylers": [{
		"color": "#bdbdbd"
	}]
}, {
	"featureType": "administrative.neighborhood",
	"stylers": [{
		"visibility": "off"
	}]
}, {
	"featureType": "poi",
	"stylers": [{
		"visibility": "off"
	}]
}, {
	"featureType": "poi",
	"elementType": "labels.text",
	"stylers": [{
		"visibility": "off"
	}]
}, {
	"featureType": "poi",
	"elementType": "labels.text.fill",
	"stylers": [{
		"color": "#757575"
	}]
}, {
	"featureType": "poi.park",
	"elementType": "geometry",
	"stylers": [{
		"color": "#181818"
	}]
}, {
	"featureType": "poi.park",
	"elementType": "labels.text.fill",
	"stylers": [{
		"color": "#616161"
	}]
}, {
	"featureType": "poi.park",
	"elementType": "labels.text.stroke",
	"stylers": [{
		"color": "#1b1b1b"
	}]
}, {
	"featureType": "road",
	"elementType": "geometry.fill",
	"stylers": [{
		"color": "#2c2c2c"
	}]
}, {
	"featureType": "road",
	"elementType": "labels",
	"stylers": [{
		"visibility": "off"
	}]
}, {
	"featureType": "road",
	"elementType": "labels.icon",
	"stylers": [{
		"visibility": "off"
	}]
}, {
	"featureType": "road",
	"elementType": "labels.text.fill",
	"stylers": [{
		"color": "#8a8a8a"
	}]
}, {
	"featureType": "road.arterial",
	"elementType": "geometry",
	"stylers": [{
		"color": "#373737"
	}]
}, {
	"featureType": "road.arterial",
	"elementType": "labels",
	"stylers": [{
		"visibility": "off"
	}]
}, {
	"featureType": "road.highway",
	"elementType": "geometry",
	"stylers": [{
		"color": "#3c3c3c"
	}]
}, {
	"featureType": "road.highway",
	"elementType": "labels",
	"stylers": [{
		"visibility": "off"
	}]
}, {
	"featureType": "road.highway.controlled_access",
	"elementType": "geometry",
	"stylers": [{
		"color": "#4e4e4e"
	}]
}, {
	"featureType": "road.local",
	"stylers": [{
		"visibility": "off"
	}]
}, {
	"featureType": "road.local",
	"elementType": "labels.text.fill",
	"stylers": [{
		"color": "#616161"
	}]
}, {
	"featureType": "transit",
	"stylers": [{
		"visibility": "off"
	}]
}, {
	"featureType": "transit",
	"elementType": "labels.text.fill",
	"stylers": [{
		"color": "#757575"
	}]
}, {
	"featureType": "water",
	"elementType": "geometry",
	"stylers": [{
		"color": "#000000"
	}]
}, {
	"featureType": "water",
	"elementType": "labels.text",
	"stylers": [{
		"visibility": "off"
	}]
}, {
	"featureType": "water",
	"elementType": "labels.text.fill",
	"stylers": [{
		"color": "#3d3d3d"
	}]
}];
'use strict';

var langs = {
	'en': 0,
	'es': 1
};

var langmap = {
	home: {
		intro: ['As the COVID-19 continues to spread around the world,\n\t\t\t\tmany people are feeling anxious and isolated.\n\t\t\t\tOne of the most pressing challenges is the lack of information.\n\t\t\t\tBut even in these uncertain times, there is an opportunity for us to\n\t\t\t\tjoin forces to STOP COVID19 TOGETHER. This project is a part of #TeamLA,\n\t\t\t\tand it aims to collect information that will help us understand how the\n\t\t\t\tcoronavirus pandemic has affected our communities. Every individual\n\t\t\t\tcan and should contribute, and by doing so will be joining our\n\t\t\t\tteam effort to collect necessary data to stop the pandemic.', 'COVID-19 sigue propagandose alrededor del globo, mucha gente se siente aislada y con\n\t\t\t\taltos niveles de ansiedad. Uno de los mayores retos a los que nos enfrentamos es\n\t\t\t\tla falta de informaci\xF3n. Sin embargo, incluso en estos momentos de confusi\xF3n,\n\t\t\t\ttenemos la oportunidad de unir nuestras fuerzas con STOP COVID19 TOGETHER y\n\t\t\t\t#TeamLA, en la recogida de informaci\xF3n para entender c\xF3mo la pandemia del\n\t\t\t\tcoronavirus est\xE1 afectando en nuestras comunidades.\n\t\t\t\tCada individuo est\xE1 llamado a contribuir a este esfuerzo conjunto,\n\t\t\t\ty puede hacerlo llenando este cuestionario con la informaci\xF3n necesaria\n\t\t\t\tpara detener la pandemia.'],
		disc: {
			one: ['Please note, we cannot provide medical advice on this platform.\n\t\t\t\t\tPlease follow the guidance of your local public health authorities and/or your health provider.\n\t\t\t\t\tFor more information about this study, please visit our', 'Preste atenci\xF3n, en esta plataforma web no podemos dar ning\xFAn consejo m\xE9dico.\n\t\t\t\t\tPor favor siga las indicaciones por parte de sus autoridades locales de salud p\xFAblica o su m\xE9dico.\n\t\t\t\t\tPara m\xE1s informaci\xF3n sobre este estudio, por favor visite nuestra p\xE1gina de'],
			two: ['For more information about UCLA Health\'s efforts on the coronavirus pandemic,\n\t\t\t\t\tvisit the', 'Para m\xE1s informaci\xF3n sobre las iniciativas sobre\n\t\t\t\t\tla pandemia del coronavirus de UCLA Health, visite'],
			faq: ['FAQ', 'Preguntas Frecuentes']
		},
		survey: {
			about: {
				first: ['Together we can stop the spread of the coronavirus.', 'Juntos podemos parar la propagación del coronavirus.'],
				second: ['Please fill out a 5 minute survey about exposure and symptoms.', 'Por favor llene este cuestionario de 5 minutos'],
				third: ['', 'sobre los síntomas y exposición.']
			},
			ask: ['How are you feeling today?', 'Cómo se siente hoy?'],
			button: {
				good: ['I feel great!', 'Me siento bien!'],
				bad: ['I feel sick.', 'Me siento mal.']
			},
			footer: ['Help us gather information about exposure, symptoms, and other clues\n\t\t\t\t\tfor finding effective ways to reduce spread and impact of the virus.', 'Ay\xFAdanos a reunir datos sobre exposici\xF3n, s\xEDntomas y otros indicios\n\t\t\t\t\tpara encontrar maneras efectivas de reducir el impacto del virus.']
		},
		team: {
			title: ['STOP COVID-19 TOGETHER Team', 'Equipo de STOP COVID-19 TOGETHER'],
			detail: ['STOP COVID-19 TOGETHER is developed by an interdisciplinary team at\n\t\t\t\t\tthe University of California, Los Angeles,\n\t\t\t\t\tled by the Department of Computational Medicine\n\t\t\t\t\t(affiliated with the School of Engineering and the School of Medicine).\n\t\t\t\t\tThe team includes many data scientists, clinicians, epidemiologists and engineers\n\t\t\t\t\tand involves many parts of the UCLA Campus and UCLA Health System including\n\t\t\t\t\tthe UCLA Department of Computational Medicine, the UCLA Fielding School of Public Health,\n\t\t\t\t\tand UCLA Health Information Technology.\n\t\t\t\t\tThe study is being funded by the University of California, Los Angeles (UCLA).', 'STOP COVID-19 TOGETHER est\xE1 desarrollado por un equipo interdisciplinario de la Universidad de California, Los \xC1ngeles,\n\t\t\t\t\tdirigido por el Departamento de Computational Medicine\n\t\t\t\t\t(afiliado a las Escuelas de Ingenier\xEDa y de Medicina).\n\t\t\t\t\tEl equipo est\xE1 compuesto por cient\xEDficos de datos, m\xE9dicos, epidemi\xF3logos e ingenieros e integra muchas partes\n\t\t\t\t\tdel Campus de UCLA y UCLA Health System, incluido el Departamento de Computational Medicine,\n\t\t\t\t\tla Escuela de Public Health UCLA Fielding y UCLA Health Information Technology.\n\t\t\t\t\tEste estudio est\xE1 financiado por la Universidad de California, Los Angeles (UCLA).']
		}
	},
	map: {
		title: ['Visualization of Survey Results', 'Visualización de Resultados del Cuestionario'],
		about: ['This map shows where people are responding to the survey who have reported\n\t\t\t\tsymptoms and exposures.\n        Please click or tap on a highlighted area to view\n        available information and adjust the scope using the buttons below.', 'Visualizaci\xF3n de Resultados del Cuestionario. Este mapa muestra las respuestas de la poblaci\xF3n que ha participado al cuestionario, informaci\xF3n sobre s\xEDntomas y exposici\xF3n. Si en su zona no mostramos suficientes datos, comparta este cuestionario con su comunidad para que podamos mostrarlo en el mapa..'],
		popup: {
			noinfo: ['Information not available', 'Información no disponible'],
			public: {
				symptomatic: ['symptomatic', 'sintomático'],
				count: ['count', 'contar'],
				title: ['Publicly reported', 'Datos Públicos'],
				p_case: ['Total Cases', 'Casos Confirmados'],
				p_death: ['Deaths', 'Muertes'],
				predictions: ['Projection', 'Predicciones']
			},
			survey: {
				title: ['Percentage of STOPCOVID Survey respondents who', 'Porcentaje de respuestas del cuestionario STOPCOVID'],
				s_sympt: ['Show at least 1 symptom of COVID-19', 'Muestran al menos un síntoma de COVID-19'],
				s_test: ['Have been tested for COVID-19', 'Han realizado la prueba de COVID-19'],
				s_dist: ['Are physically distancing', 'Están manteniendo el distanciamiento social'],
				deaths: ['Deaths', 'Muertes'],
				notenough: ['Not enough survey respondents in area.', 'No hay suficientes respuestas en su area.']
			}
		}
	},
	plot: {
		title: ['Hospital Resource Usage Surveilence', 'Vigilancia del uso de recursos en Hospitales'],
		about: ['Hospitals in California are closely monitoring their capacity to treat patients\n\t\t\tthat fall severely ill from Covid-19 and require intensive care.\n\t\t\tWe use self-reported numbers from counties across California such as ICU beds\n\t\t\tto project likely resource demand for hospitals in the near future.', 'Los Hospitales de California observan detenidamente sus capacidades para tratar los pacientes enfermos graves de Covid-19 y que necesitan cuidados intensivos.\n\t\t\tUtilizamos autoinformes estad\xEDsticos de condados en toda California, como el n\xFAmero de camas en la UCI para estimar la posible demanda de recursos en los hospitales en un futuro cercano.']
	},
	faq: {
		title: ['Frequently Asked Questions - General', 'Preguntas Frecuentes - General'],
		title2: ['STOP COVID Research Study - Frequently Asked Questions', 'STOP COVID Research Study - Frequently Asked Questions'],
		title3: ['STOP COVID Daily Symptom Screener - Frequently Asked Questions', 'STOP COVID Daily Symptom Screener - Frequently Asked Questions'],
		title4: ['STOP COVID Child Daily Symptom Screener - Frequently Asked Questions', 'STOP COVID Child Daily Symptom Screener - Frequently Asked Questions'],
		whatiscovid: {
			q: ['What is COVID-19?', '\xBFQu\xE9 es COVID-19?'],
			a: ['COVID-19 is a novel coronavirus that has not been previously seen in humans,\n\t\t\t\t\tand unlike the viruses that cause the common cold. COVID-19 is spread person-to-person,\n\t\t\t\t\tand seems to be spreading easily. It can cause a severe and fatal lung infection,\n\t\t\t\t\tbut others may carry the virus and not notice any symptoms.\n\t\t\t\t\tCurrently, there are people in the community who are unintentionally spreading\n\t\t\t\t\tthe disease (i.e., \u201Ccommunity spread\u201D) which makes it difficult to contain\n\t\t\t\t\tthe current outbreak. As a result, governments within the USA and around\n\t\t\t\t\tthe world have taken unprecedented measures in order to mitigate the spread\n\t\t\t\t\tof the disease.', 'COVID-19 es una enfermedad causada por un nuevo coronavirus, que no ha sido visto en humanos anteriormente y no se parece al virus de la gripe com\xFAn. COVID-19 se contagia f\xE1cilmente de persona a persona. En algunas personas puede causar infecci\xF3n pulmonar severa y puede llegar  a ser fatal. Sin embargo, en otras personas el virus se puede propagar sin producir s\xEDntomas. Esto facilita la propagaci\xF3n del virus en la comunidad y dificulta la contenci\xF3n del brote actual. Por esto, que gobiernos en EE.UU. y alrededor del mundo han tomado medidas sin precedentes orientadas a mitigar el contagio de la enfermedad.']
		},
		whatisstopcovid: {
			q: ['What is STOP COVID-19 TOGETHER?', '\xBFQu\xE9 es STOP COVID-19 TOGETHER?'],
			a: {
				one: ['STOP COVID-19 TOGETHER has three components.', 'STOP COVID-19 TOGETHER has three components.'],
				two: ['One component is a research study conducted by survey, designed to assess the spread of COVID-19 throughout the community, and also to assess the effectiveness of current measures. If you decide to participate in the research study, you will be asked about your recent experience with COVID-19 symptoms and mitigation measures.  In this Frequently Asked Questions document, this component is referred to as the \u201CSTOP COVID Research Study.\u201D', 'One component is a research study conducted by survey, designed to assess the spread of COVID-19 throughout the community, and also to assess the effectiveness of current measures. If you decide to participate in the research study, you will be asked about your recent experience with COVID-19 symptoms and mitigation measures.  In this Frequently Asked Questions document, this component is referred to as the \u201CSTOP COVID Research Study.\u201D'],
				three: ['The second component is a daily symptom screener which asks about your symptoms and then provides public health information based on your symptoms.  When you complete the symptom screening, if you are symptom free, you receive a symptom free certificate that shows that you completed the symptom screener and reported no symptoms.  In this Frequently Asked Questions document, this component is referred to as the \u201CSTOP COVID Daily Symptom Screener.\u201D', 'The second component is a daily symptom screener which asks about your symptoms and then provides public health information based on your symptoms.  When you complete the symptom screening, if you are symptom free, you receive a symptom free certificate that shows that you completed the symptom screener and reported no symptoms.  In this Frequently Asked Questions document, this component is referred to as the \u201CSTOP COVID Daily Symptom Screener.\u201D'],
				four: ['The third component is a daily symptom screener designed for children in schools where a parent will provide information about the child\u2019s symptoms. The screener provides public health information based on the symptoms.  When the child\u2019s parent or guardian completes the symptom screening on behalf of the child, if the child indicates they are symptom free, a symptom free certificate will be provided that shows that a parent or guardian completed the symptom screener and reported no symptoms for the child.  In this Frequently Asked Questions document, this component is referred to as the \u201CSTOP COVID Child Daily Symptom Screener.\u201D', 'The third component is a daily symptom screener designed for children in schools where a parent will provide information about the child\u2019s symptoms. The screener provides public health information based on the symptoms.  When the child\u2019s parent or guardian completes the symptom screening on behalf of the child, if the child indicates they are symptom free, a symptom free certificate will be provided that shows that a parent or guardian completed the symptom screener and reported no symptoms for the child.  In this Frequently Asked Questions document, this component is referred to as the \u201CSTOP COVID Child Daily Symptom Screener.\u201D']
			}
		},
		contact: {
			// FIXME: there is an href inside here
			q: ['If I have a question that is not answered in this FAQ, what do I do?', 'Si tengo una pregunta que no se responda en este Preguntas Frecuentes, ¿qué puedo hacer?'],
			a: ['You can contact the STOP COVID-19 TOGETHER team by clicking', 'Puede contactar al equipo STOP COVID-19 TOGETHER haciendo clic en'],
			b: ['', 'abajo']
		},
		whocanpart: {
			q: ['Who can participate in STOP COVID-19 TOGETHER?', '\xBFQui\xE9n puede participar en STOP COVID-19 TOGETHER?'],
			a: ['We invite anyone over the age of 18 to participate in this study.', 'Invitamos a cualquier persona mayor de 18 a\xF1os a participar en este estudio.']
		},
		askofme: {
			q: ['What does STOP COVID-19 TOGETHER ask of me?', '¿Qué me van a preguntar en STOP COVID-19 TOGETHER?'],
			a: {
				about: ['If you volunteer to participate in this study, we ask of you the following: ', 'Si decide ser voluntario en este estudio le preguntaremos lo siguiente:'],
				one: ['(1) Answer the questionnaire about your health, who you are around, and your living situation.', '(1) Llenar un cuestionario sobre su estado de salud, las personas que lo rodean y su hogar.'],
				two: ['(2) Participate in several short follow up questionnaires, which will ask if your experience with COVID-19 has changed in any way. The follow-up questionnaires will help us understand how it spreads over time and space. You may choose not to have a follow-up questionnaire.', '(2) Participar en varios cuestionarios cortos de seguimiento, que le preguntarán sobre cambios en su experiencia con COVID-19. Estas preguntas nos ayudarán a entender como se transmite en tiempo real y en cuales áreas del condado de Los Ángeles. Usted puede decidir no participar en los cuestionarios de seguimiento.']
			}
		},
		howlong: {
			q: ['How long will it take to fill out the survey?', '¿Cuánto tiempo me va a tomar llenar este cuestionario?'],
			a: ['We estimate it should not take you more than 10 minutes to fill this out.', 'Estimamos que no le tome más de 10 minutos a llenarlo.']
		},
		needanswer: {
			q: ['Do I need to answer all the questions in the survey?', '¿Tengo que responder a todas las preguntas en la encuesta?'],
			a: ['No. You may choose not to answer any questions that you prefer not to answer.', 'No. Puede elegir a no responder a las preguntas que prefiera no contestar.']
		},
		voluntary: {
			q: ['Is completing this survey voluntary?', '¿Completar la encuesta es voluntario?'],
			a: ['Your participation is entirely voluntary. You have been asked to participate in this study because you responded to an online ad to volunteer, you are over the age of 18.', 'Su participación es completamente voluntaria. Se le ha invitado a participar en este estudio porque usted respondió a un anuncio online para ser voluntario, y usted es mayor de 18 años.']
		},
		usage: {
			q: ['How will my data be used?', '¿Cómo van a usar mi información?'],
			a: {
				one: ['The only people who will know you are a research subject are members of the research team. No information about you, or provided by you during the research, will be disclosed to others without your written permission, except if required by law.', 'Las únicas personas que sabrán de su participación en este estudio son los miembros del equipo de investigación. Ninguna información sobre usted, o proporcionada por usted durante la investigación, será revelada a otros sin su autorización escrita, excepto si esta exigido por la ley.'],
				two: ['Personal information obtained by questionnaires will be stored in secure databases within the UCLA network. The data will be stored in a HIPAA compliant environment, which satisfies the same set of requirements used for medical data.', 'La información personal obtenida por medio de los cuestionarios será almacenada en bases de datos seguras dentro de la red de UCLA. Sus datos serán almacenados en un entorno conforme a las reglas HIPAA, satisfaciendo los mismos requerimientos para datos médicos.']
			}
		},
		anon: {
			q: ['Is this survey anonymous?', '¿La encuesta es anónima?'],
			a: ['Yes. We will not collect your name, or any other identifying data points. However, we will ask you for your location, so that we could place your answers on the map and model the spatial spread of the virus, and your age, because the virus seems to behave differently for different age groups. You can choose not to provide your address, or to provide an approximate address (either by providing a zip code or by providing a radius in the map). Also, if you choose to answer the follow-up questionnaire, we will ask you for an email address.', 'Si. No preguntaremos por su nombre, ni informaci\xF3n que lo pueda identificar. No obstante, le preguntaremos por su direcci\xF3n para ubicar sus respuestas en un mapa y modelar la distribuci\xF3n del virus por \xE1reas del condado. Tambi\xE9n le preguntaremos por su edad, porque el virus se comporta de diferente manera seg\xFAn su edad. Usted puede decidir no dar su direcci\xF3n o solo dar una direcci\xF3n aproximada (c\xF3digo postal o punto en el mapa). Adicionalmente, si decide participar en los cuestionarios de seguimiento le pediremos su correo electr\xF3nico.']
		},
		sharedata: {
			q: ['Are you going to share the data?', '¿Van a compartir estos datos?'],
			a: ['We will only share the data with other investigators for the purpose of studying the spread of the coronavirus. Authorized representatives of the UCLA Office of the Human Research Protection Program may also review research records. As a result, they may see your email address and other information you provide; but they are bound by rules of confidentiality not to reveal your identity to others.', 'Solo compartiremos los datos con otros investigadores con el fin de estudiar la propagación del coronavirus. Representantes autorizados de la Oficina de UCLA del Programa de Protección de Investigación Humana (UCLA Office of the Human Research Protection Program) también podrán revisar los datos. Debido a esto, ellos podrán ver su correo electrónico y otra información que usted proporcione; ellos están obligados por las reglas de confidencialidad a no revelar su identidad a otros.']
		},
		behalf: {
			q: ['Who can I complete the questionnaire for?', '¿Puedo llenar este formulario por alguien diferente a mí mismo?'],
			a: ['You may submit the questionnaire on behalf of anyone in your household. Prior to submitting, please confirm that the person\'s data has not already been submitted.', 'Puede llenar este cuestionario en nombre de cualquier persona dentro de su hogar. Antes de enviarlo, por favor confirme que la informaci\xF3n de esa persona no se haya enviado previamente.']
		},
		changemind: {
			q: ['What if I change my mind? Can I withdraw from the study?', '¿Qué pasa si cambio de opinión y no quiera continuar ser parte del estudio?'],
			a: ['You may withdraw your consent at any time and discontinue participation without penalty. You are not waiving any legal claims, rights or remedies because of your participation in this research study. If you wish to ask questions about your rights as a research participant or if you wish to voice any problems or concerns you may have about the study to someone other than the researchers, please call the Office of the Human Research Protection Program at (310) 825-5344 or write to Office of the Human Research Protection Program, UCLA, 11000 Kinross Avenue, Suite 102, Box 951694, Los Angeles, CA 90095-1694.', 'Usted puede decidir retirar su consentimiento en cualquier momento y retirar su participaci\xF3n sin penalizaci\xF3n. Usted no renuncia a ning\xFAn reclamo legal, derecho o recurso debido a su participaci\xF3n en este estudio. Si desea hacer preguntas sobre sus derechos como participante de la investigaci\xF3n o desea expresar cualquier problema o inquietud que pueda tener sobre el estudio a alguien que no sea un investigador, llame a la Oficina del Programa de Protecci\xF3n de la Investigaci\xF3n Humana al (310) 825-5344 o escriba a la Office of the Human Research Protection Program, UCLA, 11000 Kinross Avenue, Suite 102, Box 951694, Los Angeles, CA 90095-1694.']
		},
		refuse: {
			q: ['What happens if I refuse to participate?', '\xBFQu\xE9 pasa si me niego a participar?'],
			a: ['Your participation in this research is entirely VOLUNTARY. If you choose not to participate, that will not affect your relationship with UCLA (or the UCLA Medical Center), or your right to health care or other services to which you are otherwise entitled. If you decide to participate, you are free to withdraw your consent and discontinue participation at any time without penalty nor prejudice to your future care at UCLA. If you wish to terminate your enrollment in the study, you may contact the experimenters at any time, and will have the option to have any previously collected data destroyed.', 'Su participaci\xF3n en esta investigaci\xF3n es completamente VOLUNTARIA. Si elige no participar, eso no afectar\xE1 su relaci\xF3n con UCLA (o el Centro M\xE9dico de UCLA), o su derecho a la atenci\xF3n m\xE9dica u otros servicios a los que tiene derecho. Si decide participar, puede retirar su consentimiento y suspender su participaci\xF3n en cualquier momento sin penalizaci\xF3n ni perjuicio para su futura atenci\xF3n en UCLA. Si desea finalizar su inscripci\xF3n en el estudio, puede comunicarse con los investigadores en cualquier momento y tendr\xE1 la opci\xF3n de que se destruya cualquier dato recopilado previamente.']
		},
		hipaaenv: {
			//FIX ME: Spanish translation
			q: ['Is the data stored in a HIPAA compliant environment?', 'Is the data stored in a HIPAA compliant environment?'],
			a: ['Yes, the application that we are using for the survey is compliant with HIPAA and hosted on the UCLA Health Information Technology HIPAA Compliant systems.  We also are required by our own policies to maintain the confidentiality and security of survey data.', 'Yes, the application that we are using for the survey is compliant with HIPAA and hosted on the UCLA Health Information Technology HIPAA Compliant systems.  We also are required by our own policies to maintain the confidentiality and security of survey data.']
		},
		whatisscreener: {
			q: ['What is the STOP COVID Daily Symptom Screener?', 'What is the STOP COVID Daily Symptom Screener?'],
			a: ['The STOP COVID Daily Symptom Screener is a system that allows for daily symptom screening while preserving privacy.  In the system, we do not collect any identifying information and you will receive a symptom free certificate providing evidence that you completed the symptom screener and reported no symptoms. The certificate contains a code, powered by cryptographic technology, that confirms the hour that the symptom tracking was performed but provides no ability to obtain your identity. ', 'The STOP COVID Daily Symptom Screener is a system that allows for daily symptom screening while preserving privacy.  In the system, we do not collect any identifying information and you will receive a symptom free certificate providing evidence that you completed the symptom screener and reported no symptoms. The certificate contains a code, powered by cryptographic technology, that confirms the hour that the symptom tracking was performed but provides no ability to obtain your identity. ']
		},
		whyscreening: {
			q: ['Why is daily symptom screening important?', 'Why is daily symptom screening important?'],
			a: ['Engaging in daily symptom screening makes our workplaces and other locations where we interact with each other safer and saves lives. These symptom screeners keep us aware of our own health and provide us a daily opportunity to self-identify COVID-19 symptoms which can guide us in taking public health measures including isolating and testing.', 'Engaging in daily symptom screening makes our workplaces and other locations where we interact with each other safer and saves lives. These symptom screeners keep us aware of our own health and provide us a daily opportunity to self-identify COVID-19 symptoms which can guide us in taking public health measures including isolating and testing.']
		},
		screeneruse: {
			q: ['How do I use the STOP COVID Daily Symptom Screener?', 'How do I use the STOP COVID Daily Symptom Screener?'],
			a: ['Each morning, take the STOP COVID Daily Symptom Screener and if you are symptom free, you will receive a symptom free certificate that you can show as proof that you completed symptom screening that morning and reported no symptoms. ', 'Each morning, take the STOP COVID Daily Symptom Screener and if you are symptom free, you will receive a symptom free certificate that you can show as proof that you completed symptom screening that morning and reported no symptoms. ']
		},
		surveycovidstatus: {
			q: ['Will the symptom screener tell me if I have (or do not have) COVID-19?', 'Will the symptom screener tell me if I have (or do not have) COVID-19?'],
			a: ['No. The symptom screener only asks you questions relating to any symptoms that are associated with COVID-19. If you respond that you do have any symptoms that are associated with COVID-19, it only provides you with public health guidance that instructs you to stay home and seek medical attention.', 'No. The symptom screener only asks you questions relating to any symptoms that are associated with COVID-19. If you respond that you do have any symptoms that are associated with COVID-19, it only provides you with public health guidance that instructs you to stay home and seek medical attention.']
		},
		surveyapproval: {
			q: ['Has your symptom screener been approved by the CDC, FDA, or any state or local departments of public health?', 'Has your symptom screener been approved by the CDC, FDA, or any state or local departments of public health?'],
			a: ['No. Our symptom screener has not been reviewed, endorsed, supported or otherwise approved in any way by any public health authority.  The symptom screener questions and responses are based on publicly available public health information.', 'No. Our symptom screener has not been reviewed, endorsed, supported or otherwise approved in any way by any public health authority.  The symptom screener questions and responses are based on publicly available public health information.']
		},
		screeningoptin: {
			q: ['If I participate in the STOP COVID Daily Symptom Screening, am I part of the STOP COVID Research Study?  Can I become part of the STOP COVID Research Study?', 'If I participate in the STOP COVID Daily Symptom Screening, am I part of the STOP COVID Research Study?  Can I become part of the STOP COVID Research Study?'],
			a: ['If you are using the STOP COVID Daily Symptom Screening, you are not part of the STOP COVID Research Study unless you choose to be part of it by answering the corresponding question in the symptom screener.   Participation in the STOP COVID research study is voluntary and you can leave the study at any time. You are not required to participate in the research study to obtain a symptom free certificate.    If you do choose to join the research study, you will receive an email asking you additional questions to better understand the pandemic. If you do voluntarily become part of the STOP COVID Study, your email address will be recorded   (but not any identifying information or symptom information) so you can be contacted to answer these other questions to help identify hotspots and predict COVID-19 outbreaks. ', 'If you are using the STOP COVID Daily Symptom Screening, you are not part of the STOP COVID Research Study unless you choose to be part of it by answering the corresponding question in the symptom screener.   Participation in the STOP COVID research study is voluntary and you can leave the study at any time. You are not required to participate in the research study to obtain a symptom free certificate.    If you do choose to join the research study, you will receive an email asking you additional questions to better understand the pandemic. If you do voluntarily become part of the STOP COVID Study, your email address will be recorded   (but not any identifying information or symptom information) so you can be contacted to answer these other questions to help identify hotspots and predict COVID-19 outbreaks. ']
		},
		howdataused: {
			q: ['How do you use my data?', 'How do you use my data?'],
			a: ['If you respond to the symptom screener by indicating that you are experiencing any symptoms associated with COVID-19, we will use that data for the sole purpose of providing you with public health information.  If you reported no symptoms, we will use the data for the sole purpose of issuing you a symptom free certificate.  None of the data you enter is stored in our system unless you decide to participate in the STOP COVID Research Study in which case your email address will be recorded so you can receive a followup email to join the STOP COVID Research Study.', 'If you respond to the symptom screener by indicating that you are experiencing any symptoms associated with COVID-19, we will use that data for the sole purpose of providing you with public health information.  If you reported no symptoms, we will use the data for the sole purpose of issuing you a symptom free certificate.  None of the data you enter is stored in our system unless you decide to participate in the STOP COVID Research Study in which case your email address will be recorded so you can receive a followup email to join the STOP COVID Research Study.']
		},
		whatiscert: {
			q: ['What is a STOP COVID Symptom Free Certificate?', 'What is a STOP COVID Symptom Free Certificate?'],
			a: ['When you complete the daily symptom screening, you will receive a symptom free certificate providing evidence that you completed the symptom screener and reported no symptoms.  The certificate contains a cryptographic code that records at that time the symptom screener was performed.  This cryptographic technology confirms the hour that the symptom screening was performed but provides no ability to obtain your identity.   The code is both written on the certificate and encoded in a QR code.  The code can be verified to be authentic using a public domain algorithm.  The color of the certificate shows how recent the symptom screener was taken.  Blue signifies within 24 hours, yellow signifies within a week and red is older than one week.  On the certificate is also the time that the symptom screener was taken.   The certificate itself is generated using a system hosted by the STOP COVID website which visualizes the code with the correct color and also includes the time that the certificate was visualized.  The certificate is designed to be displayed on a mobile phone but can also be printed out.', 'When you complete the daily symptom screening, you will receive a symptom free certificate providing evidence that you completed the symptom screener and reported no symptoms.  The certificate contains a cryptographic code that records at that time the symptom screener was performed.  This cryptographic technology confirms the hour that the symptom screening was performed but provides no ability to obtain your identity.   The code is both written on the certificate and encoded in a QR code.  The code can be verified to be authentic using a public domain algorithm.  The color of the certificate shows how recent the symptom screener was taken.  Blue signifies within 24 hours, yellow signifies within a week and red is older than one week.  On the certificate is also the time that the symptom screener was taken.   The certificate itself is generated using a system hosted by the STOP COVID website which visualizes the code with the correct color and also includes the time that the certificate was visualized.  The certificate is designed to be displayed on a mobile phone but can also be printed out.']
		},
		certvalid: {
			q: ['How can I tell if a symptom free certificate is valid \u2013 that is, the person showing me a certificate has obtained it from the symptom screener?', 'How can I tell if a symptom free certificate is valid \u2013 that is, the person showing me a certificate has obtained it from the symptom screener?'],
			a: ['Using a mobile device, the QR code on a certificate can be scanned to verify that it is valid.  In addition, a code can be verified by entering it on the website https://verify.stopcovid19together.org. ', 'Using a mobile device, the QR code on a certificate can be scanned to verify that it is valid.  In addition, a code can be verified by entering it on the website https://verify.stopcovid19together.org. ']
		},
		screenerprivacy: {
			q: ['How does the STOP COVID Daily Symptom Screener preserve my privacy?', 'How does the STOP COVID Daily Symptom Screener preserve my privacy?'],
			a: {
				one: ['The STOP COVID symptom screener does not collect any identifying information about you when you fill out the symptom screener which makes it impossible to associate any of your symptom responses with you.  ', 'The STOP COVID symptom screener does not collect any identifying information about you when you fill out the symptom screener which makes it impossible to associate any of your symptom responses with you.  '],
				two: ['The only exception is if you opt to participate in the research study in which case it collects your email address.  In this case your symptom information and privacy are protected because the only people who will know you are a research subject are members of the research team. No information about you, or provided by you during the research, will be disclosed to others without your written permission, except if required by law.   Personal information obtained by questionnaires will be stored in secure databases within the UCLA network. The data will be stored in a HIPAA compliant environment, which satisfies the same set of requirements used for medical data.', 'The only exception is if you opt to participate in the research study in which case it collects your email address.  In this case your symptom information and privacy are protected because the only people who will know you are a research subject are members of the research team. No information about you, or provided by you during the research, will be disclosed to others without your written permission, except if required by law.   Personal information obtained by questionnaires will be stored in secure databases within the UCLA network. The data will be stored in a HIPAA compliant environment, which satisfies the same set of requirements used for medical data.']
			}
		},
		cryptoalg: {
			q: ['How does the cryptographic algorithm work and why do we need it?', 'How does the cryptographic algorithm work and why do we need it?'],
			a: ['Since the symptom screener is anonymous, there needs to be some way to prove that you completed the symptom screening which is enabled by the cryptographic algorithm.  An example of a cryptographic algorithm is \u201Cblockchain\u201D which is the technology that enables the bitcoin currency.   In the STOP COVID symptom screener, the cryptographic algorithm is used to generate and validate the codes.  We at UCLA have generated the completion codes for each hour and release the code to anyone who completes the symptom screening that hour.  We also release some validation information in the form of a set of numbers that allows both us or anyone else to validate the codes.  It is extremely difficult for someone to guess what a completion code is without getting it from us by completing the symptom screener.  There are 2^64 possible codes which is a number with about 20 digits so guessing a valid completion code will be extremely difficult even if someone uses a tremendous amount of computing power in the process.  Thus, if someone is in possession of a completion code such as those displayed on a completion certificate, that proves that the code came from the STOP COVID Daily Symptom Screener.  While it is possible that someone can get a completion code from someone else who completed the screener, we think this is unlikely since it is easier to just complete the screener rather than coordinate someone else completing it and sharing the code.', 'Since the symptom screener is anonymous, there needs to be some way to prove that you completed the symptom screening which is enabled by the cryptographic algorithm.  An example of a cryptographic algorithm is \u201Cblockchain\u201D which is the technology that enables the bitcoin currency.   In the STOP COVID symptom screener, the cryptographic algorithm is used to generate and validate the codes.  We at UCLA have generated the completion codes for each hour and release the code to anyone who completes the symptom screening that hour.  We also release some validation information in the form of a set of numbers that allows both us or anyone else to validate the codes.  It is extremely difficult for someone to guess what a completion code is without getting it from us by completing the symptom screener.  There are 2^64 possible codes which is a number with about 20 digits so guessing a valid completion code will be extremely difficult even if someone uses a tremendous amount of computing power in the process.  Thus, if someone is in possession of a completion code such as those displayed on a completion certificate, that proves that the code came from the STOP COVID Daily Symptom Screener.  While it is possible that someone can get a completion code from someone else who completed the screener, we think this is unlikely since it is easier to just complete the screener rather than coordinate someone else completing it and sharing the code.']
		},
		namedcert: {
			q: ['What is a Named STOP COVID Symptom Free Certificate?', 'What is a Named STOP COVID Symptom Free Certificate?'],
			a: ['You have the option to have your name or other identifier included on your STOP COVID Symptom Free Certificate.   You can request a named certificate using the STOP COVID Daily Symptom Screener.  These certificates contain a different cryptographic code that both records the time and is tied to the requested name or identifier.  Each name or identifier is assigned a number between 1 and 10,000 and the code matches the specific number.  These certificates can be validated by either using a mobile device and scanning the QR code or going to the website verify.stopcovid19together.org.  If someone modifies the name or identifier on the certificate, the number corresponding to the name will have a 99.99% chance of being different from the number of the original name, which will make the certificate invalid.  This makes it more difficult for individuals to share symptom free certificates.  We do not store the name or identifier after issuing the certificate and the code itself only encodes the number between 1 and 10,000 and not the actual name or identifier.', 'You have the option to have your name or other identifier included on your STOP COVID Symptom Free Certificate.   You can request a named certificate using the STOP COVID Daily Symptom Screener.  These certificates contain a different cryptographic code that both records the time and is tied to the requested name or identifier.  Each name or identifier is assigned a number between 1 and 10,000 and the code matches the specific number.  These certificates can be validated by either using a mobile device and scanning the QR code or going to the website verify.stopcovid19together.org.  If someone modifies the name or identifier on the certificate, the number corresponding to the name will have a 99.99% chance of being different from the number of the original name, which will make the certificate invalid.  This makes it more difficult for individuals to share symptom free certificates.  We do not store the name or identifier after issuing the certificate and the code itself only encodes the number between 1 and 10,000 and not the actual name or identifier.']
		},
		emailcert: {
			q: ['I opted to receive my STOP COVID Symptom Free Certificate or proof that I took the STOP COVID Daily Symptom Screener by email.  Is my email stored in the system?', 'I opted to receive my STOP COVID Symptom Free Certificate or proof that I took the STOP COVID Daily Symptom Screener by email.  Is my email stored in the system?'],
			a: ['No.  We do not store any email addresses unless you decide to participate in the STOP COVID Research Study in which case we store your email so that you can receive emails asking you questions for the research study.  If you select to receive your certificates by email, we will email you a link that encodes your email that you can use to request STOP COVID Symptom Free Certificates by email.  The link may also encode the name you would like to be printed on the certificates.  No copy of the email that we send you or a record of the email or name you requested on the certificate will be stored.  In addition, no copy of the emails that are sent to you with your certificates or proof that you completed the screener are stored on our system.', 'No.  We do not store any email addresses unless you decide to participate in the STOP COVID Research Study in which case we store your email so that you can receive emails asking you questions for the research study.  If you select to receive your certificates by email, we will email you a link that encodes your email that you can use to request STOP COVID Symptom Free Certificates by email.  The link may also encode the name you would like to be printed on the certificates.  No copy of the email that we send you or a record of the email or name you requested on the certificate will be stored.  In addition, no copy of the emails that are sent to you with your certificates or proof that you completed the screener are stored on our system.']
		},
		employermandate: {
			q: ['Why am I being asked to take this symptom screener by my employer? Do I have to?', 'Why am I being asked to take this symptom screener by my employer? Do I have to?'],
			a: ['If you are asked by your employer to take this symptom screener, then your employer has decided to ask employees to perform daily symptom screening.  Contact your employer about any questions relating to this symptom screener.', 'If you are asked by your employer to take this symptom screener, then your employer has decided to ask employees to perform daily symptom screening.  Contact your employer about any questions relating to this symptom screener.']
		},
		employersharing: {
			q: ['My employer is asking me to take this symptom screener - what kind of data about me do you give to my employer?', 'My employer is asking me to take this symptom screener - what kind of data about me do you give to my employer?'],
			a: ['We do not provide any information about you to your employer.  Your employer may ask you to provide evidence that you have completed the symptom screener and are symptom free by showing the symptom free certificate.', 'We do not provide any information about you to your employer.  Your employer may ask you to provide evidence that you have completed the symptom screener and are symptom free by showing the symptom free certificate.']
		},
		employerObtain: {
			q: ['My employer provided me a link to the STOP COVID Daily Symptom Screener that routes me to their COVID-19 guidelines if I report symptoms. Does my employer obtain any of my information?', 'My employer provided me a link to the STOP COVID Daily Symptom Screener that routes me to their COVID-19 guidelines if I report symptoms. Does my employer obtain any of my information?'],
			a: ['No. We do not provide any information to employers and the link is only used to route individuals to organization specific COVID-19 guidelines.', 'No. We do not provide any information to employers and the link is only used to route individuals to organization specific COVID-19 guidelines.']
		},
		employertransmit: {
			q: ['I am an employer and asked my employees to utilize the STOP COVID Daily Symptom Screener. Do you guarantee that employees taking the symptom screener are not carrying or otherwise cannot transmit COVID-19?', 'I am an employer and asked my employees to utilize the STOP COVID Daily Symptom Screener. Do you guarantee that employees taking the symptom screener are not carrying or otherwise cannot transmit COVID-19?'],
			a: ['No, the symptom screener does not provide results that someone is or is not carrying COVID-19. The results are based upon information provided by the employee.  ', 'No, the symptom screener does not provide results that someone is or is not carrying COVID-19. The results are based upon information provided by the employee.  ']
		},
		employersymptom: {
			q: ['I am an employer and asked my employees to utilize the STOP COVID Daily Symptom Screener.  If any employee displays a valid symptom free certificate, does this guarantee that the employee does not have symptoms?', 'I am an employer and asked my employees to utilize the STOP COVID Daily Symptom Screener.  If any employee displays a valid symptom free certificate, does this guarantee that the employee does not have symptoms?'],
			a: ['No.  If an employee displays a valid symptom free certificate, the most likely scenario is that the employee took the symptom screener and reported no symptoms.  Another possibility is that the employee obtained a symptom free certificate from another individual who completed the symptom screener.  We note that this is unlikely since it takes more effort to obtain a certificate from another individual than to complete the symptom screener.', 'No.  If an employee displays a valid symptom free certificate, the most likely scenario is that the employee took the symptom screener and reported no symptoms.  Another possibility is that the employee obtained a symptom free certificate from another individual who completed the symptom screener.  We note that this is unlikely since it takes more effort to obtain a certificate from another individual than to complete the symptom screener.']
		},
		employercovid: {
			q: ['I am an employer and asked my employees to utilize the STOP COVID Daily Symptom Screener.  If an employee shows symptoms, does that mean they have or had or COVID-19?', 'I am an employer and asked my employees to utilize the STOP COVID Daily Symptom Screener.  If an employee shows symptoms, does that mean they have or had or COVID-19?'],
			a: ['No. Our symptom screener only asks if individuals have symptoms that are associated with COVID-19.', 'No. Our symptom screener only asks if individuals have symptoms that are associated with COVID-19.']
		},
		employeroptin: {
			q: ['I am an employer and asked my employees to utilize the STOP COVID Daily Symptom Screener.  Will employees become part of the research study?', 'I am an employer and asked my employees to utilize the STOP COVID Daily Symptom Screener.  Will employees become part of the research study?'],
			a: ['The symptom screener includes a question asking the person if they would like to participate in the study. They are only added to the study if they answer yes to that question.', 'The symptom screener includes a question asking the person if they would like to participate in the study. They are only added to the study if they answer yes to that question.']
		},
		employernotify: {
			q: ['I am an employer and asked my employees to utilize the STOP COVID Daily Symptom Screener.  If an employee responds that they have symptoms of COVID-19, can you notify us? Do you notify local departments or public health?', 'I am an employer and asked my employees to utilize the STOP COVID Daily Symptom Screener.  If an employee responds that they have symptoms of COVID-19, can you notify us? Do you notify local departments or public health?'],
			a: ['No. We do not notify the employer, or anyone else. We do not collect any information about employees in a way that would allow us to provide this information to employers. The employee is only provided public health information advising them to stay home and seek medical attention if they respond that they have any symptoms.', 'No. We do not notify the employer, or anyone else. We do not collect any information about employees in a way that would allow us to provide this information to employers. The employee is only provided public health information advising them to stay home and seek medical attention if they respond that they have any symptoms.']
		},
		employerdata: {
			q: ['I am an employer and asked my employees to utilize the STOP COVID Daily Symptom Screener.  How do you use our employees\u2019 data? What information will you have about them?', 'I am an employer and asked my employees to utilize the STOP COVID Daily Symptom Screener.  How do you use our employees\u2019 data? What information will you have about them?'],
			a: ['We do not collect or have access to any data from the symptom screener, unless the employee signs up to participate in the research study in which case we store their email address to include them in the research study.', 'We do not collect or have access to any data from the symptom screener, unless the employee signs up to participate in the research study in which case we store their email address to include them in the research study.']
		},
		employerresults: {
			q: ['I am an employer and asked my employees to utilize the STOP COVID Daily Symptom Screener. Will employers receive any kind of aggregated results?', 'I am an employer and asked my employees to utilize the STOP COVID Daily Symptom Screener. Will employers receive any kind of aggregated results?'],
			a: ['No. We do not provide any information to employers.', 'No. We do not provide any information to employers.']
		},
		employerGuide: {
			q: ['I am an employer and asked my employees to utilize the STOP COVID Daily Symptom Screener.  I want to route individuals with symptoms to guidelines specific to my organization.  Can I do this?', 'I am an employer and asked my employees to utilize the STOP COVID Daily Symptom Screener.  I want to route individuals with symptoms to guidelines specific to my organization.  Can I do this?'],
			a: ['Yes.  It is possible to provide us a link to give to your employees which will route individuals with symptoms to specific guidelines for your organization.  Please contact us if you are interested.', 'Yes.  It is possible to provide us a link to give to your employees which will route individuals with symptoms to specific guidelines for your organization.  Please contact us if you are interested.']
		},
		whatisdailystudent: {
			q: ['What is the STOP COVID Child Daily Symptom Screener?', 'What is the STOP COVID Child Daily Symptom Screener?'],
			a: ['The STOP COVID Child Daily Symptom Screener is a system that allows for a parent to provide daily symptom screening for their child while preserving privacy.  In the system, we do not collect any identifying information and the parent will receive a symptom free certificate providing evidence that the symptom screener was completed and no symptoms were reported for the child. The certificate contains a code, powered by cryptographic technology, that confirms the hour that the symptom tracking was performed but provides no ability to obtain the identity of either the parent or the child.', 'The STOP COVID Child Daily Symptom Screener is a system that allows for a parent to provide daily symptom screening for their child while preserving privacy.  In the system, we do not collect any identifying information and the parent will receive a symptom free certificate providing evidence that the symptom screener was completed and no symptoms were reported for the child. The certificate contains a code, powered by cryptographic technology, that confirms the hour that the symptom tracking was performed but provides no ability to obtain the identity of either the parent or the child.']
		},
		whydailystudent: {
			q: ['Why is daily symptom screening important?', 'Why is daily symptom screening important?'],
			a: ['Daily symptom screening keeps us aware of children\u2019s health as well as our own and provides a daily opportunity to self-identify COVID-19 symptoms which can guide us in taking public health measures including isolating and testing.', 'Daily symptom screening keeps us aware of children\u2019s health as well as our own and provides a daily opportunity to self-identify COVID-19 symptoms which can guide us in taking public health measures including isolating and testing.']
		},
		howdailystudent: {
			q: ['How do I use the STOP COVID Child Daily Symptom Screener?', 'How do I use the STOP COVID Child Daily Symptom Screener?'],
			a: ['Each morning, take the STOP COVID Child Daily Symptom Screener using a computer browser or smartphone to report any of your child\u2019s symptoms. If your child is symptom free, you will receive a symptom free certificate that you can show as proof that you completed symptom screening that morning and reported no symptoms for your child.', 'Each morning, take the STOP COVID Child Daily Symptom Screener using a computer browser or smartphone to report any of your child\u2019s symptoms. If your child is symptom free, you will receive a symptom free certificate that you can show as proof that you completed symptom screening that morning and reported no symptoms for your child.']
		},
		nostudentdiagnosis: {
			q: ['Will the symptom screener tell me if my child has (or does not have) COVID-19?', 'Will the symptom screener tell me if my child has (or does not have) COVID-19?'],
			a: ['No. The symptom screener only asks questions relating to any symptoms that are associated with COVID-19. If you respond that your child does have any symptoms that are associated with COVID-19, it only provides you with public health guidance that instructs you to keep your child home and seek medical attention.', 'No. The symptom screener only asks questions relating to any symptoms that are associated with COVID-19. If you respond that your child does have any symptoms that are associated with COVID-19, it only provides you with public health guidance that instructs you to keep your child home and seek medical attention.']
		},
		dailystudentapproval: {
			q: ['Has your symptom screener been approved by the CDC, FDA, or any state or local departments of public health?', 'Has your symptom screener been approved by the CDC, FDA, or any state or local departments of public health?'],
			a: ['No. Our symptom screener has not been reviewed, endorsed, supported or otherwise approved in any way by any public health authority.  The symptom screener questions and responses are based on publicly-available public health information.', 'No. Our symptom screener has not been reviewed, endorsed, supported or otherwise approved in any way by any public health authority.  The symptom screener questions and responses are based on publicly-available public health information.']
		},
		dailystudentresearch: {
			q: ['If I use the STOP COVID Child Daily Symptom Screening, am I or my child part of the STOP COVID Research Study?  Can I become part of the STOP COVID Research Study?', 'If I use the STOP COVID Child Daily Symptom Screening, am I or my child part of the STOP COVID Research Study?  Can I become part of the STOP COVID Research Study?'],
			a: ['If you are using the STOP COVID Child Daily Symptom Screening, you are not part of the STOP COVID Research Study unless you choose to be part of it by answering the corresponding question in the symptom screener.  Participation in the STOP COVID research study is voluntary and you can leave the study at any time. You are not required to participate in the research study to obtain a symptom free certificate. If you do choose to join the research study, you will receive an email asking you additional questions to better understand the pandemic. If you do voluntarily become part of the STOP COVID Study, your email address will be recorded (but not any identifying information or symptom information) so you can be contacted to answer these other questions to help identify hotspots and predict COVID-19 outbreaks. Note that only individuals over 18 are eligible to be part of the STOP COVID Research Study.', 'If you are using the STOP COVID Child Daily Symptom Screening, you are not part of the STOP COVID Research Study unless you choose to be part of it by answering the corresponding question in the symptom screener.  Participation in the STOP COVID research study is voluntary and you can leave the study at any time. You are not required to participate in the research study to obtain a symptom free certificate. If you do choose to join the research study, you will receive an email asking you additional questions to better understand the pandemic. If you do voluntarily become part of the STOP COVID Study, your email address will be recorded (but not any identifying information or symptom information) so you can be contacted to answer these other questions to help identify hotspots and predict COVID-19 outbreaks. Note that only individuals over 18 are eligible to be part of the STOP COVID Research Study.']
		},
		dailystudentdatause: {
			q: ['How do you use my data?', 'How do you use my data?'],
			a: ['If you respond to the symptom screener by indicating that your child is experiencing any symptoms associated with COVID-19, we will use that data for the sole purpose of providing you with public health information.  If you reported no symptoms for your child, we will use the data for the sole purpose of issuing you a symptom free certificate for your child.  None of the data you enter is stored in our system unless you decide to participate in the STOP COVID Research Study in which case your email address will be recorded so you can receive a followup email to join the STOP COVID Research Study.', 'If you respond to the symptom screener by indicating that your child is experiencing any symptoms associated with COVID-19, we will use that data for the sole purpose of providing you with public health information.  If you reported no symptoms for your child, we will use the data for the sole purpose of issuing you a symptom free certificate for your child.  None of the data you enter is stored in our system unless you decide to participate in the STOP COVID Research Study in which case your email address will be recorded so you can receive a followup email to join the STOP COVID Research Study.']
		},
		dailystudentcert: {
			q: ['What is a STOP COVID Symptom Free Certificate?', 'What is a STOP COVID Symptom Free Certificate?'],
			a: ['When you complete the daily symptom screening for your child, you will receive a symptom free certificate providing evidence that you completed the symptom screener for your child and reported no symptoms. The certificate contains a cryptographic code that records at that time the symptom screener was performed. This cryptographic technology confirms the hour that the symptom screening was performed but provides no ability to obtain your identity. The code is both written on the certificate and encoded in a QR code. The code can be verified to be authentic using a public domain algorithm. The color of the certificate shows how recent the symptom screener was taken.  Blue signifies within 24 hours, yellow signifies within a week and red is older than one week.  On the certificate is also the time that the symptom screener was taken. The certificate itself is generated using a system hosted by the STOP COVID website which visualizes the code with the correct color and also includes the time that the certificate was visualized.  The certificate is designed to be displayed on a mobile phone but can also be printed out.', 'When you complete the daily symptom screening for your child, you will receive a symptom free certificate providing evidence that you completed the symptom screener for your child and reported no symptoms. The certificate contains a cryptographic code that records at that time the symptom screener was performed. This cryptographic technology confirms the hour that the symptom screening was performed but provides no ability to obtain your identity. The code is both written on the certificate and encoded in a QR code. The code can be verified to be authentic using a public domain algorithm. The color of the certificate shows how recent the symptom screener was taken.  Blue signifies within 24 hours, yellow signifies within a week and red is older than one week.  On the certificate is also the time that the symptom screener was taken. The certificate itself is generated using a system hosted by the STOP COVID website which visualizes the code with the correct color and also includes the time that the certificate was visualized.  The certificate is designed to be displayed on a mobile phone but can also be printed out.']
		},
		dailystudentcertvalid: {
			q: ['How can I tell if a symptom free certificate is valid \u2013 that is, the person showing me a certificate has obtained it from the symptom screener?', 'How can I tell if a symptom free certificate is valid \u2013 that is, the person showing me a certificate has obtained it from the symptom screener?'],
			a: ['Using a mobile device, the QR code on a certificate can be scanned to verify that it is valid.  In addition, a code can be verified by entering it on the website https://verify.stopcovid19together.org.', 'Using a mobile device, the QR code on a certificate can be scanned to verify that it is valid.  In addition, a code can be verified by entering it on the website https://verify.stopcovid19together.org.']
		},
		dailystudentprivacy: {
			q: ['How does the STOP COVID Child Daily Symptom Screener preserve my privacy?', 'How does the STOP COVID Child Daily Symptom Screener preserve my privacy?'],
			a: {
				one: ['The STOP COVID Child Daily Symptom Screener does not collect any identifying information about you or your child when you fill out the symptom screener which makes it impossible to associate any of your or your child\u2019s symptom responses with you.', 'The STOP COVID Child Daily Symptom Screener does not collect any identifying information about you or your child when you fill out the symptom screener which makes it impossible to associate any of your or your child\u2019s symptom responses with you.'],
				two: ['The only exception is if you opt to participate in the research study in which case it collects your email address.  In this case your symptom information and privacy are protected because the only people who will know you are a research subject are members of the research team. No information about you, or provided by you during the research, will be disclosed to others without your written permission, except if required by law.   Personal information obtained by questionnaires will be stored in secure databases within the UCLA network. The data will be stored in a HIPAA compliant environment, which satisfies the same set of requirements used for medical data.', 'The only exception is if you opt to participate in the research study in which case it collects your email address.  In this case your symptom information and privacy are protected because the only people who will know you are a research subject are members of the research team. No information about you, or provided by you during the research, will be disclosed to others without your written permission, except if required by law.   Personal information obtained by questionnaires will be stored in secure databases within the UCLA network. The data will be stored in a HIPAA compliant environment, which satisfies the same set of requirements used for medical data.']
			}
		},
		dailystudentcrypto: {
			q: ['How does the cryptographic algorithm work and why do we need it?', 'How does the cryptographic algorithm work and why do we need it?'],
			a: ['Since the symptom screener is anonymous, there needs to be some way to prove that you completed the symptom screening which is enabled by the cryptographic algorithm.  An example of a cryptographic algorithm is \u201Cblockchain\u201D which is the technology that enables the bitcoin currency.   In the STOP COVID symptom screener, the cryptographic algorithm is used to generate and validate the codes.  We at UCLA have generated the completion codes for each hour and release the code to anyone who completes the symptom screening that hour.  We also release some validation information in the form of a set of numbers that allows both us or anyone else to validate the codes.  It is extremely difficult for someone to guess what a completion code is without getting it from us by completing the symptom screener.  There are 2^64 possible codes which is a number with about 20 digits so guessing a valid completion code will be extremely difficult even if someone uses a tremendous amount of computing power in the process.  Thus, if someone is in possession of a completion code such as those displayed on a completion certificate, that proves that the code came from the STOP COVID Child Daily Symptom Screener.  While it is possible that someone can get a completion code from someone else who completed the screener, we think this is unlikely since it is easier to just complete the screener rather than coordinate someone else completing it and sharing the code.', 'Since the symptom screener is anonymous, there needs to be some way to prove that you completed the symptom screening which is enabled by the cryptographic algorithm.  An example of a cryptographic algorithm is \u201Cblockchain\u201D which is the technology that enables the bitcoin currency.   In the STOP COVID symptom screener, the cryptographic algorithm is used to generate and validate the codes.  We at UCLA have generated the completion codes for each hour and release the code to anyone who completes the symptom screening that hour.  We also release some validation information in the form of a set of numbers that allows both us or anyone else to validate the codes.  It is extremely difficult for someone to guess what a completion code is without getting it from us by completing the symptom screener.  There are 2^64 possible codes which is a number with about 20 digits so guessing a valid completion code will be extremely difficult even if someone uses a tremendous amount of computing power in the process.  Thus, if someone is in possession of a completion code such as those displayed on a completion certificate, that proves that the code came from the STOP COVID Child Daily Symptom Screener.  While it is possible that someone can get a completion code from someone else who completed the screener, we think this is unlikely since it is easier to just complete the screener rather than coordinate someone else completing it and sharing the code.']
		},
		dailystudentnamedcert: {
			q: ['What is a Named STOP COVID Symptom Free Certificate?', 'What is a Named STOP COVID Symptom Free Certificate?'],
			a: ['You have the option to have your child\u2019s name or other identifier written on your STOP COVID Symptom Free Certificate.  You can request such a named certificate using the STOP COVID Child Daily Symptom Screener. These certificates contain a different cryptographic code that both records the time as well as tied to the name or identifier. Each name or identifier is assigned a number between 1 and 10,000 and the code matches the specific number. These certificates can be validated the same way by either using a mobile device and scanning the QR code or going to the website verify.stopcovid19together.org. If someone modifies the name or identifier on the certificate, the number corresponding to the name will have a 99.99% chance of being different from the number of the original name which will make the certificate invalid. This makes it more difficult for individuals to share symptom free certificates and makes it more likely that they themselves completed the screening. We do not store the name or identifier after issuing the certificate and the code itself only encodes the number between 1 and 10,000 and not the actual name or identifier.', 'You have the option to have your child\u2019s name or other identifier written on your STOP COVID Symptom Free Certificate.  You can request such a named certificate using the STOP COVID Child Daily Symptom Screener. These certificates contain a different cryptographic code that both records the time as well as tied to the name or identifier. Each name or identifier is assigned a number between 1 and 10,000 and the code matches the specific number. These certificates can be validated the same way by either using a mobile device and scanning the QR code or going to the website verify.stopcovid19together.org. If someone modifies the name or identifier on the certificate, the number corresponding to the name will have a 99.99% chance of being different from the number of the original name which will make the certificate invalid. This makes it more difficult for individuals to share symptom free certificates and makes it more likely that they themselves completed the screening. We do not store the name or identifier after issuing the certificate and the code itself only encodes the number between 1 and 10,000 and not the actual name or identifier.']
		},
		dailystudentemail: {
			q: ['I opted to receive my STOP COVID Symptom Free Certificate or proof that I took the STOP COVID Child Daily Symptom Screener by email.  Is my email stored in the system?', 'I opted to receive my STOP COVID Symptom Free Certificate or proof that I took the STOP COVID Child Daily Symptom Screener by email.  Is my email stored in the system?'],
			a: ['No. We do not store any email addresses unless you decide to participate in the STOP COVID Research Study in which case we store your email in order to receive emails asking questions for the research study.  If you select to receive your certificates by email, we will email you a link that encodes your email that you can use to request STOP COVID Symptom Free Certificates by email. The link may also encode the name you would like to be printed on the certificates. No copy of the email that we send you or a record of the email or name you requested on the certificate will be stored. In addition, no copy of the emails that are sent to you with your certificates or proof that you completed the screener are stored on our system.', 'No. We do not store any email addresses unless you decide to participate in the STOP COVID Research Study in which case we store your email in order to receive emails asking questions for the research study.  If you select to receive your certificates by email, we will email you a link that encodes your email that you can use to request STOP COVID Symptom Free Certificates by email. The link may also encode the name you would like to be printed on the certificates. No copy of the email that we send you or a record of the email or name you requested on the certificate will be stored. In addition, no copy of the emails that are sent to you with your certificates or proof that you completed the screener are stored on our system.']
		},
		dailystudentrequire: {
			q: ['Why am I being asked to fill out this symptom screener for my child by my child\u2019s school? Do I have to?', 'Why am I being asked to fill out this symptom screener for my child by my child\u2019s school? Do I have to?'],
			a: ['If you are asked by your child\u2019s school to fill out this symptom screener for your child, then your child\u2019s school has decided to ask parents to perform daily symptom screening for their children. Contact your child\u2019s school about any questions relating to this symptom screener.', 'If you are asked by your child\u2019s school to fill out this symptom screener for your child, then your child\u2019s school has decided to ask parents to perform daily symptom screening for their children. Contact your child\u2019s school about any questions relating to this symptom screener.']
		},
		dailystudentshare: {
			q: ['My child\u2019s school is asking me to take this symptom screener - what kind of data about me do you give to my child\u2019s school?', 'My child\u2019s school is asking me to take this symptom screener - what kind of data about me do you give to my child\u2019s school?'],
			a: ['We do not provide any information about you to your child\u2019s school. Your child\u2019s school may ask you or your child to provide evidence that you have completed the symptom screener for your child and reported that your child is symptom free by showing the symptom free certificate.', 'We do not provide any information about you to your child\u2019s school. Your child\u2019s school may ask you or your child to provide evidence that you have completed the symptom screener for your child and reported that your child is symptom free by showing the symptom free certificate.']
		},
		studentobtain: {
			q: ['My child’s school provided me a link to the symptom screener that routes me to their COVID-19 guidelines if my child has symptoms.  Does the school obtain any of my information?', 'My child’s school provided me a link to the symptom screener that routes me to their COVID-19 guidelines if my child has symptoms.  Does the school obtain any of my information?'],
			a: ['No.  We do not provide any information to the school and the link is only used to route individuals to school specific COVID-19 guidelines.', 'No.  We do not provide any information to the school and the link is only used to route individuals to school specific COVID-19 guidelines.']
		},
		dailystudentguaranteecovid: {
			q: ['I am a school administrator and asked the parents and guardians of minor  students to utilize the STOP COVID Child Daily Symptom Screener.  Do you guarantee that the children whose parents or guardians complete the symptom screener are not carrying or otherwise cannot transmit COVID-19?', 'I am a school administrator and asked the parents and guardians of minor  students to utilize the STOP COVID Child Daily Symptom Screener.  Do you guarantee that the children whose parents or guardians complete the symptom screener are not carrying or otherwise cannot transmit COVID-19?'],
			a: ['No, the symptom screener does not provide results that someone is or is not carrying COVID-19. The results are based upon information provided by the parents.', 'No, the symptom screener does not provide results that someone is or is not carrying COVID-19. The results are based upon information provided by the parents.']
		},
		dailystudentguaranteesymptom: {
			q: ['I am a school administrator and asked the parents and guardians of my students to utilize the STOP COVID Child Daily Symptom Screener.  If any parent/guardian or child displays a valid symptom free certificate, does this guarantee that the child does not have symptoms?', 'I am a school administrator and asked the parents and guardians of my students to utilize the STOP COVID Child Daily Symptom Screener.  If any parent/guardian or child displays a valid symptom free certificate, does this guarantee that the child does not have symptoms?'],
			a: ['No. If a parent/guardian or child displays a valid symptom free certificate, the most likely scenario is that the adult took the symptom screener and reported no symptoms for the child. Another possibility is that the parent/guardian or child obtained a symptom free certificate from another individual who completed the symptom screener. We note that this is unlikely since it takes more effort to obtain a certificate from another individual than to complete the symptom screener.', 'No. If a parent/guardian or child displays a valid symptom free certificate, the most likely scenario is that the adult took the symptom screener and reported no symptoms for the child. Another possibility is that the parent/guardian or child obtained a symptom free certificate from another individual who completed the symptom screener. We note that this is unlikely since it takes more effort to obtain a certificate from another individual than to complete the symptom screener.']
		},
		studentroute: {
			q: ['I am a school administrator  and asked the parents and guardians  to utilize the STOP COVID Child Daily Symptom Screener.  I want to route individuals with symptoms to guidelines specific to my organization.  Can I do this?', 'I am a school administrator  and asked the parents and guardians  to utilize the STOP COVID Child Daily Symptom Screener.  I want to route individuals with symptoms to guidelines specific to my organization.  Can I do this?'],
			a: ['Yes.  It is possible to provide us a link to give to the parents and guardians affiliated with your school which will route individuals with symptoms to specific guidelines for your school.  Please contact us if you are interested.', 'Yes.  It is possible to provide us a link to give to the parents and guardians affiliated with your school which will route individuals with symptoms to specific guidelines for your school.  Please contact us if you are interested.']
		}

	},
	student: {
		survey: {
			title: ['Child Daily Symptom Screener', 'Cuestionario Sintomatico para Ni\xF1os'],
			disc: {
				first: [function (name) {
					return 'Welcome ' + name + ' (if you are not affiliated, <a href="/student">click here</a>)';
				}, function (name) {
					return 'Bienvenido a ' + name + ' (si usted no est\xE1 afiliado, <a href="/student">pinche aqu\xED</a>)';
				}],
				second: ['Daily symptom screening of our children makes schools safer and saves lives.', 'La evaluaci\xF3n diaria sintom\xE1tica de su hijo hace que los colegios sean un lugar seguro y salva vidas.'],
				third: ['At the end of the screener, if your child is symptom free, you will receive a link to a symptom free certificate for your child. Click this link and save it on your phone or print out a copy.', 'Al final del cuestionario, si su hijo no padece ning\xFAn s\xEDntoma, recibir\xE1 un enlace con su certificado. Pinche aqu\xED y gu\xE1rdelo en su tel\xE9fono o impr\xEDmalo.'],
				fourth: ['By displaying the symptom free certificate, you are certifying that you used the STOP COVID Child Daily Symptom Screener for your child and answered the symptom questions truthfully.', 'Mostrando su certificado, usted est\xE1 certificando que ha realizado el cuestionario sintom\xE1tico para ni\xF1os de Stop Covid y ha contestado con veracidad.']
			},
			link: ['Click here to symptom screen', 'Pinche aqu\xED para el cuestionario']
		},
		instructions: {
			title: ['Using the Symptom Screener', 'Como usar el Cuestionario Sintom\xE1tico'],
			disc: {
				first: ['Daily symptom screening keeps us aware of our children\u2019s health and provides a daily opportunity to self-identify their COVID-19 symptoms.', 'La evaluaci\xF3n diaria de los s\xEDntomas nos hace ser conscientes de la salud de nuestros hijos y proporciona una oportunidad diaria de identificar los s\xEDntomas de COVID-19 a nosotros mismos.'],
				second: ['Each morning, take the STOP COVID symptom screener and if your child is symptom free, you will receive a link to a symptom free certificate that you can show as proof that your child is symptom free. Save the link on your phone or print out a copy. A current certificate is blue and will change colors as it expires.', 'Haga el cuestionario sintom\xE1tico de STOP COVID cada ma\xF1ana y si su hijo no tuviera s\xEDntomas, recibir\xE1 un enlace con su certificado, que podra mostrar como prueba. Guarde el enlace en su tel\xE9fono o impr\xEDmalo. El certificado actual es de color azul y cambiara de color en elmomento que caduque.'],
				third: [function (name) {
					return 'If you report symptoms, you will be provided information specific to ' + name + ' as well as general public health guidance.';
				}, function (name) {
					return 'Si presentara s\xEDntomas en el cuestionario, ' + name + ', le dar\xE1 instrucciones sobre que hacer e incluso le informar\xE1 de las normas de salud p\xFAblica.';
				}],
				fourth: ['You will also have the option to put your child\u2019s name or other identifier on the certificate. Just enter their name or identifier in the box when getting your certificate.', 'Usted tiene tambi\xE9n la opci\xF3n de a\xF1adir el nombre o identificador de su hijo en el certificado. Solo tendr\xE1 que a\xF1adirlo en la casilla correspondiente una vez reciba el certificado.']
			}
		},
		certificates: {
			title: ['Symptom Free Certificates', 'Certificado Sin S\xEDntomas'],
			disc: {
				first: ['When you complete the screener and are symptom free, you will get a link to a symptom free certificate.', 'Cuando finalice el cuestionario y no presente s\xEDntomas, obtendr\xE1 un enlace de Certificado sin s\xEDntomas.'],
				second: ['Examples of certificates are shown below:', 'Estos son a continuaci\xF3n los ejemplos de certificados:'],
				third: ['The color of the certificate shows how recent the screening was performed. Blue signifies within 24 hours, yellow signifies within a week and red is older than one week. The certificate also displays the time that the screening was performed. The certificate is designed to be displayed on a mobile phone but can also be printed out.', 'El color de los certificados muestra hace cuanto tiempo se realiz\xF3 el cuestionario. Azul muestra que se realiz\xF3 en las \xFAltimas 24 horas, amarillo muestra que se realizo en laultima semana, y rojo muestra que se hizo hace mas de una semana. El certificado muestra tambi\xE9n la hora en la que se realiz\xF3. El certificado est\xE1 dise\xF1ado para mostrarse en el movil/cellular pero tambi\xE9n puede imprimirse.'],
				fourth: ['In addition, A name or other identifier can be displayed on the certificate. An example of a named symptom free certificate is shown below:', 'Tambi\xE9n podr\xE1 a\xF1adir en su certificado, su nombre o identificador, como se muestra a continuaci\xF3n:'],
				fifth: ['Examples of certificates are shown below:', 'Estos son a continuaci\xF3n los ejemplos de certificados:']
			}
		},
		verification: {
			title: ['Verifying Symptom Free Certificates', 'Como Verificar los Certificados Sin S\xEDntomas'],
			disc: {
				first: ['When examining a certificate, please check to see that the color is blue, the time is within 24 hours and the current time is the time that the certificate is visualized. After 24 hours, the color of the certificate turns to yellow and after a week it turns to red. On the certificate is a 16 character code which ensures that the certificate is valid and came from the system. This code can be validated by using the camera of a mobile device to scan the QR code on a certificate which will show if the code is valid. The code can also be verified by entering it on the website <a href="https://verify.stopcovid19together.org">verify.stopcovid19together.org</a>.', 'Cuando examine el certificado, por favor observe que el color sea Azul, la hora que muestra fue en las \xFAltimas 24 horas y la hora que muestra corresponde a la actual. Despues de 24 horas el certificado cambia a color amarillo y despues de una semana cambia a rojo. El certificado muestra un c\xF3digo de 16 d\xEDgitos que verifica que ha sido realizado por este sistema. Este c\xF3digo puede ser verificado utilizando la c\xE1mara del movil/celular escaneando el c\xF3digo QR de este certificado. El c\xF3digo tambi\xE9n puede ser verificado introduciendo el c\xF3digo en la siguiente p\xE1gina web: <a href="https://verify.stopcovid19together.org">verify.stopcovid19together.org</a>.']
			}
		},
		howTo: {
			title: ['How the STOP COVID Symptom Screener Works', 'C\xF3mo funciona el cuestionario de STOP COVID'],
			disc: {
				first: ['The STOP COVID symptom screener allows for anonymous symptom screening. In the system, we do not collect any identifying information. The symptom free certificate you receive contains a code, powered by cryptographic technology, that confirms the hour that the symptom screening was performed but provides no ability to obtain your identity.', 'El cuestionario de s\xEDntomas de STOP COVID permite el anonimato del cuestionario. En nuestro sistema, no recogemos datos identificativos. El certificado sin s\xEDntomas que recibe contiene un c\xF3digo generado por tecnolog\xEDa criptogr\xE1fica que confirma la hora en la que se realiz\xF3, sin recoger la identificaci\xF3n.'],
				second: ['The code is both written on the certificate and encoded in a QR code. The code can be verified to be authentic using a validation system we also provide. Because of the cryptographic algorithm, it is extremely difficult to obtain a valid code without getting it from our system. The color of the certificate shows how recent the screening was performed. ', 'El c\xF3digo est\xE1 contenido en el certificado y codificado en un c\xF3digo QR. El c\xF3digo puede ser verificado usando un sistema de validaci\xF3n que tambi\xE9n proporcionamos. Debido al algoritmo criptogr\xE1fico, es extremadamente dif\xEDcil obtener un c\xF3digo v\xE1lido si no es obtenido desde nuestro sistema. El color del certificado muestra hace cuanto tiempo se realiz\xF3 el cuestionario.'],
				third: ['Some certificates have a name or other identifier written on them. You can request such a named certificate using the STOP COVID Daily Symptom Screener. These certificates contain a different cryptographic code that both records the time as well as tied to the name or identifier. Each name or identifier is assigned a number between 1 and 10,000 and the code matches the specific number. These certificates can be validated the same way by either using a mobile device and scanning the QR code or going to the website verify.stopcovid19together.org. If someone modifies the name or identifier on the certificate, the number corresponding to the name will have a 99.99% chance of being different from the number of the original name which will make the certificate invalid. This prevents individuals from sharing symptom free certificates and ensures that they themselves completed the screening, further increasing the security of the system. To preserve privacy, the STOP COVID Daily Symptom Screener does not store the name or identifier in its database and the code itself only encodes the number between 1 and 10,000 and not the actual name or identifier.', 'Algunos certificados muestran un nombre o identificador. Usted puede pedir este nombre en el certificado, usando el Cuestionario Sin S\xEDntomas de STOP COVID. Estos certificados contienen un c\xF3digo criptogr\xE1fico diferente que recoge la hora y el nombre o identificador. Cada nombre o identificador est\xE1 asignado a un n\xFAmero entre 1 y 10,000 y el c\xF3digo est\xE1 vinculado al nombre. Estos certificados pueden verificarse de la misma forma, usando un m\xF3vil y escaneando el c\xF3digo QR o en la p\xE1gina web verify.stopcovid19together.org. Si alguien modifica el nombre o identificador en el certificado, el n\xFAmero vinculado al nombre tendr\xE1 un 99.99% de ser diferente al n\xFAmero original y el certificado es invalido. Este sistema previene compartir el certificado sin s\xEDntomas y asegura que cada uno ha completado el cuestionario personalmente, asegurando la seguridad del sistema. Para asegurar la privacidad, el Certificado Sin S\xEDntomas de STOP COVID,no guarda el nombre o identificador en su base de datos y el propio c\xF3digo contiene un n\xFAmero entre 1 y 10,000 y no el propio nombre o identificador.']
			}
		}
	},
	daily: {
		survey: {
			title: ['Daily Symptom Screener', 'Cuestionario Sintomatico'],
			disc: {
				first: [function (name) {
					return 'Welcome ' + name + ' (if you are not affiliated, <a href="/daily">click here</a>)';
				}, function (name) {
					return 'Bienvenido a ' + name + ' (si usted no est\xE1 afiliado, <a href="/daily">pinche aqu\xED</a>)';
				}],
				second: ['Daily symptom screening makes your workplaces safer and saves lives.', 'La evaluaci\xF3n diaria sintom\xE1tica de su hijo hace que los colegios sean un lugar seguro y salva vidas.'],
				third: ['At the end of the symptom screener, if you are symptom free, you will receive a link to a symptom free certificate. Click the link and save it on your phone or print out a copy.', 'Al final del cuestionario, si su hijo no padece ning\xFAn s\xEDntoma, recibir\xE1 un enlace con su certificado. Pinche aqu\xED y gu\xE1rdelo en su tel\xE9fono o impr\xEDmalo.'],
				fourth: ['By displaying the symptom free certificate, you are certifying that you used the STOP COVID Daily Symptom Screener and answered the symptom questions truthfully.', 'Mostrando su certificado, usted est\xE1 certificando que ha realizado el cuestionario sintom\xE1tico para ni\xF1os de Stop Covid y ha contestado con veracidad.'],
				fifth: ['If you wish to receive your screener results by email, register your email <a href="https://uclahs.az1.qualtrics.com/jfe/form/SV_80pR6gR6t0k60aF">here</a>.', 'Si usted desea recibir los resultados de la evaluaci\xF3n por correo electr\xF3nico, registre su correo electr\xF3nico <a href="https://uclahs.az1.qualtrics.com/jfe/form/SV_80pR6gR6t0k60aF">aqu\xED</a>.']
			},
			link: ['Click here to symptom screen', 'Pinche aqu\xED para el cuestionario']
		},
		instructions: {
			title: ['Using the Symptom Screener', 'Como usar el Cuestionario Sintom\xE1tico'],
			disc: {
				first: ['Daily symptom screening keeps us aware of our own health and provides a daily opportunity to self-identify COVID-19 symptoms.', 'La evaluaci\xF3n diaria de los s\xEDntomas nos hace ser conscientes de nuestra propia salud y proporciona una oportunidad diaria de identificar los s\xEDntomas de COVID-19 a nosotros mismos.'],
				second: ['Each morning, take the STOP COVID symptom screener and if you are symptom free, you will receive a link to a symptom free certificate that you can show as proof that you are symptom free. Save the link on your phone or print out a copy. A current certificate is blue and will change colors as it expires.', 'Haga el cuestionario sintom\xE1tico de STOP COVID cada ma\xF1ana y si no tuviera s\xEDntomas, recibir\xE1 un enlace con su certificado, que podr\xE1 mostrar como prueba. Guarde el enlace en su tel\xE9fono o impr\xEDmalo. El certificado actual es de color azul y cambiara de color en el momento que caduque.'],
				third: [function (name) {
					return 'If you report symptoms, you will be provided information specific to ' + name + ' as well as general public health guidance.';
				}, function (name) {
					return 'Si presentara s\xEDntomas en el cuestionario, ' + name + ', le dar\xE1 instrucciones sobre que hacer e incluso le informar\xE1 de las normas de salud p\xFAblica.';
				}],
				fourth: ['You will also have the option to put your name or other identifier on the certificate. Just enter your name or identifier in the box when getting your certificate.', 'Usted tiene tambi\xE9n la opci\xF3n de a\xF1adir su nombre o identificador en el certificado. Solo tendr\xE1 que a\xF1adirlo en la casilla correspondiente una vez reciba el certificado.'],
				fifth: ['If you wish to receive your symptom free completion certificate by email you can register your email using the link <a href="https://uclahs.az1.qualtrics.com/jfe/form/SV_80pR6gR6t0k60aF">here</a>.', 'Si usted desea recibir los resultados de la evaluaci\xF3n por correo electr\xF3nico, registre su correo electr\xF3nico <a href="https://uclahs.az1.qualtrics.com/jfe/form/SV_80pR6gR6t0k60aF">aqu\xED</a>.']
			}
		},
		certificates: {
			title: ['Symptom Free Certificates', 'Certificado Sin S\xEDntomas'],
			disc: {
				first: ['When you complete the screener and are symptom free, you will get a link to a symptom free certificate.', 'Cuando finalice el cuestionario y no presente s\xEDntomas, obtendr\xE1 un enlace de Certificado sin s\xEDntomas.'],
				second: ['Examples of certificates are shown below:', 'Estos son a continuaci\xF3n los ejemplos de certificados:'],
				third: ['The color of the certificate shows how recent the screening was performed. Blue signifies within 24 hours, yellow signifies within a week and red is older than one week. The certificate also displays the time that the screening was performed. The certificate is designed to be displayed on a mobile phone but can also be printed out.', 'El color de los certificados muestra hace cuanto tiempo se realiz\xF3 el cuestionario. Azul muestra que se realiz\xF3 en las \xFAltimas 24 horas, amarillo muestra que se realizo en la ultima semana, y rojo muestra que se hizo hace mas de una semana. El certificado muestra tambi\xE9n la hora en la que se realiz\xF3. El certificado est\xE1 dise\xF1ado para mostrarse en el movil/celular pero tambi\xE9n puede imprimirse.'],
				fourth: ['In addition, A name or other identifier can be displayed on the certificate. An example of a named symptom free certificate is shown below:', 'Tambi\xE9n podr\xE1 a\xF1adir en su certificado, su nombre o identificador, como se muestra a continuaci\xF3n:']
			}
		},
		verification: {
			title: ['Verifying Symptom Free Certificates', 'Como Verificar los Certificados Sin S\xEDntomas'],
			disc: {
				first: ['When examining a certificate, please check to see that the color is blue, the time is within 24 hours and the current time is the time that the certificate is visualized. After 24 hours, the color of the certificate turns to yellow and after a week it turns to red. On the certificate is a 16 character code which ensures that the certificate is valid and came from the system. This code can be validated by using the camera of a mobile device to scan the QR code on a certificate which will show if the code is valid. The code can also be verified by entering it on the website <a href="https://verify.stopcovid19together.org">verify.stopcovid19together.org</a>.', 'Cuando examine el certificado, por favor observe que el color sea Azul, la hora que muestra fue en las \xFAltimas 24 horas y la hora que muestra corresponde a la actual. Despues de 24 horas el certificado cambia a color amarillo y despues de una semana cambia a rojo. El certificado muestra un c\xF3digo de 16 d\xEDgitos que verifica que ha sido realizado por este sistema. Este c\xF3digo puede ser verificado utilizando la c\xE1mara del movil/celular escaneando el c\xF3digo QR de este certificado. El c\xF3digo tambi\xE9n puede ser verificado introduciendo el c\xF3digo en la siguiente p\xE1gina web: <a href="https://verify.stopcovid19together.org">verify.stopcovid19together.org</a>.']
			}
		},
		howTo: {
			title: ['How the STOP COVID Symptom Screener Works', 'C\xF3mo funciona el cuestionario de STOP COVID'],
			disc: {
				first: ['The STOP COVID symptom screener allows for anonymous symptom screening. In the system, we do not collect any identifying information. The symptom free certificate you receive contains a code, powered by cryptographic technology, that confirms the hour that the symptom screening was performed but provides no ability to obtain your identity.', 'El cuestionario de s\xEDntomas de STOP COVID permite el anonimato del cuestionario. En nuestro sistema, no recogemos datos identificativos. El certificado sin s\xEDntomas que recibe contiene un c\xF3digo generado por tecnolog\xEDa criptogr\xE1fica que confirma la hora en la que se realiz\xF3, sin recoger la identificaci\xF3n.'],
				second: ['The code is both written on the certificate and encoded in a QR code. The code can be verified to be authentic using a validation system we also provide. Because of the cryptographic algorithm, it is extremely difficult to obtain a valid code without getting it from our system. The color of the certificate shows how recent the screening was performed.', 'El c\xF3digo est\xE1 contenido en el certificado y codificado en un c\xF3digo QR. El c\xF3digo puede ser verificado usando un sistema de validaci\xF3n que tambi\xE9n proporcionamos. Debido al algoritmo criptogr\xE1fico, es extremadamente dif\xEDcil obtener un c\xF3digo v\xE1lido si no es obtenido desde nuestro sistema. El color del certificado muestra hace cuanto tiempo se realiz\xF3 el cuestionario.'],
				third: ['Some certificates have a name or other identifier written on them. You can request such a named certificate using the STOP COVID Daily Symptom Screener. These certificates contain a different cryptographic code that both records the time as well as tied to the name or identifier. Each name or identifier is assigned a number between 1 and 10,000 and the code matches the specific number. These certificates can be validated the same way by either using a mobile device and scanning the QR code or going to the website verify.stopcovid19together.org. If someone modifies the name or identifier on the certificate, the number corresponding to the name will have a 99.99% chance of being different from the number of the original name which will make the certificate invalid. This prevents individuals from sharing symptom free certificates and ensures that they themselves completed the screening, further increasing the security of the system. To preserve privacy, the STOP COVID Daily Symptom Screener does not store the name or identifier in its database and the code itself only encodes the number between 1 and 10,000 and not the actual name or identifier.', 'Algunos certificados muestran un nombre o identificador. Usted puede pedir este nombre en el certificado, usando el Cuestionario Sin S\xEDntomas de STOP COVID. Estos certificados contienen un c\xF3digo criptogr\xE1fico diferente que recoge la hora y el nombre o identificador. Cada nombre o identificador est\xE1 asignado a un n\xFAmero entre 1 y 10,000 y el c\xF3digo est\xE1 vinculado al nombre. Estos certificados pueden verificarse de la misma forma, usando un m\xF3vil y escaneando el c\xF3digo QR o en la p\xE1gina web verify.stopcovid19together.org. Si alguien modifica el nombre o identificador en el certificado, el n\xFAmero vinculado al nombre tendr\xE1 un 99.99% de ser diferente al n\xFAmero original y el certificado es invalido. Este sistema previene compartir el certificado sin s\xEDntomas y asegura que cada uno ha completado el cuestionario personalmente, asegurando la seguridad del sistema. Para asegurar la privacidad, el Certificado Sin S\xEDntomas de STOP COVID,no guarda el nombre o identificador en su base de datos y el propio c\xF3digo contiene un n\xFAmero entre 1 y 10,000 y no el propio nombre o identificador.']
			}
		},
		research: {
			title: ['STOP COVID Research Study', 'Estudio de investigaci\xF3n STOP COVID '],
			disc: {
				first: ['When symptom screening, you will have the option to join the STOP COVID research study. If you do, your symptom data (but not any identifying information) will be shared with researchers to help identify hotspots and predict COVID-19 outbreaks. If you do choose to join the research study, you will receive an email asking you additional questions to better understand the pandemic. Participation in the STOP COVID research study is voluntary and you can leave the study at any time. You are not required to participate in the research study to obtain a symptom free certificate.', 'Con la evaluaci\xF3n de s\xEDntomas, usted tiene la opci\xF3n de formar parte del estudio de investigaci\xF3n de STOP COVID. Si acepta formar parte, su informaci\xF3n sobre s\xEDntomas (totalmente an\xF3nima) ser\xE1 compartida con los investigadores para identificar los puntos de contagio y predecir nuevos puntos de contagio de Covid-19. Si decide formar parte del estudio, recibir\xE1 un correo electr\xF3nico para completar m\xE1s preguntas para entender mejor el comportamiento de la pandemia. La participaci\xF3n en el estudio STOP COVID es voluntaria y puede abandonar el estudio en cualquier momento. Usted no tiene que participar en el estudio para obtener el certificado.'],
				second: ['Please note, we cannot provide medical advice on this platform. Please follow the guidance of your local public health authorities and/or your health provider. For more information about this study, please visit our FAQ. For more information about UCLA Health\'s efforts on the coronavirus pandemic, visit the <a href="https://www.uclahealth.org/coronavirus">UCLA Health Coronavirus Information center</a>.', 'Por favor recuerde que no podemos proporcionar ning\xFAn consejo m\xE9dico en esta plataforma. Por favor siga las recomendaciones de las autoridades sanitarias locales y/o de su m\xE9dico. Para m\xE1s informaci\xF3n sobre el estudio, visite nuestra p\xE1gina de FAQ. Para m\xE1s informaci\xF3n sobre los esfuerzos sobre la pandemia del coronavirus de UCLA Health, visite <a href="https://www.uclahealth.org/coronavirus">UCLA Health Coronavirus Information center</a>.']
			}
		}
	}
};

function makeLang(node, ind) {
	if (Array.isArray(node)) {
		// is a text node
		return node[ind];
	}

	var obj = new Object();

	for (var key in node) {
		obj[key] = makeLang(node[key], ind);
	}

	return obj;
}

angular.module('app').factory('Lang', function () {
	return {
		init: function init(language, page) {
			// Return language mapping
			var lang_ind = langs[language];

			// console.log('Language', language);
			var mapping = makeLang(langmap[page], lang_ind);
			// console.log(mapping);
			return mapping;
		}
	};
});
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

angular.module('app').factory('OrgTable', function () {
	return {
		fetch: function fetch() {
			return $.get({
				type: 'GET',
				url: 'https://covidweb-assets.s3-us-west-2.amazonaws.com/public/orgs.tsv',
				dataType: "text"
			}).then(function (data) {
				var lookup = {};
				data.split('\n').slice(1).map(function (row) {
					var _row$split = row.split('\t'),
					    _row$split2 = _slicedToArray(_row$split, 5),
					    orgid = _row$split2[0],
					    orgname = _row$split2[1],
					    orgurl = _row$split2[2],
					    type = _row$split2[3],
					    logo = _row$split2[4];

					lookup[orgid] = {
						orgname: orgname,
						orgurl: orgurl,
						logo: logo,
						type: type
					};
				});
				return lookup;
			});
		}
	};
});
'use strict';

var app = angular.module("app");

app.service('apiService', ["$http", function ($http) {
    this.getCountiesList = function () {
        return $http.get('https://covidweb-assets.s3-us-west-2.amazonaws.com/public/hospital/counties.txt');
    };

    this.getCountiesJSON = function () {
        return $http.get('https://covidweb-assets.s3-us-west-2.amazonaws.com/public/hospital/counties.json');
    };

    /**
     * getGroceries and getPharmacies currently not being used. Using 'data' instead since it already exists. 
     */
    this.getGroceries = function () {
        return $http.get('https://covidweb-assets.s3-us-west-2.amazonaws.com/public/latest/grocery_los_angeles_v6.json');
    };

    this.getPharmacies = function () {
        return $http.get('https://covidweb-assets.s3-us-west-2.amazonaws.com/public/latest/pharmacies_v2.json');
    };
}]);
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var app = angular.module("app");

app.service('commonService', ['$filter', function ($filter) {
    var _this = this;

    this.isEmptyValue = function (d) {
        return d['pred_infection_rate'] === 'NA' || d['pred_infection_rate'] === -1 || d['count'] === 0 || d['count'] === -1;
    };

    this.kmToMiles = function (km) {
        return km / 1.6;
    };

    this.oneInN = function (d) {
        return '1 in ' + _this.percentToDivisor(d);
    };

    this.oneInNMostSig = function (d) {
        return '1 in ' + _this.shortenNumber(_this.roundMostSig(_this.percentToDivisor(d)));
    };

    this.roundup = function (v) {
        return Math.pow(10, Math.ceil(Math.log10(v)));
    };

    this.shortenNumber = function (n) {
        if (n < 1e3) return n;
        if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(1) + "K";
        if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(1) + "M";
        if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(1) + "B";
        if (n >= 1e12) return +(n / 1e12).toFixed(1) + "T";
    };

    this.roundMostSig = function (v) {
        var n = Math.pow(10, Math.floor(Math.log10(v)));
        return Math.round(v / n) * n;2;
    };

    this.haversine = function (lat1, lon1, lat2, lon2) {
        var unit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'km';

        // Math lib function names
        var _map = ['PI', 'asin', 'sin', 'cos', 'sqrt', 'pow', 'round'].map(function (k) {
            return Math[k];
        }),
            _map2 = _slicedToArray(_map, 7),
            pi = _map2[0],
            asin = _map2[1],
            sin = _map2[2],
            cos = _map2[3],
            sqrt = _map2[4],
            pow = _map2[5],
            round = _map2[6],
            _map3 = [lat1, lat2, lon1, lon2].map(function (x) {
            return x / 180 * pi;
        }),
            _map4 = _slicedToArray(_map3, 4),
            rlat1 = _map4[0],
            rlat2 = _map4[1],
            rlon1 = _map4[2],
            rlon2 = _map4[3],
            dLat = rlat2 - rlat1,
            dLon = rlon2 - rlon1,
            radius = 6372.8; // km

        // km


        var result = round(radius * 2 * asin(sqrt(pow(sin(dLat / 2), 2) + pow(sin(dLon / 2), 2) * cos(rlat1) * cos(rlat2))) * 100) / 100;

        if (unit == 'mi') {
            result = this.kmToMiles(result);
        }
        return result;
    };

    this.percentToDivisor = function (perc) {
        var divisor = 1 / perc;
        var roundedDivisor = (Math.ceil(divisor / 100) * 100).toFixed(0);
        return roundedDivisor;
    };

    this.binnedProximity = function (d) {
        if (d < 1) return 0;
        if (d < 5) return 1;
        return 2;
    };

    this.binnedProximityDisplay = function (bp) {
        return ['< 1 mi', '< 5 mi', '>= 5 mi'][bp];
    };

    this.numberWithCommas = function (n) {
        return n.toFixed(4).toLocaleString('en');
    };

    /**
     * Calculates list of average based on current day and x days before and after current day.
     * Also ignores -1.
     * @param {Object[]} list - List of numbers.
     * @param {number} x - Number of days before and after current day.
     * @return {Object[]} - Array of averages.
     */
    this.xDaysAverages = function (list, x) {
        var n = list.length;
        return list.map(function (e, i) {
            var sum = 0;
            var div = 0;
            for (var j = i - x; j < n && j <= i + x; j++) {
                if (j > 0 && list[j] != -1) {
                    sum += list[j];
                    div++;
                }
            }
            return sum / div;
        });
    };

    /**
     * Calculates average based on current day and x days before and after current day.
     * Also ignores -1.
     * @param {Object[]} list - List of numbers.
     * @param {number} x - Number of days before and after current day.
     * @return {number} - Average.
     */
    this.xDaysAverage = function (list) {
        var sum = 0;
        var div = 0;
        list.forEach(function (e) {
            if (e != -1) {
                sum += e;
                div++;
            }
        });
        return sum / div;
    };
}]);
'use strict';

var app = angular.module('app');

app.component('barcode', {
    templateUrl: 'components/barcode/barcode.html',
    controller: ["$scope", function controller($scope) {
        $scope.barcode = "";
        var barcodePicker = null;
        var license_key = "Ad7OM6uBP6H8RazjfyMtGog+ONxQFtA3V0UG4DlnI2aeQnRwkD4KeTQujvsHLQOVNWFWzmN5JgMsRW96mCR9OAVJXBZubWKzYWWephtY81QXVmT3UXZw40YGxU6+DvmYqRB59AMq06UlQxXHi3/KXzII1YpsDkH3auUGivhbv8qmURPeoqWQrmuY90F/QV5GANent1ffaJLB1HUei4K/9GuIjyLFV2xofzkPiA7gzSILI62tIGLgJCpTusWZZKcjhY/IkTVqqR4zOiwzGHHXJQmXzjKK1R9uR7XWFHPVoWebvtRVhR0quXRqsi2+9sVnXcgd5NT7CywccJQc4/sB51yWWG8b8GeIkoS682EkvzdzjVO+e1mvI7lbnuQYy4WZtrj7jni2JeSHOCzm6uZRNAQEVhZOJ9vgsieV7cbZwDw+NVzKvwbYgBiyhzYzuu6ikWTDywKm8LUuAEFiStNKrRvWBgjQKIapRy7eOF/ofSrzbs+n9JgWzadKUvcgudXg4RRFQ2H/SXdifLQkrt8Ft/p96BDlEDP/At61n3hC0n3JzM77khPZyWm6IB/LuxH2AAVZm2QPmZGG5Ob3VAa2yWCA98MWcMikN7l0zsI22aQZcquouPqkY8wRAHKs8YVwgQCYTxrk+OJc2Fr+GOe9hjDmxMwhowuzrTCssogEcZJDrApn+vTJ6SYIPVnhPYkwpZFmx+5CxgRoH9NtnZ3fa+KeNgD4WeOxyoRg/TX6PmmMrKuKFqZC7dLqYfCR9YMlvMMz7DOxWc+/1XPthVtqq+zikS+kZ5RAZAdLRCIRhEyyQ+mp9KXk45pSRT/f";

        var show = function show(arr) {
            $(".opt").hide();
            arr.forEach(function (e) {
                $(e).show();
            });
        };

        var stopCamera = function stopCamera() {
            if (barcodePicker != null) {
                barcodePicker.destroy();
                barcodePicker = null;
            }
        };

        $scope.startDecoding = function () {
            $(".spacer").css("height", $(".spacer").height() / 3 + 'px');
            $(".loading-done").hide();
            show([".barcode-scanner", ".loading"]);

            ScanditSDK.configure(license_key, {
                engineLocation: "https://cdn.jsdelivr.net/npm/scandit-sdk@5.x/build/"
            }).then(function () {
                return ScanditSDK.BarcodePicker.create(document.getElementById("scandit-barcode-picker"), {
                    scanSettings: new ScanditSDK.ScanSettings({ enabledSymbologies: ["code128"] })
                });
            }).then(function (bp) {
                barcodePicker = bp;
                bp.setMirrorImageEnabled(false);
                $(".loading").hide();
                $(".loading-done").show();
                barcodePicker.on("scan", function (scanResult) {
                    $scope.barcode = scanResult.barcodes[0].data;
                    $scope.$apply();
                    endDecoding();
                });
            });
        };

        var endDecoding = function endDecoding() {
            stopCamera();
            $(".spacer").css("height", $(".spacer").height() * 3 + 'px');
            show([".barcode-result"]);
        };

        $scope.resetDecoding = function () {
            stopCamera();
            var h = $(".spacer").height();
            if (h == 50) {
                $(".spacer").css("height", h * 3 + 'px');
            }
            show([".barcode-init"]);
        };

        $scope.startManualInput = function () {
            $scope.barcode = ""; //reset barcode
            show([".barcode-manual"]);
        };

        $scope.closeAbout = function () {
            $(".closeable-about").hide();
        };

        $scope.confirmBarcode = function () {
            var barcode1 = $("#barcode-input").val();
            var barcode2 = $("#barcode-input-verify").val();

            if (barcode1 != barcode2) {
                $("#err_msg").html("Barcodes must match");
            } else if (!barcode1 || !barcode2) {
                $("#err_msg").html("Barcodes cannot be empty");
            } else {
                $scope.barcode = barcode1;
                $scope.redirectToRegistration();
            }
        };

        $scope.redirectToRegistration = function () {
            var urlParams = new URLSearchParams(window.location.search);
            var provider = urlParams.get("testingProvider");
            var cohort = urlParams.get("cohort");

            location.replace('https://uclahs.az1.qualtrics.com/jfe/form/SV_eqEA4skEvxe5z49?barcode=' + $scope.barcode + '&testProvider=' + provider + '&cohort=' + cohort);
        };

        $scope.setURLParams = function () {
            var urlParams = new URLSearchParams(window.location.search);
            var url = new URL(window.location);
            var provider = urlParams.get("testingProvider");
            var cohort = urlParams.get("cohort");

            if (!provider) {
                provider = "UCLA_Swab-Seq_Lab_Testing";
            }
            if (!cohort) {
                cohort = "misc";
            }
            $scope.provider = provider;
            $scope.cohort = cohort;
            url.searchParams.set('testingProvider', provider);
            url.searchParams.set('cohort', cohort);

            window.history.pushState({}, '', url);
        };

        $scope.setURLParams();
        show([".barcode-init"]);
    }]
});
'use strict';

(function () {
	angular.module('app').component('botbar', {
		controllerAs: 'vm',
		templateUrl: 'components/botbar/botbar.html',
		controller: ["$scope", "$state", "$stateParams", function controller($scope, $state, $stateParams) {
			var vm = this;

			var _$state$params$lang = $state.params.lang,
			    lang = _$state$params$lang === undefined ? 'en' : _$state$params$lang;

			vm.showLang = lang;

			vm.showCookieMessage = false;

			vm.checkShowCookieMessage = function () {
				// console.log('Cookies', localStorage.getItem('cookieAccept'));
				var cookieAccept = localStorage.getItem('cookieAccept');
				if (cookieAccept == 'accept') {
					vm.showCookieMessage = false;
				} else {
					vm.showCookieMessage = true;
				}
			};

			vm.dismiss = function () {
				vm.showCookieMessage = false;
				localStorage.setItem('cookieAccept', 'accept');
			};

			vm.goHome = function () {
				if (lang != 'en') {
					$state.go('home', { lang: vm.showLang });
				} else {
					$state.go('home');
				}
			};

			vm.faqURL = function () {
				return lang != 'en' ? '/faq?lang=' + vm.showLang : '/faq';
			};
		}]
	});
})();
'use strict';

(function () {
	angular.module('app').component('daily', {
		controllerAs: 'vm',
		templateUrl: 'components/daily/daily.html',
		controller: ["$scope", "$state", "$stateParams", "Lang", "OrgTable", function controller($scope, $state, $stateParams, Lang, OrgTable) {
			var vm = this;

			var _$state$params$lang = $state.params.lang,
			    lang = _$state$params$lang === undefined ? 'en' : _$state$params$lang;

			vm.showLang = lang;
			vm.lang = Lang.init(lang, $state.$current.name);

			$scope.orgname = $state.params.orgname;
			$scope.orgurl = $state.params.orgurl;
			$scope.orglogo = $state.params.orglogo;

			OrgTable.fetch().then(function (table) {
				// console.log(table);
				if ($state.params.orgid && table[$state.params.orgid]) {
					var _table$$state$params$ = table[$state.params.orgid],
					    orgname = _table$$state$params$.orgname,
					    orgurl = _table$$state$params$.orgurl,
					    logo = _table$$state$params$.logo,
					    type = _table$$state$params$.type;

					$scope.orgname = orgname;
					$scope.orgurl = orgurl;
					$scope.orglogo = logo;
					$scope.orgtype = type;
					$scope.$apply();
				}
			}).catch(console.log);

			var baseURL = 'https://uclahs.az1.qualtrics.com/jfe/form/SV_aWDl6qM0JJpx8eV';
			vm.dailySurveyURL = function () {
				if ($scope.orgname) {
					return baseURL + '?organization_name=' + $scope.orgname + '&exit_link=' + $scope.orgurl + '&logo=' + $scope.orglogo + '&type=' + $scope.orgtype;
				} else {
					return baseURL;
				}
			};
		}]
	});
})();
'use strict';

(function () {
	angular.module('app').component('entry', {
		controllerAs: 'vm',
		templateUrl: 'components/entry/entry.html',
		controller: ["$state", "$stateParams", "User", function controller($state, $stateParams, User) {
			var vm = this;

			console.log('Load for survey:', $stateParams.surveyid);
		}]
	});
})();
'use strict';

(function () {
	angular.module('app').component('faq', {
		controllerAs: 'vm',
		templateUrl: 'components/faq/faq.html',
		controller: ["$scope", "$state", "$stateParams", "Lang", function controller($scope, $state, $stateParams, Lang) {
			var vm = this;

			var _$state$params$lang = $state.params.lang,
			    lang = _$state$params$lang === undefined ? 'en' : _$state$params$lang;

			console.log($state.params);
			vm.showLang = lang;
			vm.lang = Lang.init(lang, $state.$current.name);
		}]
	});
})();
'use strict';

(function () {
	angular.module('app').component('faqStudent', {
		controllerAs: 'vm',
		templateUrl: 'components/faq-student/faq-student.html',
		controller: ["$scope", "$state", "$stateParams", "Lang", function controller($scope, $state, $stateParams, Lang) {
			var vm = this;

			var _$state$params$lang = $state.params.lang,
			    lang = _$state$params$lang === undefined ? 'en' : _$state$params$lang;

			console.log($state.params);
			vm.showLang = lang;
			vm.lang = Lang.init(lang, $state.$current.name);
		}]
	});
})();
'use strict';

(function () {
	angular.module('app').component('hospital', {
		controllerAs: 'vm',
		templateUrl: 'components/hospital/hospital.html',
		controller: ["$scope", "$state", "$stateParams", "Lang", function controller($scope, $state, $stateParams, Lang) {
			var vm = this;
			vm.closeAbout = function () {
				$('.closeable-about').css('display', 'none');
			};

			// const { lang = 'en' } = $state.params;

			// vm.showLang = lang;
			// vm.lang = Lang.init(lang, $state.$current.name);


			// vm.initbar = () => {

			// }
		}]
	});
})();
"use strict";

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * TODOS:
 * - Refactor map options to simplify available option combinations. 
 * - Type doesn't seem like a sensible name for "per capita/count"
 * - A functional approach may be more efficient.
 * - Some events are triggered based on events. It appers some event/events are triggering functions to be ran multiple times. 
 *      - i.e. "updateTable in ngTable appears to be triggered mulitple times."
 * - Document or refactor plot logic.
 * - Refactor plot logic. Made quick fixes to support feature but probably very fragile.
 */

var app = angular.module("app");

/**
 * Get row based off query.
 * @param {Object[]} table - Psuedo table. Array of objects.
 * @param {Object.<string, *>} query - Query of key value pairs.
 * @return {Object.<string, *>} - Row object.
 */
function find_by(table, query) {
    return table.find(function (row) {
        return Object.entries(query).every(function (e) {
            return _.isEqual(row[e[0]], e[1]);
        });
    });
}

Array.prototype.find_by = function (query) {
    return find_by(this, query);
};

/**
 * Get rows based off query.
 * @param {Object[]} table - Psuedo table. Array of objects.
 * @param {Object.<string, *>} query - Query of key value pairs.
 * @return {Object[]} - Array of row objects.
 */
function where(table, query) {
    return table.filter(function (row) {
        return Object.entries(query).every(function (e) {
            if (Array.isArray(e[1])) {
                return e[1].includes(row[e[0]]);
            } else {
                return _.isEqual(row[e[0]], e[1]);
            }
        });
    });
}

Array.prototype.where = function (query) {
    return where(this, query);
};

/**
 * Get selected columns.
 * @param {Object[]} table - Psuedo table. Array of objects.
 * @param {Object[]]} columns - List of columns(keys).
 * @return {Object[]} - Array of row objects.
 */
function select(table, columns) {
    return table.map(function (row) {
        return _.pick(row, columns);
    });
}

Array.prototype.select = function (columns) {
    return select(this, columns);
};

app.component("map", {
    controllerAs: "vm",
    templateUrl: "components/map/map.html",
    controller: ["$scope", "$state", "Lang", "commonService", function controller($scope, $state, Lang, commonService) {
        var _$scope$mapOptions, _$scope$mapOptions2;

        var vm = this;

        var _$state$params$lang = $state.params.lang,
            lang = _$state$params$lang === undefined ? 'en' : _$state$params$lang;


        vm.lang = Lang.init(lang, 'map');

        var DATA_URLS = {
            country: "https://covidweb-assets.s3-us-west-2.amazonaws.com/public/latest/global_countries_geo_latest.json.gz",
            county: "https://covidweb-assets.s3-us-west-2.amazonaws.com/public/latest/us_counties_geo_latest.json.gz",
            states: "https://covidweb-assets.s3-us-west-2.amazonaws.com/public/latest/us_states_geo_latest.json.gz",
            city: "https://covidweb-assets.s3-us-west-2.amazonaws.com/public/latest/socal_cities_geo_latest.json.gz",
            us: "https://covidweb-assets.s3-us-west-2.amazonaws.com/public/latest/us_geo_latest.json.gz",
            shop: "https://covidweb-assets.s3-us-west-2.amazonaws.com/public/latest/grocery_los_angeles_v6.json",
            pharmacy: "https://covidweb-assets.s3-us-west-2.amazonaws.com/public/latest/pharmacies_v2.json"
        };

        var DAYS = 10;

        /**
         * SCOPES refers to a particular map.
         * The constant SCOPES contains prepopulated properties as well as placeholder properties to 
         * be populated by computing values from dataset.
         * This is an eager-loading approach to minimize recomputation when changing map options. 
         */
        var SCOPES = [{
            id: 0,
            name: 'country',
            display: 'All Nations',
            criteriaIds: [0, 1, 2, 3, 4, 5],
            timeline: true,
            layers: ['country', 'us']
        }, {
            id: 1,
            name: 'states',
            display: 'US States',
            criteriaIds: [0, 1, 2, 3, 4, 5],
            timeline: true,
            layers: ['country', 'states']
        }, {
            id: 2,
            name: 'county',
            display: 'US Counties',
            criteriaIds: [0, 1, 2, 3, 4, 5],
            timeline: true,
            layers: ['country', 'county'],
            criteriaSets: []
        }, {
            id: 3,
            name: 'city',
            display: 'US Cities',
            criteriaIds: [1, 2, 3, 4, 5],
            timeline: true,
            layers: ['country', 'city']
        }, {
            id: 4,
            name: 'shop',
            display: 'US Grocery Stores',
            criteriaIds: [],
            timeline: false,
            layers: ['country']
        }, {
            id: 5,
            name: 'pharmacy',
            display: 'US Pharmacy Stores',
            criteriaIds: [],
            timeline: false,
            layers: ['country']
        }];

        /**
         * CRITERIAS refers to a particular metric.
         * The constant CRITERIAS contains prepopulated properties as well as placeholder properties to 
         * be populated by computing values from dataset.
         * This is an eager-loading approach to minimize recomputation when changing map options. 
         */
        var CRITERIAS = [{
            id: 0,
            name: 'p_death',
            display: 'Deaths',
            ratio: 1,
            percent: false,
            inverted: false,
            intervals: [],
            timeline: true
        }, {
            id: 1,
            name: 'p_case',
            display: 'Total Cases',
            ratio: 1,
            percent: false,
            inverted: false,
            intervals: [],
            timeline: true
        }, {
            id: 2,
            name: 's_sympt',
            display: 'People with Symptoms',
            ratio: 100,
            percent: true,
            inverted: false,
            intervals: [],
            timeline: false
        }, {
            id: 3,
            name: 's_test',
            display: 'Tested People',
            ratio: 100,
            percent: true,
            inverted: true,
            intervals: [],
            timeline: false
        }, {
            id: 4,
            name: 's_dist',
            display: 'Physically Distancing',
            ratio: 100,
            percent: true,
            inverted: true,
            intervals: [],
            timeline: false
        }, {
            id: 5,
            name: 'n_p_case',
            display: 'New Cases',
            ratio: 1,
            percent: false,
            inverted: false,
            intervals: [],
            timeline: true
        }];

        /**
         * TYPES refers to a particular metric unit.
         */
        var TYPES = [{
            id: 0,
            name: 'per_capita',
            display: 'Per Capita'
        }, {
            id: 1,
            name: 'counts',
            display: 'Counts'
        }, {
            id: 2,
            name: 'percentage',
            display: 'Percentage'
        }];

        /**
         * SCOPE_CRITERIA_TYPE is a list that stores all valid map option combinations.
         * It can be thought of as a JOIN table. 
         */
        var SCOPE_CRITERIA_TYPE = [{
            scopeId: 0,
            criteriaId: 0,
            typeId: 0
        }, {
            scopeId: 0,
            criteriaId: 1,
            typeId: 0
        }, {
            scopeId: 0,
            criteriaId: 2,
            typeId: 2
        }, {
            scopeId: 0,
            criteriaId: 3,
            typeId: 2
        }, {
            scopeId: 0,
            criteriaId: 5,
            typeId: 0
        }, {
            scopeId: 0,
            criteriaId: 0,
            typeId: 1
        }, {
            scopeId: 0,
            criteriaId: 1,
            typeId: 1
        }, {
            scopeId: 0,
            criteriaId: 5,
            typeId: 1
        }, {
            scopeId: 1,
            criteriaId: 0,
            typeId: 0
        }, {
            scopeId: 1,
            criteriaId: 1,
            typeId: 0
        }, {
            scopeId: 1,
            criteriaId: 2,
            typeId: 2
        }, {
            scopeId: 1,
            criteriaId: 3,
            typeId: 2
        }, {
            scopeId: 1,
            criteriaId: 5,
            typeId: 0
        }, {
            scopeId: 1,
            criteriaId: 0,
            typeId: 1
        }, {
            scopeId: 1,
            criteriaId: 1,
            typeId: 1
        }, {
            scopeId: 1,
            criteriaId: 5,
            typeId: 1
        }, {
            scopeId: 2,
            criteriaId: 0,
            typeId: 0
        }, {
            scopeId: 2,
            criteriaId: 1,
            typeId: 0
        }, {
            scopeId: 2,
            criteriaId: 2,
            typeId: 0
        }, {
            scopeId: 2,
            criteriaId: 3,
            typeId: 0
        }, {
            scopeId: 2,
            criteriaId: 5,
            typeId: 0
        }, {
            scopeId: 2,
            criteriaId: 0,
            typeId: 1
        }, {
            scopeId: 2,
            criteriaId: 1,
            typeId: 1
        }, {
            scopeId: 2,
            criteriaId: 2,
            typeId: 1
        }, {
            scopeId: 2,
            criteriaId: 3,
            typeId: 1
        }, {
            scopeId: 2,
            criteriaId: 5,
            typeId: 1
        }, {
            scopeId: 3,
            criteriaId: 0,
            typeId: 1
        }, {
            scopeId: 3,
            criteriaId: 1,
            typeId: 1
        }, {
            scopeId: 3,
            criteriaId: 2,
            typeId: 2
        }, {
            scopeId: 3,
            criteriaId: 3,
            typeId: 2
        }, {
            scopeId: 3,
            criteriaId: 5,
            typeId: 1
        }];

        vm.currentScope;
        vm.currentCriteria;
        vm.dateIdx;
        vm.currentType = TYPES.find_by({ id: 0 });

        vm.ziperror = false;
        vm.laError = false;
        vm.showPredInfo = false;

        $scope.place;
        vm.currentLocationData = [];
        $scope.plotOption_idx = 0;
        //0 = death, 1 = confirmed cases
        //variables for mobile maps
        $scope.isFullSizeMap = false;
        $scope.isLeftBarOpen = false;
        $scope.zoomLevel = null;
        $scope.lowStoreData = 10;
        //needs for showing map
        vm.isMapLoading = true;
        //Scope all data about chosen intervals
        vm.gradientBarData = {};

        var _vm$lang$popup = vm.lang.popup,
            publicLang = _vm$lang$popup.public,
            surveyLang = _vm$lang$popup.survey;

        vm.plotOptions = [publicLang.p_case, publicLang.p_death, publicLang.predictions];

        var plotLabels = [publicLang.p_case, "Confirmed Cases (Upper)", "Confirmed Cases (Down)", "New York", "Los Angeles"];

        var viewOptions = [[2, { lat: 24.37, lng: -10.44 }], // 0, country view
        [4, { lat: 39.0, lng: -98.4 }], // 1, usa view
        [5, { lat: 39.0, lng: -98.4 }], // 2, usa view
        [10, { lat: 34.063502, lng: -118.445516 }], // 3, LA view
        [11, { lat: 34.063502, lng: -118.445516 }], // 4, shop view
        [11, { lat: 34.063502, lng: -118.445516 }] // 5, pharmacy view
        ];

        /**
         * List of type options based on current scope and criteria.
         * @param {Object.<string, *>} scope - Scope object.
         * @param {Object.<string, *>} criteria - Criteria obj.
         * @return {Object[]} - List of type options.
         */
        function getTypeOptions(scope, criteria) {
            if (scope && criteria) {
                var typeIds = SCOPE_CRITERIA_TYPE.where({ scopeId: scope.id, criteriaId: criteria.id }).select('typeId').map(function (r) {
                    return r.typeId;
                });
                return TYPES.where({ id: typeIds });
            }
            return [];
        }

        /**
         * Checks whether scope/criteria combination support timeline features.
         * @param {Object.<string, *>} scope - Scope object.
         * @param {Object.<string, *>} criteria - Criteria obj.
         * @return {boolean} - Timeline support.
         */
        vm.timelineSupport = function (scope, criteria) {
            return !!scope && !!criteria && scope.timeline && criteria.timeline;
        };

        /**
         * Generate all metadata for map.
         * @param {Object.[]} scopes - List of Scope objects.
         * @return {void} - Nothing.
         */
        function generateAllMetaData(scopes) {
            scopes.forEach(function (scope) {
                generateMetaData(scope);
            });
        }

        /**
         * Generates metadata for particular scope.
         * @param {Object.<string, *>} scope - Scope object.
         * @return {void} - Nothing.
         */
        function generateMetaData(scope) {
            var criteriaSet = generateCriteriaSet(scope);
            scope.criteriaSet = criteriaSet;
        }

        /**
         * Generates criteria set for a perticular date.
         * @param {Object.<string, *>} scope - Scope object
         * @param {number} dateIdx - Index of date.
         * @return {Object.<string, *>} - Criteria set.
         */
        function generateCriteriaSet(scope) {
            var result = {};
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = CRITERIAS.where({ id: scope.criteriaIds })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var criteria = _step.value;
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = getTypeOptions(scope, criteria)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var type = _step2.value;

                            if (criteria.timeline) {
                                if (!result.hasOwnProperty(type.name)) {
                                    result[type.name] = {};
                                }
                                result[type.name][criteria.name] = generateCriteria(scope, criteria, type);
                            }
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return result;
        }

        /**
         * Generates criteria object by date
         * @param {Object.<string, *>} scope - Scope object.
         * @param {Object.<string, *>} criteria - Default criteria object.
         * @param {Object.<string, *>} type - Type object.
         * @return {Object.<string, *>} - Criteria object.
         */
        function generateCriteria(scope, criteria, type) {
            var result = angular.copy(criteria);
            var dataset = data[scope.name].data;

            var criteriaWithTime = criteria.name + "_time";

            var proxyDataset = dataset.map(function (e) {
                var obj = _.pick(e, ['pop']);
                // Forces value to be at least 0 even if negative.
                obj[criteriaWithTime] = commonService.xDaysAverages(e[criteriaWithTime].slice(0, vm.first_pred_date_idx), DAYS).map(function (ee) {
                    return Math.max(ee, 0);
                });
                return obj;
            });

            // Get min and max statistical values
            var min = undefined;
            var max = undefined;

            proxyDataset.forEach(function (e, i) {
                e[criteriaWithTime].forEach(function (ee, j) {
                    if (ee > 0) {
                        var value = ee * result.ratio;
                        if (type.id == 0) {
                            value = value / e.pop;
                        }
                        if (value <= min || min === undefined) {
                            min = value;
                        }
                        if (value >= max || max === undefined) {
                            max = value;
                        }
                    }
                });
            });

            if (!min) {
                min = 1;
            }
            if (!max) {
                max = 1;
            }

            var logMin = Math.log(min);
            var logMax = Math.log(max);
            var scale = (logMax - logMin) / 9;

            // Create intervals array
            // let step = (max - min) / 10;
            var intervals = [];
            for (var i = 0; i <= 8; i++) {
                var start = Math.exp(logMin + scale * i);
                var end = Math.exp(logMin + scale * i + scale);
                intervals[i] = {
                    // start: i === 0 ? Math.round(min + (i * step)) : Math.round(min + (i * step)),
                    // end: Math.round(min + (i * step) + step),
                    start: start,
                    end: end,
                    amount: 0
                };
            }

            // Update intervals according to values mode
            proxyDataset.forEach(function (e, i) {
                e[criteriaWithTime].forEach(function (ee, j) {
                    var value = ee * result.ratio;
                    value = value < 0 ? 0 : value;
                    for (var _i = 0; _i < intervals.length; _i++) {
                        if (value >= intervals[_i].start && value < intervals[_i].end) {
                            intervals[_i].amount++;
                            break;
                        }
                    }
                });
            });

            result.intervals = intervals;
            return result;
        }

        /**
         * Updates current scope and all related data/options. i.e.
         *  - Criteria options
         *  - Current Criteria
         *  - Date info.
         * @param {number} id - Scope ID.
         * @return {void} - Nothing.
         */
        function updateCurrentScope(id) {
            vm.currentScope = SCOPES.find_by({ id: id });
            vm.criteriaOptions = CRITERIAS.where({ id: vm.currentScope.criteriaIds }).select(['id', 'display']);

            if (_.isEmpty(vm.currentScope.criteriaIds)) {
                vm.currentCriteria = null;
            } else {
                vm.currentCriteria = vm.currentCriteria == null ? CRITERIAS.find_by({ id: 5 }) : vm.currentCriteria;
            }
            vm.currentType = vm.currentType == null ? TYPES.find_by({ id: 0 }) : vm.currentType;

            if (vm.currentCriteria && !vm.currentScope.criteriaIds.includes(vm.currentCriteria.id)) {
                vm.currentCriteria = CRITERIAS.find_by({ id: vm.criteriaOptions[0].id });
            }

            vm.typeOptions = getTypeOptions(vm.currentScope, vm.currentCriteria);
            if (!vm.typeOptions.find_by({ id: vm.currentType.id })) {
                vm.currentType = _.isEmpty(vm.typeOptions) ? null : vm.typeOptions[0];
            }

            updateDateInfo(vm.currentScope);
        }

        /**
         * Update date related info based on current scope. i.e.
         *  - Dates
         *  - first_pred_date
         *  - last_date_idx
         * @param {Object.<string, *>} scope - Scope object.
         * @return {void} - Nothing.
         */
        function updateDateInfo(scope) {
            vm.dates = data[scope.name].dates;
            vm.first_pred_date = data[scope.name].first_pred_date;
            vm.first_pred_date_idx = vm.dates ? vm.dates.indexOf(vm.first_pred_date) : null;
            vm.last_date_idx = vm.first_pred_date_idx ? vm.first_pred_date_idx - 1 : null;
        }

        /**
         * Generate gradient bar. 
         * @param {Object.<string, *>} scope - Scope object.
         * @param {Object.<string, *>} criteria - Criteria object.
         * @param {Object.<string, *>} type - Type object.
         * @param {number} dateIdx - Index of date.
         * @return {void} - Nothing.
         */
        function getGradientBar(scope, criteria, type) {
            var dateIdx = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

            var timeline = vm.timelineSupport(scope, criteria) && dateIdx !== null;
            var criteriaObj = scope.criteriaSet[type.name][criteria.name];
            var intervals = criteriaObj.intervals;

            if (criteriaObj.inverted) {
                intervals.reverse();
            }

            // Create gradient blocks with data
            var gradientArray = intervals && intervals.map(function (interval, i) {
                var opacity = getIntervalColorOpacity(i, intervals);
                var value = void 0;
                if (type.id == 0) {
                    value = commonService.oneInNMostSig(interval.start);
                } else {
                    value = criteriaObj.percent === true ? shortenNumber(Math.round(interval.start * 10) / 10) : shortenNumber(Math.floor(interval.start));
                }
                if (criteriaObj.percent === true) {
                    value = value + '%';
                }
                if (i === intervals.length - 1) {
                    if (criteriaObj.inverted === false) {
                        value = value + ' +';
                    } else {
                        value = '< ' + value;
                    }
                }
                if (i === 0 && criteriaObj.inverted === true) {
                    value = value + ' +';
                }
                return {
                    interval: value,
                    color: 'rgba(255, 0, 0, ' + opacity + ')'
                };
            }).reverse();
            setTimeout(function () {
                vm.gradientBarData = gradientArray;
                $scope.$apply();
            }, 0);
        };

        //for getting last day/week
        $scope.getLastCases = function (data, dates, daysCount, removeThisValue) {
            if (!data || data.length == 0) return 'N/A';
            var casesValues = [].concat(_toConsumableArray(data));

            //Needs to remove this in the future
            var dayIndex = casesValues.findIndex(function (value) {
                return value === removeThisValue;
            });

            // //Geting current date
            // const today = new Date();
            // const formatedToday = (today.getMonth()+1)+'/' + today.getDate()+'/' + today.getFullYear().toString().substr(-2);
            // //Geting index of the current fdate for calculating
            // const currentDayIndex = casesDates.findIndex(date => date === formatedToday)
            // //Cutting array for chosen period
            // const cuttedCaseData = casesValues.splice((currentDayIndex) - daysCount, daysCount);
            // //Sum all cases for chosen period
            // let casesSum = 0;
            // cuttedCaseData.map(item => casesSum += Math.round(item));

            var cuttedCaseData = casesValues.splice(dayIndex - daysCount, daysCount);

            return '+' + Math.round(removeThisValue - cuttedCaseData[0]);
        };

        $scope.isShowCasesInfo = false;
        $scope.showMoreCasesInfo = function () {
            $scope.isShowCasesInfo = !$scope.isShowCasesInfo;
        };

        // map fullscreen checks
        document.onfullscreenchange = function (event) {
            // move google maps search dropdown when map is fullscreen
            var target = document.getElementsByClassName("search-block")[0];
            var pacContainerElements = document.getElementsByClassName("pac-container");
            if (pacContainerElements.length > 0) {
                var pacContainer = document.getElementsByClassName("pac-container")[0];
                if (pacContainer.parentElement === target) {
                    document.getElementsByTagName("body")[0].appendChild(pacContainer);
                } else {
                    target.appendChild(pacContainer);
                }
            }
        };

        // for bugfix, when fullscreen map broking after unblocking phone
        $(window).on("blur focus", function (e) {
            var prevType = $(this).data("prevType");
            if (window.innerHeight !== screen.height && $scope.isFullSizeMap === true) {
                var element = document.getElementById("mobile-nav");
                element.classList.add("unvisible");
            }
            if (prevType != e.type) {
                //  reduce double fire issues
                switch (e.type) {
                    case "blur":
                        // do work
                        break;
                    case "focus":
                        // do work
                        break;
                }
            }

            $(this).data("prevType", e.type);
        });

        //share to Twitter
        $scope.shareTwitter = function () {
            var url = "http://stopcovid19together.org";
            var text = "STOP COVID-19 TOGETHER! We at UCLA need your help to learn about the spread of the virus, in order to find effective ways to fight it. Please help us by filling out the survey at https://stopcovid19together.org/ #stopcovid19together via @CompMedUCLA";
            window.open('http://twitter.com/share?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(text), '', 'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0');
        };

        //Needs for share button, copy site url for sharing
        $scope.copyLinkText = "Copy link";
        $scope.copyLink = function () {
            navigator.clipboard.writeText('stopcovid19together.org').then(function () {
                $scope.copyLinkText = "Copied!";
                $scope.$apply();
                setTimeout(function () {
                    $scope.copyLinkText = "Copy link";
                    $scope.$apply();
                }, 3000);
            }, function (err) {
                console.error('Async: Could not copy text: ', err);
            });
        };

        var isShop = function isShop(scopeid) {
            return scopeid === 4 || scopeid === 5;
        };

        var shortenNumber = function shortenNumber(n) {
            if (n < 1e3) return n;
            if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(1) + "K";
            if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(1) + "M";
            if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(1) + "B";
            if (n >= 1e12) return +(n / 1e12).toFixed(1) + "T";
        };

        var filterLastMonth = function filterLastMonth(current_case, range1Count, range2Count) {
            var lenCase = current_case.length;
            current_case = current_case.slice(lenCase - range1Count, lenCase - range2Count);
            return current_case;
        };

        var getLastMonth = function getLastMonth(d, postfix, buttonIndex, range1Count, range2Count) {
            var percentage = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;

            var current_case = d[plotOption[buttonIndex] + postfix];
            if (current_case !== null && current_case !== undefined) {
                current_case = filterLastMonth(current_case, range1Count, range2Count);
                if (percentage) {
                    current_case.forEach(function (e, i) {
                        return current_case[i] = e / d['pop'];
                    });
                }
            }
            return current_case;
        };

        //Needs for changing data when the chart's tabs was changed
        var casesSwitcher = function casesSwitcher(arr) {
            var index = arr[0];
            var cases = arr[1] ? arr[1] : [];
            var death = arr[2] ? arr[2] : [];
            var predictions = arr[3] ? arr[3] : [];
            return index == 0 ? [].concat(_toConsumableArray(cases)) : index == 1 ? [].concat(_toConsumableArray(death)) : [].concat(_toConsumableArray(predictions));
        };
        //Getting data for current chat's tab
        $scope.getChartData = _.memoize(function (arr) {
            var data = casesSwitcher(arr);
            return [data[0], data[1], data[2], data[3], data[4]];
        });
        //Getting labels for current chat's tab
        $scope.getChartLabels = _.memoize(function (arr) {
            var data = casesSwitcher(arr);
            return data[5];
        });
        //Getting override variables for current chat's tab
        $scope.getChartDatasetOveride = _.memoize(function (arr) {
            var data = casesSwitcher(arr);
            return data[6];
        });

        //Generates data for lower and upper chart's fills
        var convertDatasetOverride = function convertDatasetOverride(plt_upper, plt_lower, buffer, index) {
            var dataSet = [{
                label: "Confirmed",
                type: "line",
                borderColor: 'rgb(255,0,0)',
                fill: false,
                pointRadius: 1,
                showLine: true,
                pointBorderColor: 'rgb(255,0,0)',
                borderWidth: 1,
                pointBackgroundColor: 'rgb(255,0,0)'
            }, {
                label: "Upper Confidence Level",
                type: "line",
                fillBetweenSet: 1,
                fillBetweenColor: 'rgb(255,255,0, 0.4)',
                pointRadius: 0,
                showLine: false,
                pointBackgroundColor: 'rgb(255,255,0)'
            }, {
                label: "Lower Confidence Level",
                type: "line",
                fillBetweenSet: 1,
                fillBetweenColor: 'rgb(255,255,0, 0.4)',
                pointRadius: 0,
                showLine: false,
                pointBackgroundColor: 'rgb(255,255,0)'
            }];
            var test = ["a", "b", "c"];
            console.log('index- ' + index);

            //Needs for cities lines on the chart
            additionalCasesMetadata.forEach(function (metadata) {
                var item = {
                    label: metadata.label,
                    type: "line",
                    borderColor: metadata.color,
                    fill: false,
                    pointRadius: 1,
                    showLine: true,
                    pointBorderColor: metadata.color,
                    pointBackgroundColor: metadata.color,
                    borderWidth: 1
                };
                dataSet.push(item);
            });

            // Show/hide high/low lines on the chart
            if (plt_upper.length == 0 || plt_lower.length == 0) {
                dataSet[1]['hidden'] = true;
                dataSet[2]['hidden'] = true;
                plt_upper = buffer;
                plt_lower = buffer;
            } else {
                dataSet[1]['hidden'] = false;
                dataSet[2]['hidden'] = false;
            }

            dataSet[0].label = vm.plotOptions[index];
            return dataSet;
        };

        $scope.showCityLine = function (additionalCaseCheckbox, additionalCases, locationName) {
            additionalCaseCheckbox.checked = !additionalCaseCheckbox.checked;
            refreshPlot($scope.place, "city", additionalCases);

            setTimeout(function () {
                scrollTo(locationName);
            }, 0);
        };

        var additionalCasesMetadata = [{
            "ID": "New York City, New York, US",
            showName: "New York City",
            label: "Confirmed New York",
            color: 'rgb(0,127,255)',
            checked: true,
            plotIndex: 3,
            index: 0,
            geomertry: [[-73.785964, 40.800862], [-73.912506, 40.79618], [-73.933408, 40.882075], [-73.917905, 40.917577], [-73.783545, 40.88104], [-73.785964, 40.800862]] // there are many area with this ID
        }, {
            "ID": "Los Angeles, California, US",
            showName: "Los Angeles",
            label: "Confirmed Los-Angeles",
            color: 'rgb(255,255,255)',
            checked: true,
            plotIndex: 4,
            index: 1,
            geomertry: [[-118.881364, 34.790629], [-118.854253, 34.817772], [-117.667292, 34.822526], [-117.650459, 34.339025], [-117.711067, 34.079536], [-117.783287, 33.946411], [-117.97653, 33.928034], [-118.116703, 33.743549], [-118.258687, 33.703741], [-118.411211, 33.741985], [-118.392107, 33.840915], [-118.519514, 34.027509], [-118.944887, 34.04534], [-118.788889, 34.168214], [-118.668152, 34.168195], [-118.636789, 34.291804], [-118.881364, 34.790629]]
        }];

        var getMetadataByPlotIndex = function getMetadataByPlotIndex(plotIndex) {
            return additionalCasesMetadata.filter(function (x) {
                return x['plotIndex'] === plotIndex;
            })[0];
        };

        var geometryEpsilon = 0.0001;

        var equal = function equal(x, y) {
            return Math.abs(x - y) < geometryEpsilon;
        };

        var pairsAreEqual = function pairsAreEqual(x, y) {
            return equal(x[0], y[0]) && equal(x[1], y[1]);
        };

        var arraysAreEqual = function arraysAreEqual(a, b) {
            if (a.length !== b.length) return false;

            for (var i = 0; i < a.length; i++) {
                if (pairsAreEqual(a[i], b[i]) === false) return false;
            }return true;
        };

        var getDateByValueFromPlot = function getDateByValueFromPlot(value, item) {
            var city = mapToPlotAdditionalCases(item);
            var index = city.p_case_time.findIndex(function (x) {
                return x === value;
            });
            return data['county']['dates'][index];
        };

        var mapToPlotAdditionalCases = function mapToPlotAdditionalCases(item) {
            var filtered = data['county']['data'].filter(function (x) {
                return x['ID'] === item['ID'];
            }).filter(function (x) {
                var t1 = x['geometry']['coordinates'][0];
                var t2 = item['geomertry'];
                var isEqual = arraysAreEqual(t1, t2);
                return isEqual;
            });

            if (filtered.length !== 1) {
                console.log("Item with ID: " + item['ID'] + " not found");
                return null;
            }
            return filtered[0];
        };

        var getIntersectionPoint = function getIntersectionPoint(arr, intersectionPoint) {
            for (var i = 0; i < arr.length; i++) {
                if (arr[i] >= intersectionPoint) return i - 1;
            }
        };

        var daysBefore = 7;

        var getPlotAdditionalCases = function getPlotAdditionalCases(metadata, intersectionPoint, initialArray) {
            if (metadata.checked === false) return [];

            var mapped = mapToPlotAdditionalCases(metadata);
            var metric_per_capita = mapped['p_case_time'].map(function (d) {
                return d / mapped['pop'];
            });

            var p1 = getIntersectionPoint(metric_per_capita, intersectionPoint);
            var result = metric_per_capita.slice(p1 - monthDays + daysBefore, p1 + daysBefore);

            for (var i = 0; i <= initialArray.length - daysBefore; i++) {
                result[i] = initialArray[i];
                result[i] = initialArray[i];
            }

            return result;
        };

        var monthDays = 30 - 1;

        //Build all data for each popup.
        // plt_case_raw && plt_upper_raw is a hack to get percentages to work. Logic to find -1 doesn't work after converting to percentages.
        var convertChartData = function convertChartData(d, type, buttonIndex, additionalCases) {
            var percentage = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

            var range1Count = monthDays * 2;
            var range2Count = monthDays;

            if (buttonIndex === 2) {
                var range1Count = monthDays;
                var range2Count = 0;
                buttonIndex = 0;
            }

            var plt_case = getLastMonth(d, '_time', buttonIndex, range1Count, range2Count, percentage);
            var plt_case_raw = !percentage ? plt_case : getLastMonth(d, '_time', buttonIndex, range1Count, range2Count, false);
            var plt_upper = getLastMonth(d, '_upper', buttonIndex, range1Count, range2Count, percentage);
            var plt_upper_raw = !percentage ? plt_upper : getLastMonth(d, '_upper', buttonIndex, range1Count, range2Count, false);
            var plt_lower = getLastMonth(d, '_lower', buttonIndex, range1Count, range2Count, percentage);

            if (plt_case === null) return [[]];

            // get intersection point N days before
            var intersectionPoint = filterLastMonth(plt_case, daysBefore, 0)[0];

            var plt_case1 = getPlotAdditionalCases(additionalCases[0], intersectionPoint, plt_case);
            var plt_case2 = getPlotAdditionalCases(additionalCases[1], intersectionPoint, plt_case);

            var plt_dates = type === 'shop' ? [] : data[type]['dates'].slice();
            plt_dates = filterLastMonth(plt_dates, range1Count, range2Count);
            // Generates elements with 0, if array is empty
            var buffer = Array.apply(null, new Array(plt_dates.length)).map(Number.prototype.valueOf, 0);

            //Change all values to 0
            if (plt_case == null) {
                plt_case = buffer;
            }
            if (plt_case_raw == null) {
                plt_case_raw = buffer;
            }
            //Change all values to 0
            if (plt_upper == null || plt_lower == null) {
                plt_upper = buffer;
                plt_lower = buffer;
            }
            if (plt_upper_raw == null) {
                plt_upper_raw = buffer;
            }

            //Gets lower and upper chart's options
            var datasetOverride = convertDatasetOverride(plt_upper, plt_lower, buffer, buttonIndex);

            //Generating a full data for the chart
            var plt_data = [plt_case.slice(), plt_upper.slice(), plt_lower.slice(), plt_case1, plt_case2, plt_dates, datasetOverride];

            var i = 0;
            //dunno about this
            var cutOff = true;
            //if we will find an element with value -1, then we will cut this element from all arrays
            while (i != plt_case_raw.length) {
                if (plt_case_raw[i] > -1) {
                    cutOff = false;
                }
                if (plt_case_raw[i] == -1 || cutOff) {
                    plt_case_raw.splice(i, 1);
                    plt_upper_raw.splice(i, 1);

                    plt_data[0].splice(i, 1);
                    plt_data[1].splice(i, 1);
                    plt_data[2].splice(i, 1);
                    plt_data[3].splice(i, 1);
                    // TODO: add dynamic behavior
                    plt_data[4].splice(i, 1);
                    plt_data[5].splice(i, 1);
                } else {
                    i++;
                }
            }
            ///if we will find an element with value -1 in second array, then we will copy this element from first array
            for (var i = 0; i < plt_upper_raw.length; i++) {
                if (plt_upper_raw[i] == -1) {
                    plt_upper_raw[i] = plt_case_raw[i];

                    plt_data[1][i] = plt_data[0][i];
                    plt_data[2][i] = plt_data[0][i];
                }
            }

            return plt_data;
        };

        var getNewAdditionalCases = function getNewAdditionalCases() {
            return additionalCasesMetadata.map(function (x) {
                return Object.assign({}, x);
            });
        };

        //0 = country, 1 = states, 2 = counties, 3 = cities

        /**
         * Refreshes plot (map popup).
         * @param {Object.<string, *>} d - data object.
         * @param {String} type - Argument loosely associated with layers. TODO: Should standardize this meaning.
         * @param {?} additionalCases - ?.
         * @return {void} - Nothing.
         */
        var refreshPlot = function refreshPlot(d, type, additionalCases) {
            //Fill curent location fields
            function generateLocationObject(dateIdx) {
                var obj = void 0;
                if (dateIdx != null) {
                    switch (type) {
                        case 'shop':
                            obj = {
                                name: d['name'],
                                city: d['city'],
                                percentage: isEmptyValue(d) ? 'N/A' : commonService.oneInN(d['pred_infection_rate']),
                                //(d['pred_infection_rate']*100 >= 2 ? '> 2.00%' : (d['pred_infection_rate']*100 < 0.01 ? '< 0.01%': (d['pred_infection_rate']*100).toFixed(2) + "%")),
                                // percentage: isEmptyValue(d) ? 'N/A' :  (Math.round(((d['pred_infection_rate'] * 100) + Number.EPSILON) * 100) / 100) + "%",
                                sympt: d['count'], //isEmptyValue(d)  ? 'N/A' : Math.round(d['count'] * d['pred_infection_rate']),
                                ask: d['count'] < $scope.lowStoreData ? 1 : 0,
                                address: d['address'],
                                empty: false,
                                isShop: true
                            };
                            break;
                        case 'city':
                            obj = {
                                name: d['ID'],
                                totalCases: d['p_case_time'][dateIdx],
                                death: -1,
                                sympt: d['s_sympt'] === 0 ? 0 : Math.floor(d['s_sympt'] * 100),
                                ask: d['count'] < $scope.lowStoreData ? 1 : 0,
                                test: d['s_test'] === 0 ? 0 : Math.floor(d['s_test'] * 100),
                                dist: d['s_dist'] === 0 ? 0 : Math.floor(d['s_dist'] * 100),
                                additionalCases: additionalCases,
                                empty: false,
                                isShop: false,
                                casesData: convertChartData(d, type, 0, additionalCases, false),
                                deathData: convertChartData(d, type, 1, additionalCases, false),
                                casesDataPercentage: convertChartData(d, type, 0, additionalCases),
                                deathDataPercentage: convertChartData(d, type, 1, additionalCases),
                                predictions: convertChartData(d, type, 2, additionalCases),
                                model: d['model']
                            };
                            break;
                        default:
                            obj = {
                                name: d['ID'],
                                confirmedCases: commonService.oneInN(d['p_case_time'][dateIdx] / d['pop']),
                                totalCases: d['p_case_time'][dateIdx],
                                death: d['p_death'],
                                sympt: d['s_sympt'] === 0 ? 0 : Math.floor(d['s_sympt'] * 100),
                                ask: d['count'] < $scope.lowStoreData ? 1 : 0,
                                test: d['s_test'] === 0 ? 0 : Math.floor(d['s_test'] * 100),
                                dist: d['s_dist'] === 0 ? 0 : Math.floor(d['s_dist'] * 100),
                                additionalCases: additionalCases,
                                empty: false,
                                isShop: false,
                                casesData: convertChartData(d, type, 0, additionalCases, false),
                                deathData: convertChartData(d, type, 1, additionalCases, false),
                                casesDataPercentage: convertChartData(d, type, 0, additionalCases),
                                deathDataPercentage: convertChartData(d, type, 1, additionalCases),
                                predictions: convertChartData(d, type, 2, additionalCases),
                                model: d['model']
                            };
                    }
                } else {
                    switch (type) {
                        case 'shop':
                            obj = {
                                name: d['name'],
                                city: d['city'],
                                percentage: isEmptyValue(d) ? 'N/A' : commonService.oneInN(d['pred_infection_rate']),
                                //(d['pred_infection_rate']*100 >= 2 ? '> 2.00%' : (d['pred_infection_rate']*100 < 0.01 ? '< 0.01%': (d['pred_infection_rate']*100).toFixed(2) + "%")),
                                // percentage: isEmptyValue(d) ? 'N/A' :  (Math.round(((d['pred_infection_rate'] * 100) + Number.EPSILON) * 100) / 100) + "%",
                                sympt: d['count'], //isEmptyValue(d)  ? 'N/A' : Math.round(d['count'] * d['pred_infection_rate']),
                                ask: d['count'] < $scope.lowStoreData ? 1 : 0,
                                address: d['address'],
                                empty: false,
                                isShop: true
                            };
                            break;
                        default:
                            obj = {
                                name: d['ID'],
                                confirmedCases: commonService.oneInN(d['p_case'] / d['pop']),
                                totalCases: d['p_case'],
                                death: d['p_death'],
                                sympt: d['s_sympt'] === 0 ? 0 : Math.floor(d['s_sympt'] * 100),
                                ask: d['count'] < $scope.lowStoreData ? 1 : 0,
                                test: d['s_test'] === 0 ? 0 : Math.floor(d['s_test'] * 100),
                                dist: d['s_dist'] === 0 ? 0 : Math.floor(d['s_dist'] * 100),
                                additionalCases: additionalCases,
                                empty: false,
                                isShop: false,
                                casesData: convertChartData(d, type, 0, additionalCases, false),
                                deathData: convertChartData(d, type, 1, additionalCases, false),
                                casesDataPercentage: convertChartData(d, type, 0, additionalCases),
                                deathDataPercentage: convertChartData(d, type, 1, additionalCases),
                                predictions: convertChartData(d, type, 2, additionalCases),
                                model: d['model']
                            };
                    }
                }
                return obj;
            }

            var dateIdx = vm.timelineSupport(vm.currentScope, vm.currentCriteria) ? vm.dateIdx : null;

            //Show chosen location in "location block" or change it to new
            if (vm.currentLocationData.length === 0) {
                vm.currentLocationData.push(generateLocationObject(dateIdx));
            } else {
                vm.currentLocationData.splice(vm.currentLocationData.length - 1, 1, generateLocationObject(dateIdx));
            }
            $('#plot').show();
        };

        var between = function between(x, min, max) {
            return x >= min && x <= max;
        };

        var isEmptyPlotLabel = function isEmptyPlotLabel(datasetIndex, plotOption_idx) {
            datasetIndex += 1;
            plotOption_idx += 1;
            switch (plotOption_idx) {
                case 1:
                    return between(datasetIndex, 2, 3);
                case 2:
                    return between(datasetIndex, 2, 3);
                case 3:
                    return false;
            }
        };

        $scope.initPlot = function () {
            installChartPlugin();
            if (vm.currentCriteria) {
                getGradientBar(vm.currentScope, vm.currentCriteria, vm.currentType, vm.dateIdx);
            }

            $scope.options = {
                tooltips: {
                    callbacks: {
                        label: function label(tooltipItems, data) {
                            if (isEmptyPlotLabel(tooltipItems.datasetIndex, $scope.plotOption_idx)) return "";

                            var date = '';
                            if (tooltipItems.datasetIndex === 0) date = tooltipItems.xLabel;else {
                                var metadata = getMetadataByPlotIndex(tooltipItems.datasetIndex);
                                date = getDateByValueFromPlot(tooltipItems.yLabel, metadata);
                            }

                            if (date === undefined) return "";

                            return plotLabels[tooltipItems.datasetIndex] + ": " + (tooltipItems.yLabel * 100).toFixed(4) + "% as of " + date;
                        }
                    }
                },
                hover: {
                    mode: 'index',
                    intersect: true
                },
                scales: {
                    xAxes: [{
                        gridLines: {
                            color: 'rgb(140,140,140, 0.5)'
                        }
                    }],
                    yAxes: [{
                        ticks: {
                            min: 0,
                            beginAtZero: true,
                            callback: function callback(value, index, values) {
                                return (value * 100).toFixed(4) + '%'; // Convert to percentage.
                            }
                        },
                        gridLines: {
                            color: 'rgb(140,140,140, 0.5)'
                        }
                    }]
                }
            };
        };

        //Add id to scrolling div for scroll all opens popups
        $scope.getRenderId = function (name) {
            if (name) {
                return name.toLowerCase().replace(/ /g, '-').split(',').join("");
            }
        };

        $scope.checkboxScroll = function () {
            setTimeout(function () {
                scrollTo(locationName);
            }, 0);
        };

        //scroll chart to top when tab was changed
        var scrollTo = function scrollTo(locationName) {
            var renderId = '#' + locationName.toLowerCase().replace(/ /g, '-').split(',').join("");
            var scrollElement = document.querySelector(renderId);
            var chartLine = document.querySelector('.charts-block');
            var topPos = chartLine.offsetTop;
            scrollElement.scrollTo({ top: scrollElement.scrollHeight, behavior: 'instant' });
        };

        $scope.setPlotView = function (index, locationName) {
            $scope.plotOption_idx = index;

            setTimeout(function () {
                scrollTo(locationName);
            }, 0);
        };

        //Needs for hide chart's buttons if chart's data is empty
        $scope.isShowChartButtons = function (index, cases, deaths, predictions) {
            //If first tab - getting cases, else deaths
            var chartData = index == 0 ? [].concat(_toConsumableArray(cases))[0] : index == 1 ? [].concat(_toConsumableArray(deaths))[0] : [].concat(_toConsumableArray(predictions))[0];
            //Needs for changing "active tab" when current chart is empty
            if (chartData.length == 0 && $scope.plotOption_idx == index) {
                index == 0 ? $scope.plotOption_idx = 1 : index == 1 ? $scope.plotOption_idx = 2 : $scope.plotOption_idx = 0;
            }
            return chartData.length > 0;
        };

        $scope.isShowChartBlock = function (cases, deaths) {
            return vm.currentScope.id < 3 && cases && deaths && [].concat(_toConsumableArray(cases))[0].length > 0 && [].concat(_toConsumableArray(deaths))[0].length > 0;
        };

        vm.hasTable = function () {
            return isShop(vm.currentScope.id);
        };

        var markerClusterer = new MarkerClusterer(vm.map, [], {});

        $scope.scopeChangedByUI = false;

        $scope.setScope = function (id, zoom) {
            var changedByUI = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            if (changedByUI) {
                $scope.scopeChangedByUI = true;
            }

            updateCurrentScope(id);
            $scope.removeMarkers();

            if (zoom === 0 || zoom === null || zoom === undefined) {
                $scope.removeAllLocationsBlocks();
                refreshNonDeckGl(id);"";

                zoom = viewOptions[id][0];
                vm.map.setCenter(viewOptions[id][1]);
                $scope.$broadcast('mapCenterChange');
                vm.map.setZoom(zoom);
            }

            updateMap();

            if (vm.currentCriteria) {
                getGradientBar(vm.currentScope, vm.currentCriteria, vm.currentType, vm.dateIdx);
            }
        };

        $scope.setCriteria = function (id) {
            vm.currentCriteria = CRITERIAS.find_by({ id: id });
            initMap(vm.currentScope, true);
        };

        $scope.setType = function (id) {
            vm.currentType = TYPES.find_by({ id: id });
            updateMap();
            if (vm.currentCriteria) {
                getGradientBar(vm.currentScope, vm.currentCriteria, vm.currentType, vm.dateIdx);
            }
        };

        function setMapViewFromUrl() {
            var sp = $state.params;

            var scrollToMap = false;
            var coords = {};

            if (sp.lat && sp.lng) {
                coords.lat = parseFloat(sp.lat), coords.lng = parseFloat(sp.lng), scrollToMap = true;
            } else {
                // check in order of resolution
                var options = [sp.zipcode, sp.city, sp.state];
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = options[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var ind = _step3.value;

                        if (options[ind]) {

                            scrollToMap = true;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }

            return {
                scrollToMap: scrollToMap,
                coords: coords,
                zoom: 9
            };
        }

        $scope.InfoClickEvent = function (d, event, type) {
            if (!event.handled) {
                $scope.place = d;
                refreshPlot(d, type, getNewAdditionalCases());
                $scope.$apply();
            }
        };

        $scope.addNewLocationBlock = function () {
            vm.currentLocationData.push({
                empty: true
            });
        };

        $scope.removeLocationBlock = function (index) {
            vm.currentLocationData.splice(index, 1);
        };

        $scope.removeAllLocationsBlocks = function () {
            if (vm.currentLocationData.length > 0) {
                //force update for closing locations blocks
                setTimeout(function () {
                    $scope.$apply(vm.currentLocationData = []);
                }, 1000);
            }
        };

        //Needs for showing right info block with shops labels
        $scope.circleLabels = [{
            imgUrl: "/img/percent-shop.svg",
            description: "The size of the cluster depends on the amount of underlying stores. The value represents the average infection rate"
        }, {
            imgUrl: "/img/unknown-shop.svg",
            description: "Unknown: Not Enough Information"
        }, {
            imgUrl: "/img/green-shop.svg",
            description: "Mostly Safe: Few Reported Symptoms"
        }, {
            imgUrl: "/img/orange-shop.svg",
            description: "Unknown: Not Enough Information"
        }, {
            imgUrl: "/img/red-shop.svg",
            description: "Caution: Many Reported Symptoms"
        }];
        $scope.circleMedLabels = [{
            imgUrl: "/img/percent-shop.svg",
            description: "The size of the cluster depends on the amount of underlying stores. The value represents the average infection rate"
        }, {
            imgUrl: "/img/unknown-shop.svg",
            description: "Unknown: Not Enough Information"
        }, {
            imgUrl: "/img/green-med.svg",
            description: "Mostly Safe: Few Reported Symptoms"
        }, {
            imgUrl: "/img/orange-med.svg",
            description: "Unknown: Not Enough Information"
        }, {
            imgUrl: "/img/red-med.svg",
            description: "Caution: Many Reported Symptoms"
        }];

        //Functions for mobile devices
        $scope.isMobile = function () {
            return window.innerWidth < 921;
        };

        // Check for mobile safari
        $scope.isIosSafari = function () {
            return navigator.userAgent.toLowerCase().indexOf('safari/') > -1;
        };

        $scope.mapOptions = (_$scope$mapOptions = {
            zoom: viewOptions[2][0],
            center: viewOptions[2][1],
            mapTypeId: "roadmap",
            styles: mapStyles,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: true,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            gestureHandling: $scope.isMobile() ? 'greedy' : 'cooperative'
        }, _defineProperty(_$scope$mapOptions, "zoomControl", !$scope.isMobile()), _defineProperty(_$scope$mapOptions, "zoomControlOptions", {
            position: google.maps.ControlPosition.RIGHT_TOP
        }), _$scope$mapOptions);

        $scope.initSearchBox = function () {
            var input = document.getElementById('gmapsearch');
            var searchBox = new google.maps.places.Autocomplete(input);
            searchBox.setFields(['geometry', 'name', 'address_components']);

            searchBox.addListener("place_changed", function () {
                var place = searchBox.getPlace();
                vm.map.setCenter(place.geometry.location);
                $scope.$broadcast('mapCenterChange');
                vm.map.fitBounds(place.geometry.viewport);
            });
        };

        function initSlider() {
            vm.dateIdx = vm.last_date_idx;
            var initialDate = vm.dates[vm.dateIdx];
            var $slider = $("#myRange");
            var $dateInput = $("#mapDate");
            $slider.attr("min", 0);
            $slider.attr("max", vm.last_date_idx);

            $dateInput.html(initialDate);

            $slider.on('input', function () {
                var value = $slider.val();
                var date = vm.dates[value];
                $dateInput.html(date);
                updateMap();
                if (vm.currentCriteria) {
                    getGradientBar(vm.currentScope, vm.currentCriteria, vm.currentType, vm.dateIdx);
                }
                refreshMarkers(vm.currentScope.id);
            });
        }

        //Needs for showing right info block with shops labels
        $scope.circleLabels = [{
            imgUrl: "./assets/img/percent-shop.svg",
            description: "The size of the cluster depends on the amount of underlying stores. The value represents the average infection rate"
        }, {
            imgUrl: "./assets/img/unknown-shop.svg",
            description: "Unknown: Not Enough Information"
        }, {
            imgUrl: "./assets/img/green-shop.svg",
            description: "Mostly Safe: Few Reported Symptoms"
        }, {
            imgUrl: "./assets/img/orange-shop.svg",
            description: "Unknown: Not Enough Information"
        }, {
            imgUrl: "./assets/img/red-shop.svg",
            description: "Caution: Many Reported Symptoms"
        }];
        $scope.circleMedLabels = [{
            imgUrl: "./assets/img/percent-shop.svg",
            description: "The size of the cluster depends on the amount of underlying stores. The value represents the average infection rate"
        }, {
            imgUrl: "./assets/img/unknown-shop.svg",
            description: "Unknown: Not Enough Information"
        }, {
            imgUrl: "./assets/img/green-med.svg",
            description: "Mostly Safe: Few Reported Symptoms"
        }, {
            imgUrl: "./assets/img/orange-med.svg",
            description: "Unknown: Not Enough Information"
        }, {
            imgUrl: "./assets/img/red-med.svg",
            description: "Caution: Many Reported Symptoms"
        }];

        //Functions for mobile devices
        $scope.isMobile = function () {
            return window.innerWidth < 921;
        };

        // Check for mobile safari
        $scope.isIosSafari = function () {
            return navigator.userAgent.toLowerCase().indexOf('safari/') > -1;
        };

        $scope.mapOptions = (_$scope$mapOptions2 = {
            zoom: viewOptions[2][0],
            center: viewOptions[2][1],
            mapTypeId: "roadmap",
            styles: mapStyles,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: true,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            gestureHandling: $scope.isMobile() ? 'greedy' : 'cooperative'
        }, _defineProperty(_$scope$mapOptions2, "zoomControl", !$scope.isMobile()), _defineProperty(_$scope$mapOptions2, "zoomControlOptions", {
            position: google.maps.ControlPosition.RIGHT_TOP
        }), _$scope$mapOptions2);

        //Needs for showing full height map in web
        $scope.getWindowHeight = function () {
            return { 'height': (window.innerHeight - 82).toString() + 'px' };
        };

        //Needs for showing full height map in safari (mobile)
        $scope.getFullWindowHeight = function () {
            if ($scope.isIosSafari()) {
                return { 'height': window.innerHeight.toString() + 'px' };
            }
        };
        //For open and close fullscreen mode
        $scope.fullSizeMap = function () {
            $scope.isFullSizeMap = true;
            //remove unvisible class for bugfix
            var element = document.getElementById("mobile-nav");
            element.classList.remove("unvisible");
            //fullscreen
            var elem = document.getElementById('map-content');
            if ($scope.isIosSafari()) {
                elem.classList.add("safari-map-adaptation");
            } else if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.mozRequestFullScreen) {
                /* Firefox */
                elem.mozRequestFullScreen();
            } else if (elem.webkitRequestFullscreen) {
                /* Chrome, Safari & Opera */
                elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) {
                /* IE/Edge */
                elem.msRequestFullscreen();
            }
        };
        $scope.closeFullSizeMap = function () {
            $scope.isFullSizeMap = false;
            if ($scope.isIosSafari()) {
                //Add manual fullscreen for safari
                var element = document.getElementById("map-content");
                element.classList.remove("safari-map-adaptation");
                //Remove relative position for fullscreen
                // var content = document.getElementsById("content");
                // content.classList.add("unset-position");
            } else if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        };

        // Open/Close a leftbar when the map have fullscreen
        $scope.hundleLeftBar = function () {
            $scope.isLeftBarOpen = !$scope.isLeftBarOpen;
        };

        /**
         * Gets color for specific data point.
         * Forces value to be at least 0 even if negative.
         * @param {Object.<string, *>} d - Google Map instance.
         * @param {Object.<string, *>} scope - Scope object.
         * @param {Object.<string, *>} criteria - Criteria object.
         * @param {Object.<string, *>} type - Type object.
         * @param {number} dateIdx - Index of date.
         * @return {void} - Nothing
         */
        function getColor(d, scope, criteria, type) {
            var dateIdx = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

            var mainColor = 255;
            var timeline = vm.timelineSupport(scope, criteria) && dateIdx !== null;

            // If criteria is not set, use 'p_case' as default. 
            // This is necessary since 'country' is a default layer for all scopes. 
            var criteriaName = criteria ? criteria.name : 'p_case';
            // Set default type as 'per_capita'
            type = type ? type : TYPES.find_by({ id: 0 });

            var criteriaObj = scope.criteriaSet[type.name][criteriaName];
            var criteriaWithTime = criteriaObj.name + "_time";

            var intervals = criteriaObj.intervals;
            var value = timeline ? d[criteriaWithTime][dateIdx] : d[criteriaObj.name];

            // Get averaged value.
            if (timeline) {
                var start = Math.max(dateIdx - DAYS, 0);
                var end = Math.min(dateIdx + DAYS + 1, d[criteriaWithTime].length);
                value = commonService.xDaysAverage(d[criteriaWithTime].slice(start, end));
            }

            if (type.id == 0) {
                value = value / d.pop;
            }
            var ratiodValue = value * criteriaObj.ratio;
            // Forces value to be at least 0 even if negative.
            value = Math.max(value, 0);

            if (criteriaObj.inverted) {
                if (value == undefined || value === -1 || value == "NA") {
                    if (scope.id == 3) {
                        return [100, 100, 100, 150];
                    }
                    return [mainColor, 0, 0, 0];
                }
            } else {
                if (ratiodValue == undefined || ratiodValue <= 0 || ratiodValue == "NA") {
                    if (scope.id == 3) {
                        return [100, 100, 100, 150];
                    }
                    return [mainColor, 0, 0, 0];
                }
            }

            for (var i = 0; i < intervals.length; i++) {
                if (ratiodValue < intervals[i].end) {
                    var opacity = Math.round(getIntervalColorOpacity(i, intervals) * 255);
                    if (criteriaObj.inverted) {
                        opacity = 255 - opacity;
                    }
                    return [mainColor, 0, 0, opacity];
                }
                if (i == intervals.length - 1) {
                    var _opacity = Math.round(getIntervalColorOpacity(i + 1, intervals) * 255);
                    if (criteriaObj.inverted) {
                        _opacity = 255 - _opacity;
                    }
                    return [mainColor, 0, 0, _opacity];
                }
            }
        }

        var getIntervalColorOpacity = function getIntervalColorOpacity(i, intervals) {
            var opacityStep = Math.round(1 / (intervals.length + 1) * 90) / 100;
            return opacityStep * (i + 1);
        };

        function refreshNonDeckGl(scopeId) {
            refreshMarkers(scopeId);
            refreshCircles(scopeId);
        }

        var circlesLayer = null;
        function refreshCircles(scopeId) {

            if (isShop(scopeId) === false) {
                return;
            }

            if (scopeId !== 4) {
                if (circlesLayer !== null) {
                    circlesLayer.setMap(null);
                }
                return;
            }

            var direction = 1;
            var paths = [];

            var key = scopeId === 4 ? 'shop' : 'pharmacy';
            data[key].forEach(function (d) {
                var point = { lat: d['geometry']['location']['lat'], lng: d['geometry']['location']['lng'] };
                var radius = isEmptyValue(d) ? 0 : 5000 * d['symptomatic'] / d['count'];
                var item = drawCircle(point, radius, direction);
                paths.push(item);
            });

            circlesLayer = new google.maps.Polygon({
                strokeColor: '#FF0000',
                strokeOpacity: 1.0,
                strokeWeight: 0,
                fillColor: '#FF0000',
                fillOpacity: 0.3,
                map: scopeId == 4 ? vm.map : null,
                paths: paths,
                center: { lat: 37.773972, lng: -122.431297 },
                radius: 1
            });
        }

        function drawCircle(point, radius, dir) {
            var d2r = Math.PI / 180; // degrees to radians
            var r2d = 180 / Math.PI; // radians to degrees
            var earthsradius = 6378137.0; // 6378137.0 is the radius of the earth in meters
            var points = 32;
            if (typeof point.lat != "function") {
                if (typeof point.lat != "number") {
                    alert("drawCircle: point.lat not function or number");
                    return;
                }
                point = new google.maps.LatLng(point.lat, point.lng);
            }

            // find the raidus in lat/lon
            var rlat = radius / earthsradius * r2d;
            var rlng = rlat / Math.cos(point.lat() * d2r);

            var extp = new Array();
            if (dir == 1) {
                var start = 0;
                var end = points + 1;
            } // one extra here makes sure we connect the ends
            else {
                    var start = points + 1;
                    var end = 0;
                }
            for (var i = start; dir == 1 ? i < end : i > end; i = i + dir) {
                var theta = Math.PI * (i / (points / 2));
                var ey = point.lng() + rlng * Math.cos(theta); // center a + radius x * cos(theta)
                var ex = point.lat() + rlat * Math.sin(theta); // center b + radius y * sin(theta)
                extp.push(new google.maps.LatLng(ex, ey));
            }
            return extp;
        }

        var isEmptyValue = function isEmptyValue(d) {
            return d['pred_infection_rate'] === 'NA' || d['pred_infection_rate'] === -1 || d['count'] === 0 || d['count'] === -1;
        };

        function getImage(d, scopeId) {
            var percentage = 0.01;

            if (isEmptyValue(d) || d['count'] < $scope.lowStoreData) {
                if (scopeId === 5) {
                    return './assets/img/pharmacy-gray.png';
                } else if (scopeId === 4) {
                    return './assets/img/store-gray.png';
                }
            }

            if (scopeId === 5) {
                var image = d['pred_infection_rate'] > percentage ? './assets/img/pharmacy-red.png' : './assets/img/pharmacy-green.png';
            } else {
                image = d['pred_infection_rate'] > percentage ? './assets/img/store-red.png' : './assets/img/store-green.png';
            }
            return image;
        }

        var storesMarkers = [];

        $scope.removeMarkers = function () {
            storesMarkers = [];
        };

        function refreshMarkers(scopeId) {
            markerClusterer.clearMarkers();

            if (isShop(scopeId)) {
                var key = scopeId === 4 ? 'shop' : 'pharmacy';
                storesMarkers = data[key].map(function (d) {
                    var marker = new google.maps.Marker({
                        position: new google.maps.LatLng(d['geometry']['location']['lat'], d['geometry']['location']['lng']),
                        icon: getImage(d, scopeId)
                    });

                    marker.customData = d;

                    marker.addListener('click', function () {
                        $scope.place = d;
                        refreshPlot(d, 'shop', getNewAdditionalCases());
                        $scope.$apply();
                    });

                    return marker;
                });

                var styles = [{
                    width: 35,
                    height: 35,
                    className: 'custom-clustericon-1'
                }, {
                    width: 40,
                    height: 40,
                    className: 'custom-clustericon-2'
                }, {
                    width: 50,
                    height: 50,
                    className: 'custom-clustericon-3'
                }, {
                    width: 65,
                    height: 65,
                    className: 'custom-clustericon-4'
                }, {
                    width: 25,
                    height: 25,
                    className: 'custom-clustericon-5'
                }];

                var clusterParams = {
                    gridSize: 100,
                    styles: styles,
                    clusterClass: 'custom-clustericon',
                    maxZoom: 13
                };

                if (isShop(vm.currentScope.id)) {
                    clusterParams.calculator = calculator;
                    markerClusterer = new MarkerClusterer(vm.map, storesMarkers, clusterParams);
                }
            }
        }

        function calculator(storeArray, index) {
            var combinedInfectionRate = 0;
            var totResponses = 0;
            var markersCount = 0;
            var i;

            for (i = 0; i < storeArray.length; i++) {
                var infRate = storeArray[i]['customData']["pred_infection_rate"];
                var numResp = storeArray[i]['customData']["count"];
                if (numResp < 20) {
                    continue;
                }
                if (infRate == "NA" || infRate == -1 || infRate == 0) {
                    continue;
                }
                totResponses += numResp;
                combinedInfectionRate += numResp * Math.log(1 / infRate - 1);
                markersCount++;
            }
            if (totResponses === 0) {
                return { text: '?', index: 5 };
            }

            combinedInfectionRate /= totResponses;
            combinedInfectionRate = 1 / (1 + Math.exp(combinedInfectionRate));

            var text = commonService.oneInN(combinedInfectionRate);
            combinedInfectionRate = combinedInfectionRate < 0.01 ? '< 0.01' : combinedInfectionRate.toFixed(2);

            if (markersCount < 5) index = 1;else if (markersCount < 10) index = 2;else if (markersCount < 20) index = 3;else index = 4;

            return { text: text, index: index };
            // return {text: combinedInfectionRate, index: index};
        }

        //Checks when to show 'Compare' btn (only last block must have this btn)
        $scope.isCompareBtnVisible = function (index) {
            return vm.currentLocationData.length - 1 === index && vm.currentLocationData.length <= 3 && !vm.currentLocationData[vm.currentLocationData.length - 1].empty;
        };

        /**
         * Adds marker and click listener.
         * @param {google.maps.Map} map - Google Map instance.
         * @param {Object.<string, number>} pos - lat/lng object.
         * @return {void} - Nothing
         */
        function addMarker(map, pos) {
            var marker = new google.maps.Marker({
                position: pos,
                map: map
            });
            marker.setMap(map);
            marker.addListener('click', function () {
                $scope.infoWindow.open(map);
            });
        }

        /**
         * Sets infoWindow with information on current location.
         * @param {google.maps.Map} map - Google Map instance.
         * @param {google.maps.InfoWindow} infoWindow - Google InfoWindow instance.
         * @param {google.maps.Geocoder} geocoder - Google GeoCoder instance.
         * @param {Object.<string, number>} pos - lat/lng object.
         * @return {void} - Nothing
         */
        function setInfoWindow(map, infoWindow, geocoder, pos) {
            geocoder.geocode({ location: pos }, function (results, status) {
                var addressHtml = "";
                if (status === "OK" && results[0]) {
                    var address = results[0].formatted_address;
                    addressHtml = "<b><span>" + address + "</span></b><br>";
                }
                var content = "\n                    <div>\n                    " + addressHtml + "\n                    <span>" + pos['lat'] + ", " + pos['lng'] + "</span>\n                    </div>\n                ";
                infoWindow.setPosition(pos);
                infoWindow.open(map);
                infoWindow.setContent(content);
            });
        }

        /**
         * Request user location permission and updates map. 
         * @param {google.maps.Map} map - Google Map instance.
         * @param {google.maps.InfoWindow} infoWindow - Google InfoWindow instance.
         * @param {google.maps.Geocoder} geocoder - Google GeoCoder instance.
         * @return {void} - Nothing. 
         */
        function getLocation(map, infoWindow, geocoder) {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function (position) {
                    var pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                    map.setCenter(pos);
                    $scope.$broadcast('mapCenterChange');
                    addMarker(map, pos);
                    setInfoWindow(map, infoWindow, geocoder, pos);
                });
            }
        }

        function hasCaseUpper(d) {
            return d['p_case_upper'] !== null;
        }

        /**
         * Creates Country layer for map. 
         * @return {deck.GeoJsonLayer} - map layer.
         */
        function createCountryLayer() {
            var scope = SCOPES.find_by({ id: 0 });
            return new deck.GeoJsonLayer({
                id: 'country-layer',
                data: data['country']['data'],
                autoHighlight: true,
                highlightColor: [255, 255, 255, 128],
                getPolygon: function getPolygon(d) {
                    return d["geometry"]["coordinates"];
                },
                getLineColor: [65, 0, 0],
                getFillColor: function getFillColor(d) {
                    return getColor(d, scope, vm.currentCriteria, vm.currentType, vm.dateIdx);
                },
                updateTriggers: {
                    getFillColor: [vm.dateIdx, vm.currentType]
                },
                fp64: true,
                filled: true,
                getLineWidth: 20,
                opacity: 0.8,
                pickable: true,
                onClick: function onClick(d, event) {
                    return $scope.InfoClickEvent(d['object'], event, "country");
                }
            });
        }

        /**
         * Creates US layer for map. 
         * @return {deck.GeoJsonLayer} - map layer.
         */
        function createUSLayer() {
            var scope = SCOPES.find_by({ id: 0 });
            return new deck.GeoJsonLayer({
                id: "us-layer",
                data: data['us']['data'],
                getPolygon: function getPolygon(d) {
                    return d["geometry"]["coordinates"];
                },
                getLineColor: [65, 0, 0],
                getFillColor: function getFillColor(d) {
                    return getColor(d, scope, vm.currentCriteria, vm.currentType, vm.dateIdx);
                },
                updateTriggers: {
                    getFillColor: [vm.dateIdx, vm.currentType]
                },
                fp64: true,
                filled: true,
                getLineWidth: 20,
                opacity: 0.8,
                pickable: true,
                onClick: function onClick(d, event) {
                    return $scope.InfoClickEvent(d['object'], event, "country");
                }
            });
        }

        /**
         * Creates States layer for map. 
         * @return {deck.GeoJsonLayer} - map layer.
         */
        function createStatesLayer() {
            var scope = SCOPES.find_by({ id: 1 });
            return new deck.GeoJsonLayer({
                id: "state-layer",
                data: data['states']['data'],
                autoHighlight: true,
                highlightColor: [255, 255, 255, 128],
                getPolygon: function getPolygon(d) {
                    return d["geometry"]["coordinates"];
                },
                getLineColor: [255, 0, 0],
                getFillColor: function getFillColor(d) {
                    return getColor(d, scope, vm.currentCriteria, vm.currentType, vm.dateIdx);
                },
                updateTriggers: {
                    getFillColor: [vm.dateIdx, vm.currentType]
                },
                filled: true,
                getLineWidth: 20,
                opacity: 0.8,
                pickable: true,
                onClick: function onClick(d, event) {
                    return $scope.InfoClickEvent(d['object'], event, "states");
                }
            });
        }

        /**
         * Creates County layer for map. 
         * @return {deck.GeoJsonLayer} - map layer.
         */
        function createCountyLayer() {
            var scope = SCOPES.find_by({ id: 2 });
            return new deck.GeoJsonLayer({
                id: "county-layer",
                data: data['county']['data'], //.filter(d => hasCaseUpper(d) === false),
                autoHighlight: true,
                highlightColor: [255, 255, 255, 128],
                getPolygon: function getPolygon(d) {
                    return d["geometry"]["coordinates"];
                },
                getLineColor: function getLineColor(d) {
                    return hasCaseUpper(d) === true ? [255, 255, 255] : [255, 0, 0];
                },
                getFillColor: function getFillColor(d) {
                    return getColor(d, scope, vm.currentCriteria, vm.currentType, vm.dateIdx);
                },
                updateTriggers: {
                    getFillColor: [vm.dateIdx, vm.currentType]
                },
                filled: true,
                getLineWidth: function getLineWidth(d) {
                    return hasCaseUpper(d) === true ? 2000 : 0;
                },
                opacity: 0.8,
                pickable: true,
                onClick: function onClick(d, event) {
                    return $scope.InfoClickEvent(d['object'], event, "county");
                }
            });
        }

        /**
         * Creates City layer for map. 
         * @return {deck.ScatterplotLayer} - map layer.
         */
        function createCityLayer() {
            var scope = SCOPES.find_by({ id: 3 });
            return new deck.ScatterplotLayer({
                //autoHighlight: true,
                //highlightColor: [255, 255, 255],
                id: "city-layer",
                data: data['city']['data'],
                getPosition: function getPosition(d) {
                    return [d['coord'][1], d['coord'][0]];
                },
                getRadius: function getRadius(d) {
                    return 700;
                },
                getFillColor: function getFillColor(d) {
                    return getColor(d, scope, vm.currentCriteria, vm.currentType, vm.dateIdx);
                },
                updateTriggers: {
                    getFillColor: [vm.dateIdx, vm.currentType]
                },
                opacity: 1,
                pickable: true,
                onClick: function onClick(d, event) {
                    return $scope.InfoClickEvent(d['object'], event, "city");
                }
            });
        }

        /**
         * Creates map layers based on scope.
         * @return {deck.*} - map layer.
         */
        function createLayers(scope) {
            return scope.layers.map(function (layer) {
                switch (layer) {
                    case 'country':
                        return createCountryLayer();
                        break;
                    case 'us':
                        return createUSLayer();
                        break;
                    case 'states':
                        return createStatesLayer();
                        break;
                    case 'county':
                        return createCountyLayer();
                        break;
                    case 'city':
                        return createCityLayer();
                        break;
                    default:
                        break;
                }
            });
        }

        /**
         * Initializes Map.
         * @param {Object.<string, *>} scope - Scope object.
         * @param {boolean} keepScope - Whether to keep current scope.
         * @return {void} - Nothing.
         */
        function initMap(scope) {
            var keepScope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var currentZoomLevel;
            var currentCenter;

            if (keepScope === true) {
                currentZoomLevel = vm.map.getZoom();
                currentCenter = vm.map.getCenter();
            }

            var autoScroll = setMapViewFromUrl();

            if (autoScroll.scrollToMap) {
                $(document).scrollTop($('.map-content').offset().top - 122);
            }

            vm.map = new google.maps.Map(document.getElementById("map"), $scope.mapOptions);
            vm.geocoder = new google.maps.Geocoder();
            $scope.infoWindow = new google.maps.InfoWindow({});

            vm.layers = createLayers(scope);

            //Show loader when map loading
            vm.map.addListener('tilesloaded', function () {
                vm.isMapLoading = false;
                $scope.$apply();
            });

            vm.map.addListener('bounds_changed', function () {
                $scope.$broadcast('bounds_changed');
            });

            vm.map.addListener('zoom_changed', function () {
                if ($scope.scopeChangedByUI) {
                    $scope.scopeChangedByUI = false;
                    return;
                }
                $scope.scopeChangedByUI = false;

                // Close popups only on scope change
                $scope.removeAllLocationsBlocks();

                var zoomLevel = vm.map.getZoom();
                if (vm.currentScope.id < 4) {
                    if (zoomLevel <= 3) {
                        $scope.setScope(0, zoomLevel);
                    } else if (zoomLevel <= 4) {
                        $scope.setScope(1, zoomLevel);
                    } else if (zoomLevel <= 9) {
                        $scope.setScope(2, zoomLevel);
                    } else {
                        $scope.setScope(3, zoomLevel);
                    }
                }
            });

            vm.deckOverlay = new deck.GoogleMapsOverlay({ layers: [vm.layers] });

            vm.deckOverlay.setMap(vm.map);
            refreshMarkers(2);
            if (keepScope == false) {
                // default resolution and positioning of map
                refreshMarkers(2);
                if (autoScroll.scrollToMap) {
                    vm.map.setCenter(autoScroll.coords);
                    $scope.$broadcast('mapCenterChange');
                    vm.map.setZoom(autoScroll.zoom);
                }
            } else {
                refreshMarkers(vm.currentScope.id);
                vm.map.setCenter(currentCenter);
                $scope.$broadcast('mapCenterChange');
                vm.map.setZoom(currentZoomLevel);
            }
            getLocation(vm.map, $scope.infoWindow, vm.geocoder);
        }

        function updateMap() {
            vm.layers = createLayers(vm.currentScope);
            vm.deckOverlay.setProps({ layers: vm.layers });
        }

        var getValueOrDefault = function getValueOrDefault(value) {
            return value === -1 || value === "NA" ? 0 : value;
        };

        function generateNewCasesData(data) {
            var dates = data.dates;
            var first_pred_date = data.first_pred_date;
            var first_pred_date_idx = dates ? dates.indexOf(first_pred_date) : null;
            var last_date_idx = first_pred_date_idx ? first_pred_date_idx - 1 : null;
            data.data.forEach(function (d) {
                if (d.p_case_time) {
                    d.n_p_case_time = d.p_case_time.slice(0, first_pred_date_idx).map(function (dd, i) {
                        return !i ? dd : dd - d.p_case_time[i - 1];
                    });
                    d.n_p_case = d.n_p_case_time[last_date_idx];
                }
            });
        }

        $scope.run = function () {
            Promise.all(Object.keys(DATA_URLS).map(function (dataname) {
                if (fetchedData) {
                    return;
                }
                return Promise.all([$.get({
                    type: 'GET',
                    url: DATA_URLS[dataname],
                    dataType: "text",
                    headers: {
                        // "Accept-Encoding": "gzip",
                        // "Accept-Encoding" : "gzip",
                        mimeType: "application/octet-stream; charset=x-user-defined"
                    }
                })]).then(function (_ref) {
                    var _ref2 = _slicedToArray(_ref, 1),
                        fetched_data_raw = _ref2[0];

                    var fetched_data = JSON.parse(fetched_data_raw);

                    if (dataname === 'pharmacy' || dataname === "shop") {
                        //let k = dataname === 'pharmacy' ? 0.01 : 1;
                        var k = dataname === 'pharmacy' ? 0.01 : 0.01;
                        fetched_data.forEach(function (x) {
                            x.pred_infection_rate = getValueOrDefault(x.pred_infection_rate) * k;
                        });
                    }
                    if (dataname !== 'pharmacy' && dataname !== 'shop') {
                        generateNewCasesData(fetched_data);
                    }

                    data[dataname] = fetched_data;
                });
            })).then(function () {
                fetchedData = true;
                vm.scopeOptions = SCOPES.select(['id', 'display']);
                vm.dateIdx = 0;
                updateCurrentScope(2);
            }).then(function () {
                return updateDateInfo(vm.currentScope);
            }).then(function () {
                generateAllMetaData(SCOPES);
            }).then(function () {
                return initMap(vm.currentScope);
            }).then(function () {
                return $scope.initSearchBox();
            }).then(function () {
                return initSlider();
            }).then(function () {
                return $scope.initPlot();
            })
            // .then(console.log('SCOPES', SCOPES))
            .catch(console.log);
        };
    }]
});

var installChartPlugin = function installChartPlugin() {
    var fillBetweenLinesPlugin = {
        afterDatasetsDraw: function afterDatasetsDraw(chart) {
            var ctx = chart.chart.ctx;
            var xaxis = chart.scales['x-axis-0'];
            var yaxis = chart.scales['y-axis-0'];
            var datasets = chart.data.datasets;
            ctx.save();

            for (var d = 0; d < datasets.length; d++) {
                var dataset = datasets[d];
                if (dataset.fillBetweenSet == undefined) {
                    continue;
                }

                // get meta for both data sets
                var meta1 = chart.getDatasetMeta(d);
                var meta2 = chart.getDatasetMeta(dataset.fillBetweenSet);

                // do not draw fill if one of the datasets is hidden
                if (meta1.hidden || meta2.hidden) continue;

                // create fill areas in pairs
                for (var p = 0; p < meta1.data.length - 1; p++) {
                    // if null skip
                    if (dataset.data[p] == null || dataset.data[p + 1] == null) continue;

                    ctx.beginPath();

                    // trace line 1
                    var curr = meta1.data[p];
                    var next = meta1.data[p + 1];
                    ctx.moveTo(curr._view.x, curr._view.y);
                    ctx.lineTo(curr._view.x, curr._view.y);
                    if (curr._view.steppedLine === true) {
                        ctx.lineTo(next._view.x, curr._view.y);
                        ctx.lineTo(next._view.x, next._view.y);
                    } else if (next._view.tension === 0) {
                        ctx.lineTo(next._view.x, next._view.y);
                    } else {
                        ctx.bezierCurveTo(curr._view.controlPointNextX, curr._view.controlPointNextY, next._view.controlPointPreviousX, next._view.controlPointPreviousY, next._view.x, next._view.y);
                    }

                    // connect dataset1 to dataset2
                    var curr = meta2.data[p + 1];
                    var next = meta2.data[p];
                    ctx.lineTo(curr._view.x, curr._view.y);

                    // trace BACKWORDS set2 to complete the box
                    if (curr._view.steppedLine === true) {
                        ctx.lineTo(curr._view.x, next._view.y);
                        ctx.lineTo(next._view.x, next._view.y);
                    } else if (next._view.tension === 0) {
                        ctx.lineTo(next._view.x, next._view.y);
                    } else {
                        // reverse bezier
                        ctx.bezierCurveTo(curr._view.controlPointPreviousX, curr._view.controlPointPreviousY, next._view.controlPointNextX, next._view.controlPointNextY, next._view.x, next._view.y);
                    }

                    // close the loop and fill with shading
                    ctx.closePath();
                    ctx.fillStyle = dataset.fillBetweenColor || "rgba(0,0,0,0.1)";
                    ctx.fill();
                } // end for p loop
            }
        } // end afterDatasetsDraw
    }; // end fillBetweenLinesPlugin


    Chart.pluginService.register(fillBetweenLinesPlugin);
};
'use strict';

(function () {
	angular.module('app').component('navbar', {
		controllerAs: 'vm',
		templateUrl: 'components/navbar/navbar.html',
		controller: ["$scope", "$rootScope", "$state", "$stateParams", "$location", function controller($scope, $rootScope, $state, $stateParams, $location) {
			var vm = this;
			vm.location = $location;

			var _$state$params$lang = $state.params.lang,
			    lang = _$state$params$lang === undefined ? 'en' : _$state$params$lang;

			vm.showLang = lang;

			vm.goHome = function () {
				if (lang != 'en') {
					$state.go('home', { lang: vm.showLang });
				} else {
					$state.go('home');
				}
			};
			vm.test = "test";

			vm.liveRefresh = function () {
				$rootScope.$broadcast('live-refresh');
			};
		}]
	});
})();
'use strict';

var app = angular.module("app");

app.filter('onInNFilter', ["commonService", function (commonService) {
    return function (n) {
        return commonService.oneInN(n);
    };
}]);

app.filter('distanceFilter', ['$filter', function ($filter) {
    return function (input, decimals, unit) {
        return $filter('number')(input, decimals) + ' ' + unit;
    };
}]);

app.component("ngTable", {
    controllerAs: "vm",
    templateUrl: "components/ngTable/ngTable.html",
    require: {
        dependencyCtrl: '^map'
    },
    controller: ["$attrs", "$scope", "$state", "Lang", "$http", "apiService", "commonService", "uiGridConstants", "$filter", function controller($attrs, $scope, $state, Lang, $http, apiService, commonService, uiGridConstants, $filter) {
        var type = $attrs.tableType;
        var vm = this;
        var _$state$params$lang = $state.params.lang,
            lang = _$state$params$lang === undefined ? 'en' : _$state$params$lang;

        var rowHeight = 50;

        vm.isTableLoading = true;

        vm.myData = [];

        $scope.$on('mapCenterChange', function (e) {
            vm.updateTable();
        });
        $scope.$on('bounds_changed', function (e) {
            vm.updateTable();
        });

        vm.$onInit = function () {
            vm.map = this.dependencyCtrl.map;
        };

        //Functions for mobile devices
        vm.isMobile = function () {
            return window.innerWidth < 921;
        };

        function transform(list) {
            var map = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var bounds = map.getBounds();
            var results = list.filter(function (d) {
                return !commonService.isEmptyValue(d);
            });
            if (bounds) {
                results = results.filter(function (d) {
                    return bounds.contains({ lat: d['geometry']['location']['lat'], lng: d['geometry']['location']['lng'] });
                });
            }
            results = results.map(function (d, i) {
                var result = {
                    index: i,
                    name: d['name'],
                    percentage: d['pred_infection_rate'],
                    sympt: d['count'],
                    address: d['address']
                };

                if (map) {
                    var proximity = commonService.haversine(d['geometry']['location']['lat'], d['geometry']['location']['lng'], map.data.map.center.lat(), map.data.map.center.lng(), 'mi');
                    result.binnedProximity = commonService.binnedProximity(proximity);
                    result.binnedProximityDisplay = commonService.binnedProximityDisplay(result.binnedProximity);
                }
                return result;
            });

            return results;
        }

        vm.gridOptions = {
            data: 'vm.myData',
            paginationPageSizes: [10, 25, 50, 100],
            paginationPageSize: 10,
            enableColumnResizing: true,
            rowHeight: rowHeight,
            columnDefs: [{
                name: 'index',
                displayName: 'Rank',
                width: '7%',
                cellTooltip: false,
                cellTemplate: '<div class="ui-grid-cell-contents text-center">{{grid.renderContainers.body.visibleRowCache.indexOf(row) + 1}}</div>',
                enableSorting: false
            }, {
                name: 'name',
                displayName: 'Name',
                width: '35%',
                cellTooltip: true
            }, {
                name: 'address',
                displayName: 'Address',
                width: '35%',
                cellTooltip: true
            }, {
                name: 'percentage',
                cellFilter: 'onInNFilter',
                type: 'number',
                displayName: 'Infection Rate',
                width: '13%',
                defaultSort: {
                    direction: uiGridConstants.DESC,
                    priority: 1
                }
            }, {
                name: 'sympt',
                displayName: 'Number of Reports',
                visible: false,
                defaultSort: {
                    direction: uiGridConstants.DESC,
                    priority: 2
                }
            }, {
                name: 'binnedProximity',
                displayName: 'binnedProximity',
                cellTooltip: true,
                visible: false,
                defaultSort: {
                    direction: uiGridConstants.ASC,
                    priority: 0
                }
            }, {
                name: 'binnedProximityDisplay',
                displayName: 'Proximity',
                width: '10%',
                cellTooltip: true,
                visible: true,
                enableSorting: false
            }]
        };

        vm.updateTable = function () {
            vm.myData = transform(data[type], vm.map);
            vm.isTableLoading = false;
        };
    }]
});
"use strict";

var app = angular.module("app");

app.component("plot", {
    controllerAs: "vm",
    templateUrl: "components/plot/plot.html",
    controller: ["$attrs", "$scope", "$state", "Lang", "$http", "apiService", "$filter", function controller($attrs, $scope, $state, Lang, $http, apiService, $filter) {

        var HOSPITAL_DIR = "https://covidweb-assets.s3-us-west-2.amazonaws.com/public/hospital/";

        var type = $attrs.tableType;
        var vm = this;
        var _$state$params$lang = $state.params.lang,
            lang = _$state$params$lang === undefined ? 'en' : _$state$params$lang;


        vm.lang = Lang.init(lang, 'plot');
        var lowStoreData = 10;
        var rowHeight = 50;

        vm.isPlotLoading = true;

        vm.$onInit = function () {
            initPlot();
        };

        //Functions for mobile devices
        vm.isMobile = function () {
            return window.innerWidth < 921;
        };

        vm.selectCounty = function (name) {
            vm.currentCounty = vm.counties.find(function (e) {
                return e.name == name;
            });
        };

        function generatePlotUrl(county) {
            return HOSPITAL_DIR + county.replace(" ", "+") + ".png";
        }

        function initPlot() {
            apiService.getCountiesJSON().then(function (response) {
                vm.counties = response.data;
                vm.currentCounty = vm.counties.length ? vm.counties[0] : null;
                vm.isPlotLoading = false;
            });
        }
    }]
});
"use strict";
'use strict';

angular.module('app').component('rootContainer', {
	controllerAs: 'vm',
	templateUrl: 'components/root/root.html',
	controller: ["$scope", "$state", "$rootScope", function controller($scope, $state, $rootScope) {
		var vm = this;

		$rootScope.$on('$stateChangeSuccess', function () {
			document.body.scrollTop = document.documentElement.scrollTop = 0;
		});
	}]
});
'use strict';

var app = angular.module('app');

app.component('staff', {
    templateUrl: "components/staff/staff.html",
    controller: ["$scope", function controller($scope) {
        $scope.barcode = null;
        $scope.user_id = null;
        var barcodePicker = null;
        var license_key = "Ad7OM6uBP6H8RazjfyMtGog+ONxQFtA3V0UG4DlnI2aeQnRwkD4KeTQujvsHLQOVNWFWzmN5JgMsRW96mCR9OAVJXBZubWKzYWWephtY81QXVmT3UXZw40YGxU6+DvmYqRB59AMq06UlQxXHi3/KXzII1YpsDkH3auUGivhbv8qmURPeoqWQrmuY90F/QV5GANent1ffaJLB1HUei4K/9GuIjyLFV2xofzkPiA7gzSILI62tIGLgJCpTusWZZKcjhY/IkTVqqR4zOiwzGHHXJQmXzjKK1R9uR7XWFHPVoWebvtRVhR0quXRqsi2+9sVnXcgd5NT7CywccJQc4/sB51yWWG8b8GeIkoS682EkvzdzjVO+e1mvI7lbnuQYy4WZtrj7jni2JeSHOCzm6uZRNAQEVhZOJ9vgsieV7cbZwDw+NVzKvwbYgBiyhzYzuu6ikWTDywKm8LUuAEFiStNKrRvWBgjQKIapRy7eOF/ofSrzbs+n9JgWzadKUvcgudXg4RRFQ2H/SXdifLQkrt8Ft/p96BDlEDP/At61n3hC0n3JzM77khPZyWm6IB/LuxH2AAVZm2QPmZGG5Ob3VAa2yWCA98MWcMikN7l0zsI22aQZcquouPqkY8wRAHKs8YVwgQCYTxrk+OJc2Fr+GOe9hjDmxMwhowuzrTCssogEcZJDrApn+vTJ6SYIPVnhPYkwpZFmx+5CxgRoH9NtnZ3fa+KeNgD4WeOxyoRg/TX6PmmMrKuKFqZC7dLqYfCR9YMlvMMz7DOxWc+/1XPthVtqq+zikS+kZ5RAZAdLRCIRhEyyQ+mp9KXk45pSRT/f";

        $scope.startDecoding = function () {
            ScanditSDK.configure(license_key, {
                engineLocation: "https://cdn.jsdelivr.net/npm/scandit-sdk@5.x/build/"
            }).then(function () {
                return ScanditSDK.BarcodePicker.create(document.getElementById("scandit-barcode-picker"), {
                    scanSettings: new ScanditSDK.ScanSettings({ enabledSymbologies: ["code128"], codeDuplicateFilter: 5000 })
                });
            }).then(function (bp) {
                barcodePicker = bp;
                bp.setMirrorImageEnabled(false);
                barcodePicker.on("scan", function (scanResult) {
                    $scope.barcode = scanResult.barcodes[0].data;
                    $scope.$apply();
                    redirect();
                });
            });
        };

        var stopCamera = function stopCamera() {
            if (barcodePicker != null) {
                barcodePicker.destroy();
                barcodePicker = null;
            }
        };

        var endDecoding = function endDecoding() {
            stopCamera();
            $(".spacer").css("height", $(".spacer").height() * 3 + 'px');
            show([".barcode-result"]);
        };

        var redirect = function redirect() {
            if ($scope.barcode != null && $scope.user_id != null) {
                window.location = 'https://uclahs.az1.qualtrics.com/jfe/form/SV_2na3TNZGIf61jxP?barcode=' + $scope.barcode + '&RandomID=' + $scope.user_id;
            }
        };

        var validateInput = function validateInput(i) {
            var val1 = $('#' + i + '-input').val();
            var val2 = $('#' + i + '-input2').val();

            if (val1 == val2 && (val1 != null || val != undefined || !val)) {
                if (i == "barcode") {
                    $("#barcode-err").hide();
                    $("#barcode-err").parents(".form-group").removeClass('has-error');
                    $scope.barcode = val1;
                    $scope.$apply();
                } else {
                    $("#qr-err").hide();
                    $("#qr-err").parents(".form-group").removeClass('has-error');
                    $scope.user_id = val1;
                    $scope.$apply();
                }
            } else {
                if (i == "barcode") {
                    $("#barcode-err").html("Entered barcodes do not match").show();
                    $("#barcode-err").parents(".form-group").addClass('has-error');
                } else {
                    $("#qr-err").html("Entered IDs do not match").show();
                    $("#qr-err").parents(".form-group").addClass('has-error');
                }
            }
        };

        // $('form').submit(function(e) {
        //     validateInput("qr");
        //     validateInput("barcode");
        //     redirect();
        // });

        document.getElementById("barcode-input").addEventListener("keypress", function (e) {
            if (e.key == 'Enter') {
                validateInput("barcode");
                redirect();
            }
        });

        document.getElementById("barcode-input2").addEventListener("keypress", function (e) {
            if (e.key == 'Enter') {
                validateInput("barcode");
                redirect();
            }
        });

        document.getElementById("qr-input").addEventListener("keypress", function (e) {
            if (e.key == 'Enter') {
                validateInput("qr");
                redirect();
            }
        });

        document.getElementById("qr-input2").addEventListener("keypress", function (e) {
            if (e.key == 'Enter') {
                validateInput("qr");
                redirect();
            }
        });

        var codeReader = new ZXing.BrowserQRCodeReader();
        codeReader.decodeOnceFromVideoDevice(null, 'video').then(function (result) {
            $scope.user_id = result.text;
            $scope.$apply();
            redirect();
        });

        $scope.startDecoding();
    }]
});
'use strict';

var app = angular.module('app');

app.component('staffLogin', {
    templateUrl: "components/staff-login/staff-login.html",
    controller: ["$scope", "$cookies", "$compile", function controller($scope, $cookies, $compile) {

        $scope.login = function () {
            var name = $("#name").val();
            var email = $("#email").val();
            var location = $("#location").val();

            if (!name) {
                $("#name").parents(".form-group").addClass('has-error');
                $("#name-err").html("Required").show();
            } else {
                $("#name").parents(".form-group").removeClass('has-error');
                $("#name-err").hide();
            }
            if (!email) {
                $("#email").parents(".form-group").addClass('has-error');
                $("#email-err").html("Required").show();
            } else {
                $("#email").parents(".form-group").removeClass('has-error');
                $("#email-err").hide();
            }
            if (!location) {
                $("#location").parents(".form-group").addClass('has-error');
                $("#location-err").html("Required").show();
            } else {
                $("#location").parents(".form-group").removeClass('has-error');
                $("#location-err").hide();
            }

            if (name && email && location) {
                insertCookie(name, email, location);
                loadStaffPage();
            }
        };

        var checkCookie = function checkCookie() {
            var cookie = $cookies.getObject("SCS_LT");
            if (!cookie) {
                return false;
            } else {
                return true;
            }
        };

        var insertCookie = function insertCookie(name, email, location) {
            var expireTime = new Date();
            expireTime.setHours(expireTime.setHours() + 2);
            $cookies.putObject("SCS_LT", {
                name: name,
                email: email,
                location: location
            }, {
                expires: expireTime
            });
        };

        var loadStaffPage = function loadStaffPage() {
            $("#staff-login").hide();
            $(".ng-scope").append($compile("<staff></staff>")($scope));
        };

        if (checkCookie()) {
            loadStaffPage();
        }
    }]
});
'use strict';

(function () {
	angular.module('app').component('student', {
		controllerAs: 'vm',
		templateUrl: 'components/student/student.html',
		controller: ["$scope", "$state", "Lang", "OrgTable", function controller($scope, $state, Lang, OrgTable) {
			var vm = this;

			var _$state$params$lang = $state.params.lang,
			    lang = _$state$params$lang === undefined ? 'en' : _$state$params$lang;

			vm.showLang = lang;
			vm.lang = Lang.init(lang, $state.$current.name);

			$scope.orgname = $state.params.orgname;
			$scope.orgurl = $state.params.orgurl;
			$scope.orglogo = $state.params.orglogo;

			OrgTable.fetch().then(function (table) {
				// console.log(table);
				if ($state.params.orgid && table[$state.params.orgid]) {
					var _table$$state$params$ = table[$state.params.orgid],
					    orgname = _table$$state$params$.orgname,
					    orgurl = _table$$state$params$.orgurl,
					    logo = _table$$state$params$.logo,
					    type = _table$$state$params$.type;

					$scope.orgname = orgname;
					$scope.orgurl = orgurl;
					$scope.orglogo = logo;
					$scope.orgtype = type;
					$scope.$apply();
				}
			}).catch(console.log);

			var baseURL = 'https://uclahs.az1.qualtrics.com/jfe/form/SV_4YJB6yQt1kdPL7f';
			vm.dailySurveyURL = function () {
				if ($scope.orgname) {
					return baseURL + '?organization_name=' + $scope.orgname + '&exit_link=' + $scope.orgurl + '&logo=' + $scope.orglogo + '&type=' + $scope.orgtype;
				} else {
					return baseURL;
				}
			};
		}]
	});
})();
'use strict';

(function () {
	angular.module('app').component('summary', {
		controllerAs: 'vm',
		templateUrl: 'components/summary/summary.html',
		controller: ["$scope", "$stateParams", "User", "Survey", function controller($scope, $stateParams, User, Survey) {
			var vm = this;

			// vm.mainOpen = true;
			vm.mainOpen = false;
			vm.dailyOpen = false;

			var attachManyVector = function attachManyVector(surveySpec) {
				surveySpec.map(function (section) {
					section.questions.map(function (question) {
						if (question.type == 'many') {
							var boolVector = new Array(question.options.length).fill(false);
							question.answer = boolVector;
						}
					});
				});
			};

			vm.mainQuestions = [{
				title: 'Thank you for taking our survey. We\'d like to ask about how you\'ve been feeling.',
				questions: [{
					text: 'Do you currently have a fever?',
					code: 'feverNow',
					type: 'yesno',
					options: ['yes', 'no']
				}, {
					text: 'How many days have you had a fever?',
					code: 'feverDays',
					type: 'number',
					showif: 0
				}, {
					text: 'What is your current temperature?',
					code: 'feverTemp',
					type: 'number',
					showif: 0
				}, {
					text: 'What has been your highest fever in the past XX days?',
					code: 'feverHighest',
					type: 'number',
					showif: 0
				}, {
					text: 'Do you currently have any of the following symptoms:',
					code: 'symptomsNow',
					type: 'many',
					options: ['Cough', 'Congestion', 'Sore throat', 'Nausea or diarrhea', 'Difficulty breathing', 'Fatigue', 'Muscle pain']
				}, {
					text: 'Have you experienced loss of smell?',
					code: 'smellLoss',
					type: 'yesno',
					options: ['yes', 'no']
				}, {
					text: 'Is this a chronic condition?',
					code: 'smellLossChronic',
					type: 'yesno',
					options: ['yes', 'no'],
					showif: 5
				}, {
					text: 'For how many days have you been suffering from loss of smell?',
					code: 'smellLossDays',
					type: 'number',
					showif: 5
				}]
			}, {
				title: 'Thank you for answering those questions. Now we have some questions about you.',
				questions: [{
					text: 'How old are you?',
					code: 'age',
					type: 'number'
				}, {
					text: 'What is your gender?',
					code: 'gender',
					type: 'choose',
					options: ['Male', 'Female', 'Other', 'Decline to State']
				}, {
					text: 'What is your height?',
					code: 'height',
					type: 'number'
				}, {
					text: 'What is your weight?',
					code: 'weight',
					type: 'number'
				}, {
					text: 'Have you smoked at least 100 cigarettes in your entire life?',
					type: 'yesno',
					code: 'smoked100',
					options: ['yes', 'no']
				}, {
					text: 'Do you currently smoke or vape?',
					code: 'vape',
					type: 'yesno',
					options: ['yes', 'no']
				}, {
					text: 'Do you have any of the following conditions?',
					code: 'conditions',
					type: 'many',
					options: ['Hypertension', 'Diabetes', 'Cardiovascular disease', 'Renal insufficiency', 'Chronic obstructive pulmonary disease (COPD)', 'Malignant tumor (cancer)', 'Autoimmune diseases']
				}, {
					text: 'Do you take any of the following medications?',
					code: 'medications',
					type: 'many',
					options: ['NSAIDs (Paracetamol / acetaminophen)', 'Ashthma medication', 'Pollen allergy medications', 'Antibiotics', 'Hyocardial infarction or stroke medication (examples)', 'Blood thinners', 'Other (please specify)']
				}]
			}];

			[vm.mainQuestions].map(function (surveySpec) {
				attachManyVector(surveySpec);
			});

			// vm.diagnosis = 'none';
			// vm.user = {
			// 	subscribed: true,
			// 	mainComplete: false,
			// }

			vm.setSub = function (sub) {
				vm.user.subscribed = sub;
			};

			vm.setDiag = function (diag) {
				vm.diagnosis = diag;
			};

			vm.setMainOpen = function (openFlag) {
				if (openFlag) {
					// will open

					$('.survey').css('opacity', '0');
				}
				vm.mainOpen = openFlag;

				$('.survey').animate({ opacity: '1' });
			};

			vm.packForm = function (name, questions) {
				var responses = {};
				questions.map(function (section) {
					section.questions.map(function (spec) {

						var answer = spec.answer;
						if (spec.type == 'many') {
							answer = spec.answer.map(function (flag, ind) {
								return flag ? ind : null;
							}).filter(function (val) {
								return val != null;
							});
						}
						console.log(spec.code, answer);

						responses[spec.code] = answer;
					});
				});

				return {
					name: name,
					responses: responses
				};
			};

			vm.submitMain = function () {

				var surveyResponse = vm.packForm('main', vm.mainQuestions);
				console.log(surveyResponse);

				Survey.submit({
					user: $stateParams.user,
					survey: surveyResponse
				}).then(function (res) {
					var submitted = res.data;
					console.log(res.data);
					if (submitted.success) {
						// successfully submitted

						vm.user.mainComplete = true;
						vm.mainOpen = false;
					} else {
						// TODO: indicates which required responses were missing

					}
				}).catch(console.log);
			};

			vm.showQuestion = function (qlist, spec) {
				var yesAnswered = qlist[spec.showif].answer == true;
				return yesAnswered;
			};

			Survey.summary($stateParams.user).then(function (res) {
				vm.hist = res.data.surveys;
			}).catch(console.log);

			User.info($stateParams.user).then(function (res) {
				vm.user = res.data;
			}).catch(console.log);
		}]
	});
})();
'use strict';

(function () {
	angular.module('app').component('survey', {
		controllerAs: 'vm',
		templateUrl: 'components/survey/survey.html',
		controller: ["$scope", "$stateParams", "$sce", "mainSurveyUrl", function controller($scope, $stateParams, $sce, mainSurveyUrl) {
			var vm = this;

			console.log($stateParams.user);

			// // const surveyURL = 'https://uclahs.az1.qualtrics.com/jfe/form/SV_0Mw55IrSnYVurQ1';
			// const surveyURL = 'https://uclahs.az1.qualtrics.com/jfe/form/SV_bQ4fV8946XjLiQJ';
			var trusted = $sce.trustAsResourceUrl(mainSurveyUrl + '?userid=' + $stateParams.user);
			vm.surveyURL = trusted;
		}]
	});
})();
'use strict';

(function () {
	angular.module('app').component('terms', {
		controllerAs: 'vm',
		templateUrl: 'components/terms/terms.html',
		controller: ["$scope", "$stateParams", function controller($scope, $stateParams) {
			var vm = this;
		}]
	});
})();
'use strict';

(function () {
	angular.module('app').component('home', {
		controllerAs: 'vm',
		templateUrl: 'components/home/home.html',
		controller: ["$scope", "$interval", "$state", "Lang", function controller($scope, $interval, $state, Lang) {
			var vm = this;
			vm.isSick = false;

			var _$state$params$lang = $state.params.lang,
			    lang = _$state$params$lang === undefined ? 'en' : _$state$params$lang;

			vm.showLang = lang;
			vm.lang = Lang.init(lang, $state.$current.name);

			vm.westwood = true;

			vm.surveyLinkLang = function (feelsgood) {
				var langOption = lang == 'en' ? '' : '&Q_Language=ES-ES';
				var baseUrl = 'https://uclahs.az1.qualtrics.com/jfe/form/SV_ebnu7bymEa3ZElD';
				return baseUrl + '?feelsgood=' + feelsgood + '&marketingroute=homepage' + langOption;
			};

			vm.faqURL = function () {
				return lang != 'en' ? '/faq?lang=' + vm.showLang : '/faq';
			};

			// default checkbox selection
			vm.pharm = true;
			vm.groc = false;
			vm.states = false;

			vm.needConsent = function () {
				// check browser cache?
				return true;
			};

			vm.showSick = function () {

				vm.isSick = true;
				vm.waitForSurvey();
			};

			var surveyChecker = null;
			$scope.$on('$destroy', function () {
				$interval.cancel(surveyChecker);
			});

			function parseCreds(rawURL) {
				console.log('Entry', rawURL);
				var surveyerID = rawURL.split('entry/')[1];
				return [surveyerID];
			}

			vm.updateMap = function () {

				var mapOptions = [vm.pharm, vm.groc, vm.states];
				// console.log(mapOptions);

				vm.westwood = !vm.states;

				map.data.forEach(function (feature) {
					map.data.remove(feature);
				});

				initMap(mapOptions, zoomLevel);
			};

			vm.closeAbout = function () {
				$('.closeable-about').css('display', 'none');
			};

			setTimeout(function () {
				$('.gohome').click(function () {
					// console.log('go home!');
					vm.isSick = false;
					iframe.src = introSurveyUrl + '?unique=' + Math.floor(Math.random() * 10000);
				});
			}, 500);

			vm.signin = function (username, password) {
				if (!username || !password) return;

				User.login({ username: username, password: password }).then(function (res) {
					console.log(res.data);
					var user = res.data.user;

					$state.go('survey', { user: user });
				}).catch(function (err) {
					switch (err.status) {
						case 406:
							vm.showBadPass = true;
							break;
						case 409:
							vm.showBadLogin = true;
							break;
						default:
							console.log(err);
							return;
					}
				});
			};
		}]
	});
})();
//# sourceMappingURL=app.js.map
